import type * as Types from '@marketmuse/config/types/papi';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const AppDataParamsFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AppDataParamsFields on AppDataParams {
    bodyOrArticle
    brands
    country
    language
    people
    topic
    url
  }
`;
export const AppRunsFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AppRunsFields on AppRuns {
    current
    error
    extra
    lastReset
    limit
    nextReset
    resetInterval
  }
`;
export const GetAppDataResponseFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment GetAppDataResponseFields on GetAppDataResponse {
    compareKgsNews
    keywords
    kg
    kgNews
    lr
    qts
    scores
    scoresNews
  }
`;
export const AppQueryFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment AppQueryFieldsBase on AppQuery {
    app
    connectCompetitorDomains
    connectNetworkDomains
    country
    createdAt
    id
    jsonMetadata
    language
    status
    topic
    updatedAt
    url
  }
`;
export const SiteFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment SiteFieldsBase on Site {
    cancelled
    domain
    id
    level
    title
    visible
  }
`;
export const UserFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment UserFieldsBase on User {
    id
    email
    fullName
    createdAt
    updatedAt
  }
`;
export const AppQueryFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AppQueryFields on AppQuery {
    ...AppQueryFieldsBase
    site {
      ...SiteFieldsBase
    }
    user {
      ...UserFieldsBase
    }
  }
  ${AppQueryFieldsBaseFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
`;
export const OrganizationFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment OrganizationFieldsBase on Organization {
    id
    name
    slug
    clientTier
  }
`;
export const DocumentFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentFieldsBase on Document {
    assigneeTo {
      ...UserFieldsBase
    }
    createdAt
    createdBy {
      ...UserFieldsBase
    }
    id
    inputData {
      terms
      urls
      domain
      location
    }
    org {
      ...OrganizationFieldsBase
    }
    site {
      ...SiteFieldsBase
    }
    status
    subtype
    tags {
      id
      title
    }
    title
    type
    updatedAt
    updatedBy {
      ...UserFieldsBase
    }
  }
  ${UserFieldsBaseFragmentDoc}
  ${OrganizationFieldsBaseFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
`;
export const DocumentFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentFields on Document {
    ...DocumentFieldsBase
    steps
    prioritization
    scope
  }
  ${DocumentFieldsBaseFragmentDoc}
`;
export const DocumentStorageDataFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentStorageData on Document {
    id
    inputData {
      terms
      urls
      domain
      location
    }
    org {
      id
    }
    site {
      competitorDomains
      defaultSerpCountry
      domain
      id
      networkDomains
    }
    content
    subtype
    title
    additionalData {
      ... on DocumentAnalysisData {
        clusters {
          contentGroups {
            name
            personas
          }
          terms
          theme
        }
        clustersWithThemes {
          terms
          theme
        }
        processingTime
      }
      ... on DocumentBriefData {
        processingTime
      }
      ... on DocumentContentPlanData {
        theme
        opportunitiesOptimize {
          term
          url
        }
        opportunitiesCreate {
          documentSubtype
          focusTerm
          funnelStage
          idea
          overview
          pointsToCover
          relatedTerms
          title
        }
        processingTime
        recommendedBriefs {
          countCreate
          countOptimize
        }
      }
    }
  }
`;
export const InventoryItemFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment InventoryItemFieldsBase on InventoryItem {
    key
    type
    page {
      id
      url
    }
    pageTopic {
      id
      pageId
      topicId
    }
    topic {
      id
      term
    }
  }
`;
export const InventoryPageFragmentDoc = /*#__PURE__*/ gql`
  fragment InventoryPage on Page {
    authority
    avgMmCompetitiveAdvantage
    avgMmDifficulty
    avgMmPersonalizedAdvantage
    avgPersonalizedMmDifficulty
    createdAt
    externalContentLinkCount
    externalContentLinks
    hiddenByCs
    hiddenByUser
    id
    internalContentLinkCount
    internalContentLinks
    maxRank
    minRank
    numTopics
    potentialTraffic
    potentialTrafficUpside
    potentialTrafficValue
    source
    sumVolume
    title
    traffic
    trafficDelta
    trafficDeltaPct
    trafficValue
    trafficValueDelta
    updatedAt
    url
    urlHash
    versionTrafficPct
    versionTrafficValuePct
  }
`;
export const InventoryPageTopicFragmentDoc = /*#__PURE__*/ gql`
  fragment InventoryPageTopic on PageTopic {
    hiddenByCs
    hiddenByUser
    id
    pageId
    potentialTraffic
    potentialTrafficUpside
    potentialTrafficValue
    prePriority
    rank
    rankDelta
    rankDeltaPotential
    topicId
    traffic
    trafficDelta
    trafficDeltaPct
    trafficValue
    trafficValueDelta
    trafficValueDeltaPct
    versionId
    versionTrafficPct
    versionTrafficValuePct
  }
`;
export const InventoryTopicFragmentDoc = /*#__PURE__*/ gql`
  fragment InventoryTopic on Topic {
    avgPageAuthority
    competition
    difficulty
    hiddenByCs
    hiddenByUser
    id
    maxRank
    mmDifficulty
    mmPersonalizedAdvantage
    mmPersonalizedDifficulty
    monthlyTrends
    numPages
    potentialTraffic
    potentialTrafficUpside
    potentialTrafficValue
    serpFeatures
    serpFeaturesSet
    serpFeaturesTrafficShare
    source
    sumExternalContentLinks
    sumInternalContentLinks
    term
    topRankingPage
    traffic
    trafficDelta
    trafficDeltaPct
    trafficValue
    trafficValueDelta
    trafficValueDeltaPct
    versionTrafficPct
    versionTrafficValuePct
    volume
  }
`;
export const InventoryVersionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment InventoryVersionFields on InventoryVersion {
    id
    name
    visible
    status
    statusUpdatedAt
    traffic
    trafficDelta
    trafficDeltaPct
    trafficValue
    trafficValueDelta
    trafficValueDeltaPct
    failed
  }
`;
export const DocumentsAllotmentFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentsAllotmentFields on DocumentsAllotment {
    analysisPlanning {
      created
      total
    }
    briefs {
      created
      total
    }
    resetDate {
      last
      next
    }
  }
`;
export const OrganizationFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment OrganizationFields on Organization {
    address
    createdAt
    clientTier
    id
    name
    phone
    primaryContact {
      ...UserFieldsBase
    }
    recurlyAccountCode
    recurlyAccountCodeTest
    sfdcAccountId
    slug
    updatedAt
    topicsMax
    topicsAllocated
  }
  ${UserFieldsBaseFragmentDoc}
`;
export const PermissionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment PermissionFields on Permission {
    action
    resource
    status
  }
`;
export const RecurlyAccountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyAccountFields on Account {
    billTo
    ccEmails
    code
    id
    company
    firstName
    email
    lastName
    createdAt
    deletedAt
    dunningCampaignId
    exemptionCertificate
    hasActiveSubscription
    hasCanceledSubscription
    hasFutureSubscription
    hasLiveSubscription
    hasPastDueInvoice
    hasPausedSubscription
    object
    parentAccountId
    preferredLocale
    state
    taxExempt
    updatedAt
    username
    vatNumber
  }
`;
export const RecurlyPlanMiniFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyPlanMiniFields on PlanMini {
    code
    id
    name
    object
  }
`;
export const RecurlyCouponFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyCouponFields on Coupon {
    appliesToAllItems
    appliesToAllPlans
    appliesToNonPlanCharges
    code
    couponType
    createdAt
    discount {
      currencies {
        amount
        currency
      }
      percent
      trial {
        length
        unit
      }
      type
    }
    duration
    expiredAt
    hostedPageDescription
    id
    invoiceDescription
    items {
      code
      description
      id
      name
      object
      state
    }
    maxRedemptions
    maxRedemptionsPerAccount
    name
    object
    plans {
      ...RecurlyPlanMiniFields
    }
    redeemBy
    redemptionResource
    state
    temporalAmount
    temporalUnit
    uniqueCodeTemplate
    uniqueCouponCode
    uniqueCouponCodesCount
    updatedAt
  }
  ${RecurlyPlanMiniFieldsFragmentDoc}
`;
export const RecurlyCouponDiscountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyCouponDiscountFields on CouponDiscount {
    currencies {
      amount
      currency
    }
    percent
    trial {
      length
      unit
    }
    type
  }
`;
export const RecurlyCouponMiniFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyCouponMiniFields on CouponMini {
    code
    couponType
    discount {
      ...RecurlyCouponDiscountFields
    }
    expiredAt
    id
    name
    object
    state
  }
  ${RecurlyCouponDiscountFieldsFragmentDoc}
`;
export const RecurlyCouponRedemptionsFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyCouponRedemptionsFields on CouponRedemptionMini {
    coupon {
      ...RecurlyCouponMiniFields
    }
    createdAt
    discounted
    id
    object
    state
  }
  ${RecurlyCouponMiniFieldsFragmentDoc}
`;
export const RecurlySubscriptionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlySubscriptionFields on RecurlySubscription {
    activatedAt
    addOnsTotal
    autoRenew
    bankAccountAuthorizedAt
    billingInfoId
    canceledAt
    collectionMethod
    createdAt
    currency
    currentPeriodEndsAt
    currentPeriodStartedAt
    currentTermEndsAt
    currentTermStartedAt
    customerNotes
    customFields {
      name
      value
    }
    expirationReason
    expiresAt
    gatewayCode
    id
    netTerms
    object
    pausedAt
    poNumber
    quantity
    remainingBillingCycles
    remainingPauseCycles
    renewalBillingCycles
    revenueScheduleType
    state
    subtotal
    tax
    termsAndConditions
    total
    totalBillingCycles
    trialEndsAt
    trialStartedAt
    unitAmount
    updatedAt
    uuid
    plan {
      code
      id
      name
      object
    }
  }
`;
export const RecurlySubscriptionAddOnFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlySubscriptionAddOnFields on RecurlySubscriptionAddon {
    addOn {
      accountingCode
      addOnType
      code
      externalSku
      id
      itemId
      measuredUnitId
      name
      object
      usagePercentage
      usageType
    }
    addOnSource
    createdAt
    expiredAt
    id
    object
    quantity
    revenueScheduleType
    subscriptionId
    tierType
    tiers {
      endingQuantity
      unitAmount
      unitAmountDecimal
      usagePercentage
    }
    unitAmount
    unitAmountDecimal
    updatedAt
    usagePercentage
  }
`;
export const RecurlyAccountMiniFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyAccountMiniFields on AccountMini {
    billTo
    code
    company
    email
    firstName
    id
    lastName
  }
`;
export const RecurlyInvoiceMiniFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyInvoiceMiniFields on InvoiceMini {
    id
    number
    state
    type
  }
`;
export const RecurlyTransactionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyTransactionFields on Transaction {
    account {
      billTo
      code
      company
      dunningCampaignId
      email
      firstName
      id
      lastName
      parentAccountId
    }
    amount
    avsCheck
    backupPaymentMethodUsed
    billingAddress {
      city
      country
      firstName
      lastName
      phone
      postalCode
      region
      street1
      street2
    }
    collectedAt
    collectionMethod
    createdAt
    currency
    customerMessage
    customerMessageLocale
    cvvCheck
    gatewayApprovalCode
    gatewayMessage
    gatewayReference
    gatewayResponseCode
    gatewayResponseTime
    gatewayResponseValues
    id
    invoice {
      id
      number
      state
      type
    }
    ipAddressCountry
    ipAddressV4
    object
    origin
    originalTransactionId
    paymentGateway {
      id
      name
      type
    }
    paymentMethod {
      accountType
      billingAgreementId
      cardType
      ccBinCountry
      expMonth
      expYear
      firstSix
      gatewayCode
      gatewayToken
      lastFour
      lastTwo
      nameOnAccount
      routingNumber
      routingNumberBank
    }
    refunded
    status
    statusCode
    statusMessage
    subscriptionIds
    success
    type
    updatedAt
    uuid
    voidedAt
    voidedByInvoice {
      id
      number
      state
      type
    }
  }
`;
export const RecurlyShippingAddressFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyShippingAddressFields on ShippingAddress {
    accountId
    city
    company
    country
    createdAt
    email
    firstName
    id
    lastName
    nickname
    object
    phone
    postalCode
    region
    street1
    street2
    updatedAt
    vatNumber
  }
`;
export const RecurlyTaxInfoFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyTaxInfoFields on TaxInfo {
    rate
    region
    taxDetails {
      rate
      region
      tax
      type
    }
    type
  }
`;
export const RecurlyInvoiceFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyInvoiceFields on Invoice {
    account {
      billTo
      code
      company
      dunningCampaignId
      email
      firstName
      id
      lastName
      parentAccountId
    }
    address {
      city
      company
      country
      firstName
      lastName
      nameOnAccount
      phone
      postalCode
      region
      street1
      street2
    }
    balance
    billingInfoId
    closedAt
    collectionMethod
    createdAt
    creditPayments {
      account {
        ...RecurlyAccountMiniFields
      }
      action
      amount
      appliedToInvoice {
        ...RecurlyInvoiceMiniFields
      }
      createdAt
      currency
      id
      object
      originalCreditPaymentId
      originalInvoice {
        ...RecurlyInvoiceMiniFields
      }
      refundTransaction {
        ...RecurlyTransactionFields
      }
      updatedAt
      uuid
      voidedAt
    }
    currency
    customerNotes
    discount
    dueAt
    dunningCampaignId
    hasMoreLineItems
    id
    lineItems {
      account {
        ...RecurlyAccountMiniFields
      }
      accountingCode
      addOnCode
      addOnId
      amount
      avalaraServiceType
      avalaraTransactionType
      billForAccountId
      createdAt
      creditApplied
      creditReasonCode
      currency
      description
      discount
      endDate
      externalSku
      id
      invoiceId
      invoiceNumber
      itemCode
      itemId
      legacyCategory
      object
      origin
      originalLineItemInvoiceId
      planCode
      planId
      previousLineItemId
      productCode
      prorationRate
      quantity
      refund
      refundedQuantity
      revenueScheduleType
      shippingAddress {
        ...RecurlyShippingAddressFields
      }
      startDate
      state
      subscriptionId
      subtotal
      tax
      taxCode
      taxExempt
      taxInfo {
        ...RecurlyTaxInfoFields
      }
      taxable
      type
      unitAmount
      unitAmountDecimal
      updatedAt
      uuid
    }
    netTerms
    number
    object
    origin
    paid
    poNumber
    previousInvoiceId
    refundableAmount
    shippingAddress {
      ...RecurlyShippingAddressFields
    }
    state
    subscriptionIds
    subtotal
    tax
    taxInfo {
      ...RecurlyTaxInfoFields
    }
    termsAndConditions
    total
    transactions {
      ...RecurlyTransactionFields
    }
    type
    updatedAt
    vatNumber
    vatReverseChargeNotes
  }
  ${RecurlyAccountMiniFieldsFragmentDoc}
  ${RecurlyInvoiceMiniFieldsFragmentDoc}
  ${RecurlyTransactionFieldsFragmentDoc}
  ${RecurlyShippingAddressFieldsFragmentDoc}
  ${RecurlyTaxInfoFieldsFragmentDoc}
`;
export const RecurlyInvoiceCollectionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyInvoiceCollectionFields on InvoiceCollection {
    chargeInvoice {
      ...RecurlyInvoiceFields
    }
    creditInvoices {
      ...RecurlyInvoiceFields
    }
    object
  }
  ${RecurlyInvoiceFieldsFragmentDoc}
`;
export const RecurlySubscriptionShippingFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlySubscriptionShippingFields on SubscriptionShipping {
    address {
      accountId
      city
      company
      country
      createdAt
      email
      firstName
      id
      lastName
      nickname
      object
      phone
      postalCode
      region
      street1
      street2
      updatedAt
      vatNumber
    }
    amount
    method {
      code
      id
      name
      object
    }
    object
  }
`;
export const RecurlySubscriptionChangeFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlySubscriptionChangeFields on SubscriptionChange {
    activateAt
    activated
    addOns {
      ...RecurlySubscriptionAddOnFields
    }
    billingInfo {
      threeDSecureActionResultTokenId
    }
    createdAt
    customFields {
      name
      value
    }
    deletedAt
    id
    invoiceCollection {
      ...RecurlyInvoiceCollectionFields
    }
    object
    plan {
      ...RecurlyPlanMiniFields
    }
    quantity
    revenueScheduleType
    shipping {
      ...RecurlySubscriptionShippingFields
    }
    subscriptionId
    taxInclusive
    unitAmount
    updatedAt
  }
  ${RecurlySubscriptionAddOnFieldsFragmentDoc}
  ${RecurlyInvoiceCollectionFieldsFragmentDoc}
  ${RecurlyPlanMiniFieldsFragmentDoc}
  ${RecurlySubscriptionShippingFieldsFragmentDoc}
`;
export const RecurlyShippingAddressFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyShippingAddress on ShippingAddress {
    city
    country
    firstName
    lastName
    postalCode
    region
    street1
    street2
  }
`;
export const RecurlyAddressFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyAddressFields on Address {
    city
    country
    postalCode
    region
    street1
    street2
  }
`;
export const RecurlyPaymentMethodFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyPaymentMethodFields on PaymentMethod {
    cardType
    expMonth
    expYear
    firstSix
    gatewayCode
    gatewayToken
    lastFour
    lastTwo
    nameOnAccount
    routingNumber
    routingNumberBank
  }
`;
export const RecurlyBillingInfoFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurlyBillingInfoFields on BillingInfo {
    accountId
    id
    company
    firstName
    lastName
    address {
      ...RecurlyAddressFields
    }
    backupPaymentMethod
    primaryPaymentMethod
    object
    valid
    vatNumber
    updatedAt
    createdAt
    paymentMethod {
      ...RecurlyPaymentMethodFields
    }
  }
  ${RecurlyAddressFieldsFragmentDoc}
  ${RecurlyPaymentMethodFieldsFragmentDoc}
`;
export const HistoryFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment HistoryFields on History {
    yearMonth
    volume
  }
`;
export const AdWordsItemFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AdWordsItemFields on AdWordsItem {
    term
    costPerClick
    volume
    existsInInventory @client
    history {
      ...HistoryFields
    }
  }
  ${HistoryFieldsFragmentDoc}
`;
export const KgItemFragmentDoc = /*#__PURE__*/ gql`
  fragment KGItem on KnowledgeGraphItem {
    recommendedMentions
    existsInInventory @client
    relevanceScore
    term
    userProvidedPageMentions
  }
`;
export const OrganicSerpItemPageKgDataFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment OrganicSerpItemPageKgDataFields on OrganicSerpItemPageKgData {
    contentScore
    mentions {
      term
      count
    }
    position
    url
  }
`;
export const SavedViewFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SavedViewFields on SavedView {
    createdAt
    updatedAt
    id
    title
    description
    inventoryType
    filters
    pinned
    hidden
    order
    sorting
    sharing
  }
`;
export const ShareFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareFieldsBase on Share {
    id
    entityType
    accessLevel
    recipient {
      id
      email
    }
  }
`;
export const SiteFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SiteFields on Site {
    cancelled
    displayContentData
    domain
    id
    invId
    level
    title
    visible
  }
`;
export const DocumentBriefUserInputFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentBriefUserInputFields on DocumentBriefUserInput {
    buyerOrInformationJourney
    contextLinguistic
    expertise
    factStatements
    intentAnalysis
    marketingAndMessagingReferences
    personalExperience
    personalizationDetail
    pointOfView
    proofStatements
    structuring
    style
    targetMarket
    tone
    voice
  }
`;
export const SiteFieldsAllFragmentDoc = /*#__PURE__*/ gql`
  fragment SiteFieldsAll on Site {
    appRuns
    appRunsExtra
    appRunsLastReset
    appRunsLimit
    appRunsResetInterval
    appSumoCodes
    cancelled
    competitorDomains
    createdAt
    defaultSerpCountry
    displayContentData
    documentMeta {
      documentBriefUserInput {
        ...DocumentBriefUserInputFields
      }
      minimumSearchVolume
    }
    domain
    id
    invId
    level
    networkDomains
    title
    topicsAllocated
    updatedAt
    visible
  }
  ${DocumentBriefUserInputFieldsFragmentDoc}
`;
export const SiteInventoryDataFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SiteInventoryDataFields on Site {
    valuePerVisit
    subdomains
    excludePaths
    includePaths
    autoUpdate
    recommendedTopics
    topicsAllocated
    topicsInUse
    versions {
      id
      name
      visible
      failed
      status
      statusUpdatedAt
    }
  }
`;
export const SubscriptionPlanFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionPlanFields on SubscriptionPlan {
    active
    appQueryCount
    analysisAndPlanningDocumentAllocationLimit
    briefDocumentAllocationLimit
    id
    planCode
    price
    term
    termLength
    type
    userCanDowngradePackage
    userCanUpgradePackage
    usersArePurchasable
    usersCountDefault
  }
`;
export const SubscriptionAddonTypeFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionAddonTypeFields on SubscriptionAddonType {
    id
    description
    price
    type
    validFromDate
    validUntilDate
  }
`;
export const SubscriptionAddonsFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionAddons on SubscriptionAddon {
    addonState
    addonType {
      ...SubscriptionAddonTypeFields
    }
    id
    mode
    site {
      ...SiteFieldsBase
    }
  }
  ${SubscriptionAddonTypeFieldsFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
`;
export const SubscriptionEntityFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionEntityFields on SubscriptionEntity {
    createdAt
    dunning
    endsOnDate
    id
    externalSubscriptionId
    conversionMethod
    startedOnDate
    state
    subscriptionPlan {
      ...SubscriptionPlanFields
    }
    org {
      ...OrganizationFieldsBase
    }
    site {
      ...SiteFieldsBase
    }
    addons {
      ...SubscriptionAddons
    }
    addonsPrices {
      addonType
      price
    }
    discount
    price
    demo
  }
  ${SubscriptionPlanFieldsFragmentDoc}
  ${OrganizationFieldsBaseFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
  ${SubscriptionAddonsFragmentDoc}
`;
export const TagFieldsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment TagFieldsBase on Tag {
    createdAt
    updatedAt
    id
    title
  }
`;
export const TagFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment TagFields on Tag {
    createdAt
    updatedAt
    id
    title
    terms
    urls
    urlTerms {
      url
      term
    }
    documents {
      id
    }
    createdBy {
      ...UserFieldsBase
    }
    updatedBy {
      ...UserFieldsBase
    }
    site {
      ...SiteFieldsBase
    }
  }
  ${UserFieldsBaseFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
`;
export const UserFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserFields on User {
    createdAt
    defaultApplicationSerpCountry
    displayExactDistribution
    email
    firstName
    fullName
    id
    lastName
    onboardingProgress
    onboardingStep
    orgRole
    phone
    suspended
    sfdcContactId
    updatedAt
  }
`;
export const AddFromResearchDocument = /*#__PURE__*/ gql`
  mutation AddFromResearch(
    $tagInput: TagUpdateInput!
    $tagId: String!
    $items: [InventoryItemsAddInput!]!
    $siteId: String!
  ) {
    tagCreateOrUpdate(tagId: $tagId, siteId: $siteId, tagInput: $tagInput) {
      createdAt
      updatedAt
      id
      title
      terms
    }
    inventoryItemsAdd(items: $items, siteId: $siteId) {
      status
    }
  }
`;
export type AddFromResearchMutationFn = Apollo.MutationFunction<
  Types.AddFromResearchMutation,
  Types.AddFromResearchMutationVariables
>;

/**
 * __useAddFromResearchMutation__
 *
 * To run a mutation, you first call `useAddFromResearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFromResearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFromResearchMutation, { data, loading, error }] = useAddFromResearchMutation({
 *   variables: {
 *      tagInput: // value for 'tagInput'
 *      tagId: // value for 'tagId'
 *      items: // value for 'items'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useAddFromResearchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AddFromResearchMutation,
    Types.AddFromResearchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AddFromResearchMutation,
    Types.AddFromResearchMutationVariables
  >(AddFromResearchDocument, options);
}
export type AddFromResearchMutationHookResult = ReturnType<
  typeof useAddFromResearchMutation
>;
export type AddFromResearchMutationResult =
  Apollo.MutationResult<Types.AddFromResearchMutation>;
export type AddFromResearchMutationOptions = Apollo.BaseMutationOptions<
  Types.AddFromResearchMutation,
  Types.AddFromResearchMutationVariables
>;
export const AddMemberDocument = /*#__PURE__*/ gql`
  mutation AddMember($fields: UserCreateInput!, $orgId: String!) {
    addMember(fields: $fields, orgId: $orgId) {
      ...UserFields
      org {
        ...OrganizationFields
        sites {
          ...SiteFieldsAll
        }
        users {
          ...UserFields
        }
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${OrganizationFieldsFragmentDoc}
  ${SiteFieldsAllFragmentDoc}
`;
export type AddMemberMutationFn = Apollo.MutationFunction<
  Types.AddMemberMutation,
  Types.AddMemberMutationVariables
>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAddMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AddMemberMutation,
    Types.AddMemberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AddMemberMutation,
    Types.AddMemberMutationVariables
  >(AddMemberDocument, options);
}
export type AddMemberMutationHookResult = ReturnType<
  typeof useAddMemberMutation
>;
export type AddMemberMutationResult =
  Apollo.MutationResult<Types.AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<
  Types.AddMemberMutation,
  Types.AddMemberMutationVariables
>;
export const AdminPermissionsUpdateDocument = /*#__PURE__*/ gql`
  mutation AdminPermissionsUpdate(
    $entityId: String!
    $scope: PermissionScope!
    $permissions: [PermissionItemInput!]!
  ) {
    permissionsWrite(
      entityId: $entityId
      scope: $scope
      permissions: $permissions
    ) {
      message
      status
    }
  }
`;
export type AdminPermissionsUpdateMutationFn = Apollo.MutationFunction<
  Types.AdminPermissionsUpdateMutation,
  Types.AdminPermissionsUpdateMutationVariables
>;

/**
 * __useAdminPermissionsUpdateMutation__
 *
 * To run a mutation, you first call `useAdminPermissionsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPermissionsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPermissionsUpdateMutation, { data, loading, error }] = useAdminPermissionsUpdateMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      scope: // value for 'scope'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAdminPermissionsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AdminPermissionsUpdateMutation,
    Types.AdminPermissionsUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AdminPermissionsUpdateMutation,
    Types.AdminPermissionsUpdateMutationVariables
  >(AdminPermissionsUpdateDocument, options);
}
export type AdminPermissionsUpdateMutationHookResult = ReturnType<
  typeof useAdminPermissionsUpdateMutation
>;
export type AdminPermissionsUpdateMutationResult =
  Apollo.MutationResult<Types.AdminPermissionsUpdateMutation>;
export type AdminPermissionsUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.AdminPermissionsUpdateMutation,
  Types.AdminPermissionsUpdateMutationVariables
>;
export const AdminSubscriptionAddonCreateDocument = /*#__PURE__*/ gql`
  mutation AdminSubscriptionAddonCreate(
    $subscriptionId: String!
    $addonInput: AdminAddonInput!
    $coupon: String
    $count: Int
  ) {
    adminSubscriptionAddonCreate(
      subscriptionId: $subscriptionId
      addonInput: $addonInput
      coupon: $coupon
      count: $count
    ) {
      id
    }
  }
`;
export type AdminSubscriptionAddonCreateMutationFn = Apollo.MutationFunction<
  Types.AdminSubscriptionAddonCreateMutation,
  Types.AdminSubscriptionAddonCreateMutationVariables
>;

/**
 * __useAdminSubscriptionAddonCreateMutation__
 *
 * To run a mutation, you first call `useAdminSubscriptionAddonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSubscriptionAddonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSubscriptionAddonCreateMutation, { data, loading, error }] = useAdminSubscriptionAddonCreateMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      addonInput: // value for 'addonInput'
 *      coupon: // value for 'coupon'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useAdminSubscriptionAddonCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AdminSubscriptionAddonCreateMutation,
    Types.AdminSubscriptionAddonCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AdminSubscriptionAddonCreateMutation,
    Types.AdminSubscriptionAddonCreateMutationVariables
  >(AdminSubscriptionAddonCreateDocument, options);
}
export type AdminSubscriptionAddonCreateMutationHookResult = ReturnType<
  typeof useAdminSubscriptionAddonCreateMutation
>;
export type AdminSubscriptionAddonCreateMutationResult =
  Apollo.MutationResult<Types.AdminSubscriptionAddonCreateMutation>;
export type AdminSubscriptionAddonCreateMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AdminSubscriptionAddonCreateMutation,
    Types.AdminSubscriptionAddonCreateMutationVariables
  >;
export const AdminSubscriptionAddonPriceSetDocument = /*#__PURE__*/ gql`
  mutation AdminSubscriptionAddonPriceSet(
    $subscriptionId: String!
    $subscriptionAddonPrices: [SubscriptionAddonPriceInput!]!
  ) {
    subscriptionAddonPriceSet(
      subscriptionId: $subscriptionId
      subscriptionAddonPrices: $subscriptionAddonPrices
    ) {
      addonType
      price
    }
  }
`;
export type AdminSubscriptionAddonPriceSetMutationFn = Apollo.MutationFunction<
  Types.AdminSubscriptionAddonPriceSetMutation,
  Types.AdminSubscriptionAddonPriceSetMutationVariables
>;

/**
 * __useAdminSubscriptionAddonPriceSetMutation__
 *
 * To run a mutation, you first call `useAdminSubscriptionAddonPriceSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSubscriptionAddonPriceSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSubscriptionAddonPriceSetMutation, { data, loading, error }] = useAdminSubscriptionAddonPriceSetMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      subscriptionAddonPrices: // value for 'subscriptionAddonPrices'
 *   },
 * });
 */
export function useAdminSubscriptionAddonPriceSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AdminSubscriptionAddonPriceSetMutation,
    Types.AdminSubscriptionAddonPriceSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AdminSubscriptionAddonPriceSetMutation,
    Types.AdminSubscriptionAddonPriceSetMutationVariables
  >(AdminSubscriptionAddonPriceSetDocument, options);
}
export type AdminSubscriptionAddonPriceSetMutationHookResult = ReturnType<
  typeof useAdminSubscriptionAddonPriceSetMutation
>;
export type AdminSubscriptionAddonPriceSetMutationResult =
  Apollo.MutationResult<Types.AdminSubscriptionAddonPriceSetMutation>;
export type AdminSubscriptionAddonPriceSetMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AdminSubscriptionAddonPriceSetMutation,
    Types.AdminSubscriptionAddonPriceSetMutationVariables
  >;
export const AdminSubscriptionCreateDocument = /*#__PURE__*/ gql`
  mutation AdminSubscriptionCreate(
    $subscriptionInput: SubscriptionCreateInput!
  ) {
    adminSubscriptionCreate(subscriptionInput: $subscriptionInput) {
      ...SubscriptionEntityFields
    }
  }
  ${SubscriptionEntityFieldsFragmentDoc}
`;
export type AdminSubscriptionCreateMutationFn = Apollo.MutationFunction<
  Types.AdminSubscriptionCreateMutation,
  Types.AdminSubscriptionCreateMutationVariables
>;

/**
 * __useAdminSubscriptionCreateMutation__
 *
 * To run a mutation, you first call `useAdminSubscriptionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSubscriptionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSubscriptionCreateMutation, { data, loading, error }] = useAdminSubscriptionCreateMutation({
 *   variables: {
 *      subscriptionInput: // value for 'subscriptionInput'
 *   },
 * });
 */
export function useAdminSubscriptionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AdminSubscriptionCreateMutation,
    Types.AdminSubscriptionCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AdminSubscriptionCreateMutation,
    Types.AdminSubscriptionCreateMutationVariables
  >(AdminSubscriptionCreateDocument, options);
}
export type AdminSubscriptionCreateMutationHookResult = ReturnType<
  typeof useAdminSubscriptionCreateMutation
>;
export type AdminSubscriptionCreateMutationResult =
  Apollo.MutationResult<Types.AdminSubscriptionCreateMutation>;
export type AdminSubscriptionCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.AdminSubscriptionCreateMutation,
  Types.AdminSubscriptionCreateMutationVariables
>;
export const AdminSubscriptionUpdateDocument = /*#__PURE__*/ gql`
  mutation AdminSubscriptionUpdate(
    $coupon: String
    $subscriptionId: String!
    $subscriptionInput: SubscriptionUpdateInput!
  ) {
    adminSubscriptionUpdate(
      coupon: $coupon
      subscriptionId: $subscriptionId
      subscriptionInput: $subscriptionInput
    ) {
      ...SubscriptionEntityFields
    }
  }
  ${SubscriptionEntityFieldsFragmentDoc}
`;
export type AdminSubscriptionUpdateMutationFn = Apollo.MutationFunction<
  Types.AdminSubscriptionUpdateMutation,
  Types.AdminSubscriptionUpdateMutationVariables
>;

/**
 * __useAdminSubscriptionUpdateMutation__
 *
 * To run a mutation, you first call `useAdminSubscriptionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSubscriptionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSubscriptionUpdateMutation, { data, loading, error }] = useAdminSubscriptionUpdateMutation({
 *   variables: {
 *      coupon: // value for 'coupon'
 *      subscriptionId: // value for 'subscriptionId'
 *      subscriptionInput: // value for 'subscriptionInput'
 *   },
 * });
 */
export function useAdminSubscriptionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AdminSubscriptionUpdateMutation,
    Types.AdminSubscriptionUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AdminSubscriptionUpdateMutation,
    Types.AdminSubscriptionUpdateMutationVariables
  >(AdminSubscriptionUpdateDocument, options);
}
export type AdminSubscriptionUpdateMutationHookResult = ReturnType<
  typeof useAdminSubscriptionUpdateMutation
>;
export type AdminSubscriptionUpdateMutationResult =
  Apollo.MutationResult<Types.AdminSubscriptionUpdateMutation>;
export type AdminSubscriptionUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.AdminSubscriptionUpdateMutation,
  Types.AdminSubscriptionUpdateMutationVariables
>;
export const AppQueryCreateOrUpdateDocument = /*#__PURE__*/ gql`
  mutation AppQueryCreateOrUpdate(
    $siteId: String!
    $app: App!
    $connectCompetitorDomains: [Domain!]
    $connectNetworkDomains: [Domain!]
    $country: Country!
    $language: Language!
    $term: String!
    $url: URL
  ) {
    appQueryCreateOrUpdate(
      siteId: $siteId
      appQueryInput: {
        app: $app
        connectCompetitorDomains: $connectCompetitorDomains
        connectNetworkDomains: $connectNetworkDomains
        country: $country
        language: $language
        topic: $term
        url: $url
      }
    ) {
      ...AppQueryFields
    }
  }
  ${AppQueryFieldsFragmentDoc}
`;
export type AppQueryCreateOrUpdateMutationFn = Apollo.MutationFunction<
  Types.AppQueryCreateOrUpdateMutation,
  Types.AppQueryCreateOrUpdateMutationVariables
>;

/**
 * __useAppQueryCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `useAppQueryCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppQueryCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appQueryCreateOrUpdateMutation, { data, loading, error }] = useAppQueryCreateOrUpdateMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      app: // value for 'app'
 *      connectCompetitorDomains: // value for 'connectCompetitorDomains'
 *      connectNetworkDomains: // value for 'connectNetworkDomains'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      term: // value for 'term'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useAppQueryCreateOrUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AppQueryCreateOrUpdateMutation,
    Types.AppQueryCreateOrUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AppQueryCreateOrUpdateMutation,
    Types.AppQueryCreateOrUpdateMutationVariables
  >(AppQueryCreateOrUpdateDocument, options);
}
export type AppQueryCreateOrUpdateMutationHookResult = ReturnType<
  typeof useAppQueryCreateOrUpdateMutation
>;
export type AppQueryCreateOrUpdateMutationResult =
  Apollo.MutationResult<Types.AppQueryCreateOrUpdateMutation>;
export type AppQueryCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.AppQueryCreateOrUpdateMutation,
  Types.AppQueryCreateOrUpdateMutationVariables
>;
export const AppQueryUpdateDocument = /*#__PURE__*/ gql`
  mutation AppQueryUpdate(
    $appQueryId: String!
    $status: AppQueryStatus
    $competitorDomains: [Domain!]
    $networkDomains: [Domain!]
  ) {
    appQueryUpdate(
      appQueryId: $appQueryId
      appQueryInput: {
        status: $status
        connectCompetitorDomains: $competitorDomains
        connectNetworkDomains: $networkDomains
      }
    ) {
      ...AppQueryFields
    }
  }
  ${AppQueryFieldsFragmentDoc}
`;
export type AppQueryUpdateMutationFn = Apollo.MutationFunction<
  Types.AppQueryUpdateMutation,
  Types.AppQueryUpdateMutationVariables
>;

/**
 * __useAppQueryUpdateMutation__
 *
 * To run a mutation, you first call `useAppQueryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppQueryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appQueryUpdateMutation, { data, loading, error }] = useAppQueryUpdateMutation({
 *   variables: {
 *      appQueryId: // value for 'appQueryId'
 *      status: // value for 'status'
 *      competitorDomains: // value for 'competitorDomains'
 *      networkDomains: // value for 'networkDomains'
 *   },
 * });
 */
export function useAppQueryUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AppQueryUpdateMutation,
    Types.AppQueryUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.AppQueryUpdateMutation,
    Types.AppQueryUpdateMutationVariables
  >(AppQueryUpdateDocument, options);
}
export type AppQueryUpdateMutationHookResult = ReturnType<
  typeof useAppQueryUpdateMutation
>;
export type AppQueryUpdateMutationResult =
  Apollo.MutationResult<Types.AppQueryUpdateMutation>;
export type AppQueryUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.AppQueryUpdateMutation,
  Types.AppQueryUpdateMutationVariables
>;
export const DocumentDeleteDocument = /*#__PURE__*/ gql`
  mutation DocumentDelete($id: String!) {
    documentDelete(documentId: $id) {
      message
      status
    }
  }
`;
export type DocumentDeleteMutationFn = Apollo.MutationFunction<
  Types.DocumentDeleteMutation,
  Types.DocumentDeleteMutationVariables
>;

/**
 * __useDocumentDeleteMutation__
 *
 * To run a mutation, you first call `useDocumentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentDeleteMutation, { data, loading, error }] = useDocumentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DocumentDeleteMutation,
    Types.DocumentDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DocumentDeleteMutation,
    Types.DocumentDeleteMutationVariables
  >(DocumentDeleteDocument, options);
}
export type DocumentDeleteMutationHookResult = ReturnType<
  typeof useDocumentDeleteMutation
>;
export type DocumentDeleteMutationResult =
  Apollo.MutationResult<Types.DocumentDeleteMutation>;
export type DocumentDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.DocumentDeleteMutation,
  Types.DocumentDeleteMutationVariables
>;
export const DocumentUpdateDocument = /*#__PURE__*/ gql`
  mutation DocumentUpdate($id: String!, $input: DocumentUpdateInput!) {
    documentUpdate(documentId: $id, documentUpdateInput: $input) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;
export type DocumentUpdateMutationFn = Apollo.MutationFunction<
  Types.DocumentUpdateMutation,
  Types.DocumentUpdateMutationVariables
>;

/**
 * __useDocumentUpdateMutation__
 *
 * To run a mutation, you first call `useDocumentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentUpdateMutation, { data, loading, error }] = useDocumentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DocumentUpdateMutation,
    Types.DocumentUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DocumentUpdateMutation,
    Types.DocumentUpdateMutationVariables
  >(DocumentUpdateDocument, options);
}
export type DocumentUpdateMutationHookResult = ReturnType<
  typeof useDocumentUpdateMutation
>;
export type DocumentUpdateMutationResult =
  Apollo.MutationResult<Types.DocumentUpdateMutation>;
export type DocumentUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.DocumentUpdateMutation,
  Types.DocumentUpdateMutationVariables
>;
export const DocumentUpdateClusterGenerationDocument = /*#__PURE__*/ gql`
  mutation DocumentUpdateClusterGeneration(
    $documentId: String!
    $terms: [String!]!
    $theme: String!
  ) {
    documentUpdateClusterGeneration(
      documentId: $documentId
      terms: $terms
      theme: $theme
    ) {
      id
      inputData {
        terms
        urls
        domain
        location
      }
      subtype
      title
      additionalData {
        ... on DocumentAnalysisData {
          clusters {
            contentGroups {
              name
              personas
            }
            terms
            theme
          }
          clustersWithThemes {
            terms
            theme
          }
          processingTime
        }
      }
    }
  }
`;
export type DocumentUpdateClusterGenerationMutationFn = Apollo.MutationFunction<
  Types.DocumentUpdateClusterGenerationMutation,
  Types.DocumentUpdateClusterGenerationMutationVariables
>;

/**
 * __useDocumentUpdateClusterGenerationMutation__
 *
 * To run a mutation, you first call `useDocumentUpdateClusterGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentUpdateClusterGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentUpdateClusterGenerationMutation, { data, loading, error }] = useDocumentUpdateClusterGenerationMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      terms: // value for 'terms'
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useDocumentUpdateClusterGenerationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DocumentUpdateClusterGenerationMutation,
    Types.DocumentUpdateClusterGenerationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DocumentUpdateClusterGenerationMutation,
    Types.DocumentUpdateClusterGenerationMutationVariables
  >(DocumentUpdateClusterGenerationDocument, options);
}
export type DocumentUpdateClusterGenerationMutationHookResult = ReturnType<
  typeof useDocumentUpdateClusterGenerationMutation
>;
export type DocumentUpdateClusterGenerationMutationResult =
  Apollo.MutationResult<Types.DocumentUpdateClusterGenerationMutation>;
export type DocumentUpdateClusterGenerationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DocumentUpdateClusterGenerationMutation,
    Types.DocumentUpdateClusterGenerationMutationVariables
  >;
export const DocumentsCreateDocument = /*#__PURE__*/ gql`
  mutation DocumentsCreate(
    $country: Country!
    $inputs: [DocumentCreateInput!]!
    $language: Language!
    $siteId: String!
    $orgId: String!
  ) {
    documentsCreate(
      documentCreateInputs: $inputs
      documentCountry: $country
      documentLanguage: $language
      orgId: $orgId
      siteId: $siteId
    ) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;
export type DocumentsCreateMutationFn = Apollo.MutationFunction<
  Types.DocumentsCreateMutation,
  Types.DocumentsCreateMutationVariables
>;

/**
 * __useDocumentsCreateMutation__
 *
 * To run a mutation, you first call `useDocumentsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentsCreateMutation, { data, loading, error }] = useDocumentsCreateMutation({
 *   variables: {
 *      country: // value for 'country'
 *      inputs: // value for 'inputs'
 *      language: // value for 'language'
 *      siteId: // value for 'siteId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDocumentsCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DocumentsCreateMutation,
    Types.DocumentsCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DocumentsCreateMutation,
    Types.DocumentsCreateMutationVariables
  >(DocumentsCreateDocument, options);
}
export type DocumentsCreateMutationHookResult = ReturnType<
  typeof useDocumentsCreateMutation
>;
export type DocumentsCreateMutationResult =
  Apollo.MutationResult<Types.DocumentsCreateMutation>;
export type DocumentsCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.DocumentsCreateMutation,
  Types.DocumentsCreateMutationVariables
>;
export const DocumentsCreateBriefsFromPlanDocument = /*#__PURE__*/ gql`
  mutation DocumentsCreateBriefsFromPlan(
    $inputs: [DocumentCreateBriefFromPlanInput!]!
    $orgId: String!
    $siteId: String!
  ) {
    documentsCreateBriefsFromPlan(
      documentsCreateBriefsFromPlanInputs: $inputs
      orgId: $orgId
      siteId: $siteId
    ) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;
export type DocumentsCreateBriefsFromPlanMutationFn = Apollo.MutationFunction<
  Types.DocumentsCreateBriefsFromPlanMutation,
  Types.DocumentsCreateBriefsFromPlanMutationVariables
>;

/**
 * __useDocumentsCreateBriefsFromPlanMutation__
 *
 * To run a mutation, you first call `useDocumentsCreateBriefsFromPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentsCreateBriefsFromPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentsCreateBriefsFromPlanMutation, { data, loading, error }] = useDocumentsCreateBriefsFromPlanMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      orgId: // value for 'orgId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDocumentsCreateBriefsFromPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DocumentsCreateBriefsFromPlanMutation,
    Types.DocumentsCreateBriefsFromPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DocumentsCreateBriefsFromPlanMutation,
    Types.DocumentsCreateBriefsFromPlanMutationVariables
  >(DocumentsCreateBriefsFromPlanDocument, options);
}
export type DocumentsCreateBriefsFromPlanMutationHookResult = ReturnType<
  typeof useDocumentsCreateBriefsFromPlanMutation
>;
export type DocumentsCreateBriefsFromPlanMutationResult =
  Apollo.MutationResult<Types.DocumentsCreateBriefsFromPlanMutation>;
export type DocumentsCreateBriefsFromPlanMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DocumentsCreateBriefsFromPlanMutation,
    Types.DocumentsCreateBriefsFromPlanMutationVariables
  >;
export const DocumentsCreatePlansFromAnalysisDocument = /*#__PURE__*/ gql`
  mutation DocumentsCreatePlansFromAnalysis(
    $inputs: [DocumentCreatePlansFromAnalysisInput!]!
    $orgId: String!
    $siteId: String!
  ) {
    documentsCreatePlansFromAnalysis(
      documentsCreatePlansFromAnalysisInputs: $inputs
      orgId: $orgId
      siteId: $siteId
    ) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;
export type DocumentsCreatePlansFromAnalysisMutationFn =
  Apollo.MutationFunction<
    Types.DocumentsCreatePlansFromAnalysisMutation,
    Types.DocumentsCreatePlansFromAnalysisMutationVariables
  >;

/**
 * __useDocumentsCreatePlansFromAnalysisMutation__
 *
 * To run a mutation, you first call `useDocumentsCreatePlansFromAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentsCreatePlansFromAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentsCreatePlansFromAnalysisMutation, { data, loading, error }] = useDocumentsCreatePlansFromAnalysisMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      orgId: // value for 'orgId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDocumentsCreatePlansFromAnalysisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DocumentsCreatePlansFromAnalysisMutation,
    Types.DocumentsCreatePlansFromAnalysisMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DocumentsCreatePlansFromAnalysisMutation,
    Types.DocumentsCreatePlansFromAnalysisMutationVariables
  >(DocumentsCreatePlansFromAnalysisDocument, options);
}
export type DocumentsCreatePlansFromAnalysisMutationHookResult = ReturnType<
  typeof useDocumentsCreatePlansFromAnalysisMutation
>;
export type DocumentsCreatePlansFromAnalysisMutationResult =
  Apollo.MutationResult<Types.DocumentsCreatePlansFromAnalysisMutation>;
export type DocumentsCreatePlansFromAnalysisMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DocumentsCreatePlansFromAnalysisMutation,
    Types.DocumentsCreatePlansFromAnalysisMutationVariables
  >;
export const InquirePremiumDocument = /*#__PURE__*/ gql`
  mutation InquirePremium($planLevel: String!) {
    inquirePremium(planLevel: $planLevel) {
      status
    }
  }
`;
export type InquirePremiumMutationFn = Apollo.MutationFunction<
  Types.InquirePremiumMutation,
  Types.InquirePremiumMutationVariables
>;

/**
 * __useInquirePremiumMutation__
 *
 * To run a mutation, you first call `useInquirePremiumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInquirePremiumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inquirePremiumMutation, { data, loading, error }] = useInquirePremiumMutation({
 *   variables: {
 *      planLevel: // value for 'planLevel'
 *   },
 * });
 */
export function useInquirePremiumMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InquirePremiumMutation,
    Types.InquirePremiumMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InquirePremiumMutation,
    Types.InquirePremiumMutationVariables
  >(InquirePremiumDocument, options);
}
export type InquirePremiumMutationHookResult = ReturnType<
  typeof useInquirePremiumMutation
>;
export type InquirePremiumMutationResult =
  Apollo.MutationResult<Types.InquirePremiumMutation>;
export type InquirePremiumMutationOptions = Apollo.BaseMutationOptions<
  Types.InquirePremiumMutation,
  Types.InquirePremiumMutationVariables
>;
export const InventoryItemsAddDocument = /*#__PURE__*/ gql`
  mutation InventoryItemsAdd(
    $items: [InventoryItemsAddInput!]!
    $siteId: String!
  ) {
    inventoryItemsAdd(items: $items, siteId: $siteId) {
      status
    }
  }
`;
export type InventoryItemsAddMutationFn = Apollo.MutationFunction<
  Types.InventoryItemsAddMutation,
  Types.InventoryItemsAddMutationVariables
>;

/**
 * __useInventoryItemsAddMutation__
 *
 * To run a mutation, you first call `useInventoryItemsAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryItemsAddMutation, { data, loading, error }] = useInventoryItemsAddMutation({
 *   variables: {
 *      items: // value for 'items'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useInventoryItemsAddMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InventoryItemsAddMutation,
    Types.InventoryItemsAddMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InventoryItemsAddMutation,
    Types.InventoryItemsAddMutationVariables
  >(InventoryItemsAddDocument, options);
}
export type InventoryItemsAddMutationHookResult = ReturnType<
  typeof useInventoryItemsAddMutation
>;
export type InventoryItemsAddMutationResult =
  Apollo.MutationResult<Types.InventoryItemsAddMutation>;
export type InventoryItemsAddMutationOptions = Apollo.BaseMutationOptions<
  Types.InventoryItemsAddMutation,
  Types.InventoryItemsAddMutationVariables
>;
export const InventoryItemsAddWithTagsDocument = /*#__PURE__*/ gql`
  mutation InventoryItemsAddWithTags(
    $inventoryItems: [InventoryItemsAddInput!]!
    $siteId: String!
    $tagsInput: [TagsCreateOrUpdateInput!]!
    $upsertTags: Boolean!
  ) {
    inventoryItemsAdd(items: $inventoryItems, siteId: $siteId) {
      status
    }
    tagsCreateOrUpdate(siteId: $siteId, tagsInput: $tagsInput)
      @include(if: $upsertTags) {
      ...TagFields
    }
  }
  ${TagFieldsFragmentDoc}
`;
export type InventoryItemsAddWithTagsMutationFn = Apollo.MutationFunction<
  Types.InventoryItemsAddWithTagsMutation,
  Types.InventoryItemsAddWithTagsMutationVariables
>;

/**
 * __useInventoryItemsAddWithTagsMutation__
 *
 * To run a mutation, you first call `useInventoryItemsAddWithTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsAddWithTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryItemsAddWithTagsMutation, { data, loading, error }] = useInventoryItemsAddWithTagsMutation({
 *   variables: {
 *      inventoryItems: // value for 'inventoryItems'
 *      siteId: // value for 'siteId'
 *      tagsInput: // value for 'tagsInput'
 *      upsertTags: // value for 'upsertTags'
 *   },
 * });
 */
export function useInventoryItemsAddWithTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InventoryItemsAddWithTagsMutation,
    Types.InventoryItemsAddWithTagsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InventoryItemsAddWithTagsMutation,
    Types.InventoryItemsAddWithTagsMutationVariables
  >(InventoryItemsAddWithTagsDocument, options);
}
export type InventoryItemsAddWithTagsMutationHookResult = ReturnType<
  typeof useInventoryItemsAddWithTagsMutation
>;
export type InventoryItemsAddWithTagsMutationResult =
  Apollo.MutationResult<Types.InventoryItemsAddWithTagsMutation>;
export type InventoryItemsAddWithTagsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.InventoryItemsAddWithTagsMutation,
    Types.InventoryItemsAddWithTagsMutationVariables
  >;
export const InventoryItemsUpdateDocument = /*#__PURE__*/ gql`
  mutation InventoryItemsUpdate($items: InventoryItemsUpdateInput!) {
    inventoryItemsUpdate(items: $items)
  }
`;
export type InventoryItemsUpdateMutationFn = Apollo.MutationFunction<
  Types.InventoryItemsUpdateMutation,
  Types.InventoryItemsUpdateMutationVariables
>;

/**
 * __useInventoryItemsUpdateMutation__
 *
 * To run a mutation, you first call `useInventoryItemsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryItemsUpdateMutation, { data, loading, error }] = useInventoryItemsUpdateMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useInventoryItemsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InventoryItemsUpdateMutation,
    Types.InventoryItemsUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InventoryItemsUpdateMutation,
    Types.InventoryItemsUpdateMutationVariables
  >(InventoryItemsUpdateDocument, options);
}
export type InventoryItemsUpdateMutationHookResult = ReturnType<
  typeof useInventoryItemsUpdateMutation
>;
export type InventoryItemsUpdateMutationResult =
  Apollo.MutationResult<Types.InventoryItemsUpdateMutation>;
export type InventoryItemsUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.InventoryItemsUpdateMutation,
  Types.InventoryItemsUpdateMutationVariables
>;
export const OrganizationCreateDocument = /*#__PURE__*/ gql`
  mutation OrganizationCreate($organizationInput: OrganizationInput!) {
    organizationCreate(organizationInput: $organizationInput) {
      ...OrganizationFields
    }
  }
  ${OrganizationFieldsFragmentDoc}
`;
export type OrganizationCreateMutationFn = Apollo.MutationFunction<
  Types.OrganizationCreateMutation,
  Types.OrganizationCreateMutationVariables
>;

/**
 * __useOrganizationCreateMutation__
 *
 * To run a mutation, you first call `useOrganizationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationCreateMutation, { data, loading, error }] = useOrganizationCreateMutation({
 *   variables: {
 *      organizationInput: // value for 'organizationInput'
 *   },
 * });
 */
export function useOrganizationCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.OrganizationCreateMutation,
    Types.OrganizationCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.OrganizationCreateMutation,
    Types.OrganizationCreateMutationVariables
  >(OrganizationCreateDocument, options);
}
export type OrganizationCreateMutationHookResult = ReturnType<
  typeof useOrganizationCreateMutation
>;
export type OrganizationCreateMutationResult =
  Apollo.MutationResult<Types.OrganizationCreateMutation>;
export type OrganizationCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.OrganizationCreateMutation,
  Types.OrganizationCreateMutationVariables
>;
export const OrganizationUpdateDocument = /*#__PURE__*/ gql`
  mutation OrganizationUpdate(
    $organizationId: String!
    $organizationInput: OrganizationInput!
  ) {
    organizationUpdate(
      organizationId: $organizationId
      organizationInput: $organizationInput
    ) {
      ...OrganizationFields
    }
  }
  ${OrganizationFieldsFragmentDoc}
`;
export type OrganizationUpdateMutationFn = Apollo.MutationFunction<
  Types.OrganizationUpdateMutation,
  Types.OrganizationUpdateMutationVariables
>;

/**
 * __useOrganizationUpdateMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMutation, { data, loading, error }] = useOrganizationUpdateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationInput: // value for 'organizationInput'
 *   },
 * });
 */
export function useOrganizationUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.OrganizationUpdateMutation,
    Types.OrganizationUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.OrganizationUpdateMutation,
    Types.OrganizationUpdateMutationVariables
  >(OrganizationUpdateDocument, options);
}
export type OrganizationUpdateMutationHookResult = ReturnType<
  typeof useOrganizationUpdateMutation
>;
export type OrganizationUpdateMutationResult =
  Apollo.MutationResult<Types.OrganizationUpdateMutation>;
export type OrganizationUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.OrganizationUpdateMutation,
  Types.OrganizationUpdateMutationVariables
>;
export const RecurlyAccountCreateDocument = /*#__PURE__*/ gql`
  mutation RecurlyAccountCreate($email: String, $orgId: String) {
    recurlyCreateAccount(email: $email, orgId: $orgId) {
      code
      company
      id
    }
  }
`;
export type RecurlyAccountCreateMutationFn = Apollo.MutationFunction<
  Types.RecurlyAccountCreateMutation,
  Types.RecurlyAccountCreateMutationVariables
>;

/**
 * __useRecurlyAccountCreateMutation__
 *
 * To run a mutation, you first call `useRecurlyAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurlyAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurlyAccountCreateMutation, { data, loading, error }] = useRecurlyAccountCreateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useRecurlyAccountCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RecurlyAccountCreateMutation,
    Types.RecurlyAccountCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RecurlyAccountCreateMutation,
    Types.RecurlyAccountCreateMutationVariables
  >(RecurlyAccountCreateDocument, options);
}
export type RecurlyAccountCreateMutationHookResult = ReturnType<
  typeof useRecurlyAccountCreateMutation
>;
export type RecurlyAccountCreateMutationResult =
  Apollo.MutationResult<Types.RecurlyAccountCreateMutation>;
export type RecurlyAccountCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.RecurlyAccountCreateMutation,
  Types.RecurlyAccountCreateMutationVariables
>;
export const RecurlyUpsertBillingInfoDocument = /*#__PURE__*/ gql`
  mutation RecurlyUpsertBillingInfo(
    $accountCode: String
    $recurlyToken: String!
  ) {
    recurlyUpsertBillingInfo(
      accountCode: $accountCode
      recurlyToken: $recurlyToken
    ) {
      ...RecurlyAccountFields
      address {
        ...RecurlyAddressFields
      }
      billingInfo {
        ...RecurlyBillingInfoFields
      }
      shippingAddresses {
        ...RecurlyShippingAddress
      }
      customFields {
        name
        value
      }
    }
  }
  ${RecurlyAccountFieldsFragmentDoc}
  ${RecurlyAddressFieldsFragmentDoc}
  ${RecurlyBillingInfoFieldsFragmentDoc}
  ${RecurlyShippingAddressFragmentDoc}
`;
export type RecurlyUpsertBillingInfoMutationFn = Apollo.MutationFunction<
  Types.RecurlyUpsertBillingInfoMutation,
  Types.RecurlyUpsertBillingInfoMutationVariables
>;

/**
 * __useRecurlyUpsertBillingInfoMutation__
 *
 * To run a mutation, you first call `useRecurlyUpsertBillingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurlyUpsertBillingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurlyUpsertBillingInfoMutation, { data, loading, error }] = useRecurlyUpsertBillingInfoMutation({
 *   variables: {
 *      accountCode: // value for 'accountCode'
 *      recurlyToken: // value for 'recurlyToken'
 *   },
 * });
 */
export function useRecurlyUpsertBillingInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RecurlyUpsertBillingInfoMutation,
    Types.RecurlyUpsertBillingInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RecurlyUpsertBillingInfoMutation,
    Types.RecurlyUpsertBillingInfoMutationVariables
  >(RecurlyUpsertBillingInfoDocument, options);
}
export type RecurlyUpsertBillingInfoMutationHookResult = ReturnType<
  typeof useRecurlyUpsertBillingInfoMutation
>;
export type RecurlyUpsertBillingInfoMutationResult =
  Apollo.MutationResult<Types.RecurlyUpsertBillingInfoMutation>;
export type RecurlyUpsertBillingInfoMutationOptions =
  Apollo.BaseMutationOptions<
    Types.RecurlyUpsertBillingInfoMutation,
    Types.RecurlyUpsertBillingInfoMutationVariables
  >;
export const SavedViewCreateDocument = /*#__PURE__*/ gql`
  mutation SavedViewCreate($siteId: String!, $savedViewInput: SavedViewInput!) {
    savedViewCreate(siteId: $siteId, savedViewInput: $savedViewInput) {
      ...SavedViewFields
      createdBy {
        ...UserFieldsBase
      }
    }
  }
  ${SavedViewFieldsFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
`;
export type SavedViewCreateMutationFn = Apollo.MutationFunction<
  Types.SavedViewCreateMutation,
  Types.SavedViewCreateMutationVariables
>;

/**
 * __useSavedViewCreateMutation__
 *
 * To run a mutation, you first call `useSavedViewCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavedViewCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savedViewCreateMutation, { data, loading, error }] = useSavedViewCreateMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      savedViewInput: // value for 'savedViewInput'
 *   },
 * });
 */
export function useSavedViewCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SavedViewCreateMutation,
    Types.SavedViewCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SavedViewCreateMutation,
    Types.SavedViewCreateMutationVariables
  >(SavedViewCreateDocument, options);
}
export type SavedViewCreateMutationHookResult = ReturnType<
  typeof useSavedViewCreateMutation
>;
export type SavedViewCreateMutationResult =
  Apollo.MutationResult<Types.SavedViewCreateMutation>;
export type SavedViewCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.SavedViewCreateMutation,
  Types.SavedViewCreateMutationVariables
>;
export const SavedViewDeleteDocument = /*#__PURE__*/ gql`
  mutation SavedViewDelete($savedViewId: String!) {
    savedViewDelete(savedViewId: $savedViewId) {
      message
    }
  }
`;
export type SavedViewDeleteMutationFn = Apollo.MutationFunction<
  Types.SavedViewDeleteMutation,
  Types.SavedViewDeleteMutationVariables
>;

/**
 * __useSavedViewDeleteMutation__
 *
 * To run a mutation, you first call `useSavedViewDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavedViewDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savedViewDeleteMutation, { data, loading, error }] = useSavedViewDeleteMutation({
 *   variables: {
 *      savedViewId: // value for 'savedViewId'
 *   },
 * });
 */
export function useSavedViewDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SavedViewDeleteMutation,
    Types.SavedViewDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SavedViewDeleteMutation,
    Types.SavedViewDeleteMutationVariables
  >(SavedViewDeleteDocument, options);
}
export type SavedViewDeleteMutationHookResult = ReturnType<
  typeof useSavedViewDeleteMutation
>;
export type SavedViewDeleteMutationResult =
  Apollo.MutationResult<Types.SavedViewDeleteMutation>;
export type SavedViewDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.SavedViewDeleteMutation,
  Types.SavedViewDeleteMutationVariables
>;
export const SavedViewUpdateDocument = /*#__PURE__*/ gql`
  mutation SavedViewUpdate(
    $savedViewId: String!
    $savedViewInput: SavedViewInput!
  ) {
    savedViewUpdate(
      savedViewId: $savedViewId
      savedViewInput: $savedViewInput
    ) {
      ...SavedViewFields
      createdBy {
        ...UserFieldsBase
      }
    }
  }
  ${SavedViewFieldsFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
`;
export type SavedViewUpdateMutationFn = Apollo.MutationFunction<
  Types.SavedViewUpdateMutation,
  Types.SavedViewUpdateMutationVariables
>;

/**
 * __useSavedViewUpdateMutation__
 *
 * To run a mutation, you first call `useSavedViewUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavedViewUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savedViewUpdateMutation, { data, loading, error }] = useSavedViewUpdateMutation({
 *   variables: {
 *      savedViewId: // value for 'savedViewId'
 *      savedViewInput: // value for 'savedViewInput'
 *   },
 * });
 */
export function useSavedViewUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SavedViewUpdateMutation,
    Types.SavedViewUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SavedViewUpdateMutation,
    Types.SavedViewUpdateMutationVariables
  >(SavedViewUpdateDocument, options);
}
export type SavedViewUpdateMutationHookResult = ReturnType<
  typeof useSavedViewUpdateMutation
>;
export type SavedViewUpdateMutationResult =
  Apollo.MutationResult<Types.SavedViewUpdateMutation>;
export type SavedViewUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.SavedViewUpdateMutation,
  Types.SavedViewUpdateMutationVariables
>;
export const SetupAccountDocument = /*#__PURE__*/ gql`
  mutation SetupAccount(
    $email: String!
    $firstName: String!
    $lastName: String!
    $country: String!
    $company: String!
    $domain: Domain!
    $phone: String
    $utm: JSON!
    $onboardingStep: String
  ) {
    setupAccount(
      email: $email
      firstName: $firstName
      lastName: $lastName
      country: $country
      company: $company
      domain: $domain
      phone: $phone
      utm: $utm
      onboardingStep: $onboardingStep
    ) {
      user {
        ...UserFields
      }
      org {
        ...OrganizationFields
        sites {
          ...SiteFieldsAll
        }
        users {
          ...UserFieldsBase
          orgRole
          suspended
        }
        maxUsers
        documentAllotment {
          ...DocumentsAllotmentFields
        }
      }
      site {
        ...SiteFieldsAll
      }
      subscription {
        ...SubscriptionEntityFields
      }
      permissions {
        ...PermissionFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${OrganizationFieldsFragmentDoc}
  ${SiteFieldsAllFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
  ${DocumentsAllotmentFieldsFragmentDoc}
  ${SubscriptionEntityFieldsFragmentDoc}
  ${PermissionFieldsFragmentDoc}
`;
export type SetupAccountMutationFn = Apollo.MutationFunction<
  Types.SetupAccountMutation,
  Types.SetupAccountMutationVariables
>;

/**
 * __useSetupAccountMutation__
 *
 * To run a mutation, you first call `useSetupAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupAccountMutation, { data, loading, error }] = useSetupAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      country: // value for 'country'
 *      company: // value for 'company'
 *      domain: // value for 'domain'
 *      phone: // value for 'phone'
 *      utm: // value for 'utm'
 *      onboardingStep: // value for 'onboardingStep'
 *   },
 * });
 */
export function useSetupAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetupAccountMutation,
    Types.SetupAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SetupAccountMutation,
    Types.SetupAccountMutationVariables
  >(SetupAccountDocument, options);
}
export type SetupAccountMutationHookResult = ReturnType<
  typeof useSetupAccountMutation
>;
export type SetupAccountMutationResult =
  Apollo.MutationResult<Types.SetupAccountMutation>;
export type SetupAccountMutationOptions = Apollo.BaseMutationOptions<
  Types.SetupAccountMutation,
  Types.SetupAccountMutationVariables
>;
export const ShareEmailCaptureDocument = /*#__PURE__*/ gql`
  mutation ShareEmailCapture($shareId: String!, $email: Email!) {
    shareEmailCapture(
      shareEmailCaptureInput: { email: $email, shareId: $shareId }
    ) {
      message
      status
    }
  }
`;
export type ShareEmailCaptureMutationFn = Apollo.MutationFunction<
  Types.ShareEmailCaptureMutation,
  Types.ShareEmailCaptureMutationVariables
>;

/**
 * __useShareEmailCaptureMutation__
 *
 * To run a mutation, you first call `useShareEmailCaptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareEmailCaptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareEmailCaptureMutation, { data, loading, error }] = useShareEmailCaptureMutation({
 *   variables: {
 *      shareId: // value for 'shareId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useShareEmailCaptureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ShareEmailCaptureMutation,
    Types.ShareEmailCaptureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ShareEmailCaptureMutation,
    Types.ShareEmailCaptureMutationVariables
  >(ShareEmailCaptureDocument, options);
}
export type ShareEmailCaptureMutationHookResult = ReturnType<
  typeof useShareEmailCaptureMutation
>;
export type ShareEmailCaptureMutationResult =
  Apollo.MutationResult<Types.ShareEmailCaptureMutation>;
export type ShareEmailCaptureMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareEmailCaptureMutation,
  Types.ShareEmailCaptureMutationVariables
>;
export const SharesCreateDocument = /*#__PURE__*/ gql`
  mutation SharesCreate(
    $recipients: [ShareRecipient!]!
    $entityId: String!
    $entityType: ShareType!
  ) {
    sharesCreate(
      recipients: $recipients
      entityId: $entityId
      entityType: $entityType
    ) {
      id
      entityType
      node {
        ... on Document {
          id
        }
      }
      accessLevel
      recipient {
        id
        email
      }
      createdBy {
        id
        email
      }
      updatedBy {
        id
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export type SharesCreateMutationFn = Apollo.MutationFunction<
  Types.SharesCreateMutation,
  Types.SharesCreateMutationVariables
>;

/**
 * __useSharesCreateMutation__
 *
 * To run a mutation, you first call `useSharesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharesCreateMutation, { data, loading, error }] = useSharesCreateMutation({
 *   variables: {
 *      recipients: // value for 'recipients'
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useSharesCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SharesCreateMutation,
    Types.SharesCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SharesCreateMutation,
    Types.SharesCreateMutationVariables
  >(SharesCreateDocument, options);
}
export type SharesCreateMutationHookResult = ReturnType<
  typeof useSharesCreateMutation
>;
export type SharesCreateMutationResult =
  Apollo.MutationResult<Types.SharesCreateMutation>;
export type SharesCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.SharesCreateMutation,
  Types.SharesCreateMutationVariables
>;
export const InventoryUpdateDocument = /*#__PURE__*/ gql`
  mutation InventoryUpdate($siteId: String!, $siteInput: SiteInput!) {
    siteUpdate(siteId: $siteId, siteInput: $siteInput) {
      ...SiteFieldsAll
      ...SiteInventoryDataFields
      org {
        ...OrganizationFields
        users {
          ...UserFields
        }
      }
    }
  }
  ${SiteFieldsAllFragmentDoc}
  ${SiteInventoryDataFieldsFragmentDoc}
  ${OrganizationFieldsFragmentDoc}
  ${UserFieldsFragmentDoc}
`;
export type InventoryUpdateMutationFn = Apollo.MutationFunction<
  Types.InventoryUpdateMutation,
  Types.InventoryUpdateMutationVariables
>;

/**
 * __useInventoryUpdateMutation__
 *
 * To run a mutation, you first call `useInventoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryUpdateMutation, { data, loading, error }] = useInventoryUpdateMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      siteInput: // value for 'siteInput'
 *   },
 * });
 */
export function useInventoryUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InventoryUpdateMutation,
    Types.InventoryUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InventoryUpdateMutation,
    Types.InventoryUpdateMutationVariables
  >(InventoryUpdateDocument, options);
}
export type InventoryUpdateMutationHookResult = ReturnType<
  typeof useInventoryUpdateMutation
>;
export type InventoryUpdateMutationResult =
  Apollo.MutationResult<Types.InventoryUpdateMutation>;
export type InventoryUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.InventoryUpdateMutation,
  Types.InventoryUpdateMutationVariables
>;
export const InventoryCreateDocument = /*#__PURE__*/ gql`
  mutation InventoryCreate(
    $orgId: String!
    $siteInput: SiteInput!
    $options: SiteCreateOptions!
  ) {
    siteCreate(orgId: $orgId, siteInput: $siteInput, options: $options) {
      ...SiteFieldsAll
      ...SiteInventoryDataFields
    }
  }
  ${SiteFieldsAllFragmentDoc}
  ${SiteInventoryDataFieldsFragmentDoc}
`;
export type InventoryCreateMutationFn = Apollo.MutationFunction<
  Types.InventoryCreateMutation,
  Types.InventoryCreateMutationVariables
>;

/**
 * __useInventoryCreateMutation__
 *
 * To run a mutation, you first call `useInventoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryCreateMutation, { data, loading, error }] = useInventoryCreateMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      siteInput: // value for 'siteInput'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useInventoryCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InventoryCreateMutation,
    Types.InventoryCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InventoryCreateMutation,
    Types.InventoryCreateMutationVariables
  >(InventoryCreateDocument, options);
}
export type InventoryCreateMutationHookResult = ReturnType<
  typeof useInventoryCreateMutation
>;
export type InventoryCreateMutationResult =
  Apollo.MutationResult<Types.InventoryCreateMutation>;
export type InventoryCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.InventoryCreateMutation,
  Types.InventoryCreateMutationVariables
>;
export const InventoryDeleteDocument = /*#__PURE__*/ gql`
  mutation InventoryDelete($siteId: String!) {
    siteDelete(siteId: $siteId) {
      status
      message
    }
  }
`;
export type InventoryDeleteMutationFn = Apollo.MutationFunction<
  Types.InventoryDeleteMutation,
  Types.InventoryDeleteMutationVariables
>;

/**
 * __useInventoryDeleteMutation__
 *
 * To run a mutation, you first call `useInventoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryDeleteMutation, { data, loading, error }] = useInventoryDeleteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useInventoryDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InventoryDeleteMutation,
    Types.InventoryDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InventoryDeleteMutation,
    Types.InventoryDeleteMutationVariables
  >(InventoryDeleteDocument, options);
}
export type InventoryDeleteMutationHookResult = ReturnType<
  typeof useInventoryDeleteMutation
>;
export type InventoryDeleteMutationResult =
  Apollo.MutationResult<Types.InventoryDeleteMutation>;
export type InventoryDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.InventoryDeleteMutation,
  Types.InventoryDeleteMutationVariables
>;
export const SiteCreateGovernedInventoryDocument = /*#__PURE__*/ gql`
  mutation SiteCreateGovernedInventory(
    $orgId: String!
    $domain: String!
    $defaultSerpCountry: String!
  ) {
    siteCreateGovernedInventory(
      orgId: $orgId
      siteInput: { domain: $domain, defaultSerpCountry: $defaultSerpCountry }
    ) {
      ...SiteFieldsAll
    }
  }
  ${SiteFieldsAllFragmentDoc}
`;
export type SiteCreateGovernedInventoryMutationFn = Apollo.MutationFunction<
  Types.SiteCreateGovernedInventoryMutation,
  Types.SiteCreateGovernedInventoryMutationVariables
>;

/**
 * __useSiteCreateGovernedInventoryMutation__
 *
 * To run a mutation, you first call `useSiteCreateGovernedInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteCreateGovernedInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteCreateGovernedInventoryMutation, { data, loading, error }] = useSiteCreateGovernedInventoryMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      domain: // value for 'domain'
 *      defaultSerpCountry: // value for 'defaultSerpCountry'
 *   },
 * });
 */
export function useSiteCreateGovernedInventoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SiteCreateGovernedInventoryMutation,
    Types.SiteCreateGovernedInventoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SiteCreateGovernedInventoryMutation,
    Types.SiteCreateGovernedInventoryMutationVariables
  >(SiteCreateGovernedInventoryDocument, options);
}
export type SiteCreateGovernedInventoryMutationHookResult = ReturnType<
  typeof useSiteCreateGovernedInventoryMutation
>;
export type SiteCreateGovernedInventoryMutationResult =
  Apollo.MutationResult<Types.SiteCreateGovernedInventoryMutation>;
export type SiteCreateGovernedInventoryMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SiteCreateGovernedInventoryMutation,
    Types.SiteCreateGovernedInventoryMutationVariables
  >;
export const SiteInventoryTriggerVersionDocument = /*#__PURE__*/ gql`
  mutation SiteInventoryTriggerVersion($siteId: String!) {
    siteInventoryTriggerVersion(siteId: $siteId) {
      id
      name
    }
  }
`;
export type SiteInventoryTriggerVersionMutationFn = Apollo.MutationFunction<
  Types.SiteInventoryTriggerVersionMutation,
  Types.SiteInventoryTriggerVersionMutationVariables
>;

/**
 * __useSiteInventoryTriggerVersionMutation__
 *
 * To run a mutation, you first call `useSiteInventoryTriggerVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteInventoryTriggerVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteInventoryTriggerVersionMutation, { data, loading, error }] = useSiteInventoryTriggerVersionMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteInventoryTriggerVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SiteInventoryTriggerVersionMutation,
    Types.SiteInventoryTriggerVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SiteInventoryTriggerVersionMutation,
    Types.SiteInventoryTriggerVersionMutationVariables
  >(SiteInventoryTriggerVersionDocument, options);
}
export type SiteInventoryTriggerVersionMutationHookResult = ReturnType<
  typeof useSiteInventoryTriggerVersionMutation
>;
export type SiteInventoryTriggerVersionMutationResult =
  Apollo.MutationResult<Types.SiteInventoryTriggerVersionMutation>;
export type SiteInventoryTriggerVersionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SiteInventoryTriggerVersionMutation,
    Types.SiteInventoryTriggerVersionMutationVariables
  >;
export const SubscriptionAddonCancelDocument = /*#__PURE__*/ gql`
  mutation SubscriptionAddonCancel(
    $subscriptionId: String!
    $subscriptionAddonId: String!
  ) {
    subscriptionAddonCancel(
      subscriptionId: $subscriptionId
      subscriptionAddonId: $subscriptionAddonId
    ) {
      message
      status
    }
  }
`;
export type SubscriptionAddonCancelMutationFn = Apollo.MutationFunction<
  Types.SubscriptionAddonCancelMutation,
  Types.SubscriptionAddonCancelMutationVariables
>;

/**
 * __useSubscriptionAddonCancelMutation__
 *
 * To run a mutation, you first call `useSubscriptionAddonCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAddonCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionAddonCancelMutation, { data, loading, error }] = useSubscriptionAddonCancelMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      subscriptionAddonId: // value for 'subscriptionAddonId'
 *   },
 * });
 */
export function useSubscriptionAddonCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SubscriptionAddonCancelMutation,
    Types.SubscriptionAddonCancelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SubscriptionAddonCancelMutation,
    Types.SubscriptionAddonCancelMutationVariables
  >(SubscriptionAddonCancelDocument, options);
}
export type SubscriptionAddonCancelMutationHookResult = ReturnType<
  typeof useSubscriptionAddonCancelMutation
>;
export type SubscriptionAddonCancelMutationResult =
  Apollo.MutationResult<Types.SubscriptionAddonCancelMutation>;
export type SubscriptionAddonCancelMutationOptions = Apollo.BaseMutationOptions<
  Types.SubscriptionAddonCancelMutation,
  Types.SubscriptionAddonCancelMutationVariables
>;
export const SubscriptionAddonCreateDocument = /*#__PURE__*/ gql`
  mutation SubscriptionAddonCreate(
    $subscriptionId: String!
    $addonTypeId: String!
    $siteId: String
  ) {
    subscriptionAddonCreate(
      subscriptionId: $subscriptionId
      addonTypeId: $addonTypeId
      siteId: $siteId
    ) {
      id
      subscription {
        ...SubscriptionEntityFields
      }
      addonType {
        ...SubscriptionAddonTypeFields
      }
      site {
        ...SiteFieldsAll
      }
    }
  }
  ${SubscriptionEntityFieldsFragmentDoc}
  ${SubscriptionAddonTypeFieldsFragmentDoc}
  ${SiteFieldsAllFragmentDoc}
`;
export type SubscriptionAddonCreateMutationFn = Apollo.MutationFunction<
  Types.SubscriptionAddonCreateMutation,
  Types.SubscriptionAddonCreateMutationVariables
>;

/**
 * __useSubscriptionAddonCreateMutation__
 *
 * To run a mutation, you first call `useSubscriptionAddonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAddonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionAddonCreateMutation, { data, loading, error }] = useSubscriptionAddonCreateMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      addonTypeId: // value for 'addonTypeId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSubscriptionAddonCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SubscriptionAddonCreateMutation,
    Types.SubscriptionAddonCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SubscriptionAddonCreateMutation,
    Types.SubscriptionAddonCreateMutationVariables
  >(SubscriptionAddonCreateDocument, options);
}
export type SubscriptionAddonCreateMutationHookResult = ReturnType<
  typeof useSubscriptionAddonCreateMutation
>;
export type SubscriptionAddonCreateMutationResult =
  Apollo.MutationResult<Types.SubscriptionAddonCreateMutation>;
export type SubscriptionAddonCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.SubscriptionAddonCreateMutation,
  Types.SubscriptionAddonCreateMutationVariables
>;
export const SubscriptionUpdateDocument = /*#__PURE__*/ gql`
  mutation SubscriptionUpdate(
    $subscriptionId: String!
    $subscriptionPlanId: String!
    $coupon: String
  ) {
    subscriptionUpdate(
      subscriptionId: $subscriptionId
      subscriptionPlanId: $subscriptionPlanId
      coupon: $coupon
    ) {
      org {
        ...OrganizationFields
        sites {
          ...SiteFieldsAll
        }
        users {
          ...UserFieldsBase
          orgRole
          suspended
        }
        maxUsers
        documentAllotment {
          ...DocumentsAllotmentFields
        }
      }
      permissions {
        ...PermissionFields
      }
      subscription {
        ...SubscriptionEntityFields
      }
    }
  }
  ${OrganizationFieldsFragmentDoc}
  ${SiteFieldsAllFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
  ${DocumentsAllotmentFieldsFragmentDoc}
  ${PermissionFieldsFragmentDoc}
  ${SubscriptionEntityFieldsFragmentDoc}
`;
export type SubscriptionUpdateMutationFn = Apollo.MutationFunction<
  Types.SubscriptionUpdateMutation,
  Types.SubscriptionUpdateMutationVariables
>;

/**
 * __useSubscriptionUpdateMutation__
 *
 * To run a mutation, you first call `useSubscriptionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionUpdateMutation, { data, loading, error }] = useSubscriptionUpdateMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      subscriptionPlanId: // value for 'subscriptionPlanId'
 *      coupon: // value for 'coupon'
 *   },
 * });
 */
export function useSubscriptionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SubscriptionUpdateMutation,
    Types.SubscriptionUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SubscriptionUpdateMutation,
    Types.SubscriptionUpdateMutationVariables
  >(SubscriptionUpdateDocument, options);
}
export type SubscriptionUpdateMutationHookResult = ReturnType<
  typeof useSubscriptionUpdateMutation
>;
export type SubscriptionUpdateMutationResult =
  Apollo.MutationResult<Types.SubscriptionUpdateMutation>;
export type SubscriptionUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.SubscriptionUpdateMutation,
  Types.SubscriptionUpdateMutationVariables
>;
export const TagCreateOrUpdateDocument = /*#__PURE__*/ gql`
  mutation TagCreateOrUpdate(
    $tagId: String!
    $siteId: String!
    $tagInput: TagUpdateInput!
  ) {
    tagCreateOrUpdate(tagId: $tagId, siteId: $siteId, tagInput: $tagInput) {
      ...TagFields
    }
  }
  ${TagFieldsFragmentDoc}
`;
export type TagCreateOrUpdateMutationFn = Apollo.MutationFunction<
  Types.TagCreateOrUpdateMutation,
  Types.TagCreateOrUpdateMutationVariables
>;

/**
 * __useTagCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `useTagCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagCreateOrUpdateMutation, { data, loading, error }] = useTagCreateOrUpdateMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      siteId: // value for 'siteId'
 *      tagInput: // value for 'tagInput'
 *   },
 * });
 */
export function useTagCreateOrUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.TagCreateOrUpdateMutation,
    Types.TagCreateOrUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.TagCreateOrUpdateMutation,
    Types.TagCreateOrUpdateMutationVariables
  >(TagCreateOrUpdateDocument, options);
}
export type TagCreateOrUpdateMutationHookResult = ReturnType<
  typeof useTagCreateOrUpdateMutation
>;
export type TagCreateOrUpdateMutationResult =
  Apollo.MutationResult<Types.TagCreateOrUpdateMutation>;
export type TagCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.TagCreateOrUpdateMutation,
  Types.TagCreateOrUpdateMutationVariables
>;
export const TagDeleteDocument = /*#__PURE__*/ gql`
  mutation TagDelete($tagId: String!) {
    tagDelete(tagId: $tagId) {
      message
    }
  }
`;
export type TagDeleteMutationFn = Apollo.MutationFunction<
  Types.TagDeleteMutation,
  Types.TagDeleteMutationVariables
>;

/**
 * __useTagDeleteMutation__
 *
 * To run a mutation, you first call `useTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDeleteMutation, { data, loading, error }] = useTagDeleteMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useTagDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.TagDeleteMutation,
    Types.TagDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.TagDeleteMutation,
    Types.TagDeleteMutationVariables
  >(TagDeleteDocument, options);
}
export type TagDeleteMutationHookResult = ReturnType<
  typeof useTagDeleteMutation
>;
export type TagDeleteMutationResult =
  Apollo.MutationResult<Types.TagDeleteMutation>;
export type TagDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.TagDeleteMutation,
  Types.TagDeleteMutationVariables
>;
export const UserDeleteDocument = /*#__PURE__*/ gql`
  mutation UserDelete($userId: String!) {
    userDelete(userId: $userId) {
      message
      status
    }
  }
`;
export type UserDeleteMutationFn = Apollo.MutationFunction<
  Types.UserDeleteMutation,
  Types.UserDeleteMutationVariables
>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UserDeleteMutation,
    Types.UserDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UserDeleteMutation,
    Types.UserDeleteMutationVariables
  >(UserDeleteDocument, options);
}
export type UserDeleteMutationHookResult = ReturnType<
  typeof useUserDeleteMutation
>;
export type UserDeleteMutationResult =
  Apollo.MutationResult<Types.UserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.UserDeleteMutation,
  Types.UserDeleteMutationVariables
>;
export const UserUpdateDocument = /*#__PURE__*/ gql`
  mutation UserUpdate($userId: String!, $userInput: UserUpdateInput!) {
    userUpdate(userId: $userId, userInput: $userInput) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type UserUpdateMutationFn = Apollo.MutationFunction<
  Types.UserUpdateMutation,
  Types.UserUpdateMutationVariables
>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUserUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UserUpdateMutation,
    Types.UserUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UserUpdateMutation,
    Types.UserUpdateMutationVariables
  >(UserUpdateDocument, options);
}
export type UserUpdateMutationHookResult = ReturnType<
  typeof useUserUpdateMutation
>;
export type UserUpdateMutationResult =
  Apollo.MutationResult<Types.UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.UserUpdateMutation,
  Types.UserUpdateMutationVariables
>;
export const SeoWebsiteHeatmapDocument = /*#__PURE__*/ gql`
  query SeoWebsiteHeatmap(
    $term: String!
    $kgTerms: [String!]!
    $includePath: URL!
    $excludePaths: [URL!]
  ) {
    seoWebsiteHeatmap(
      term: $term
      kgTerms: $kgTerms
      includePath: $includePath
      excludePaths: $excludePaths
    ) {
      title
      position
      url
      wordCount
      contentScore
      mentions {
        term
        count
      }
    }
  }
`;

/**
 * __useSeoWebsiteHeatmapQuery__
 *
 * To run a query within a React component, call `useSeoWebsiteHeatmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoWebsiteHeatmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoWebsiteHeatmapQuery({
 *   variables: {
 *      term: // value for 'term'
 *      kgTerms: // value for 'kgTerms'
 *      includePath: // value for 'includePath'
 *      excludePaths: // value for 'excludePaths'
 *   },
 * });
 */
export function useSeoWebsiteHeatmapQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoWebsiteHeatmapQuery,
    Types.SeoWebsiteHeatmapQueryVariables
  > &
    (
      | { variables: Types.SeoWebsiteHeatmapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoWebsiteHeatmapQuery,
    Types.SeoWebsiteHeatmapQueryVariables
  >(SeoWebsiteHeatmapDocument, options);
}
export function useSeoWebsiteHeatmapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoWebsiteHeatmapQuery,
    Types.SeoWebsiteHeatmapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoWebsiteHeatmapQuery,
    Types.SeoWebsiteHeatmapQueryVariables
  >(SeoWebsiteHeatmapDocument, options);
}
export function useSeoWebsiteHeatmapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoWebsiteHeatmapQuery,
    Types.SeoWebsiteHeatmapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoWebsiteHeatmapQuery,
    Types.SeoWebsiteHeatmapQueryVariables
  >(SeoWebsiteHeatmapDocument, options);
}
export type SeoWebsiteHeatmapQueryHookResult = ReturnType<
  typeof useSeoWebsiteHeatmapQuery
>;
export type SeoWebsiteHeatmapLazyQueryHookResult = ReturnType<
  typeof useSeoWebsiteHeatmapLazyQuery
>;
export type SeoWebsiteHeatmapSuspenseQueryHookResult = ReturnType<
  typeof useSeoWebsiteHeatmapSuspenseQuery
>;
export type SeoWebsiteHeatmapQueryResult = Apollo.QueryResult<
  Types.SeoWebsiteHeatmapQuery,
  Types.SeoWebsiteHeatmapQueryVariables
>;
export const AppQueriesDocument = /*#__PURE__*/ gql`
  query AppQueries(
    $filters: [AppQueryFilter!]
    $limit: Int
    $order: String
    $page: Int
  ) {
    appQueries(filters: $filters, order: $order, limit: $limit, page: $page) {
      count
      items {
        ...AppQueryFields
      }
    }
  }
  ${AppQueryFieldsFragmentDoc}
`;

/**
 * __useAppQueriesQuery__
 *
 * To run a query within a React component, call `useAppQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppQueriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAppQueriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AppQueriesQuery,
    Types.AppQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.AppQueriesQuery, Types.AppQueriesQueryVariables>(
    AppQueriesDocument,
    options,
  );
}
export function useAppQueriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AppQueriesQuery,
    Types.AppQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AppQueriesQuery,
    Types.AppQueriesQueryVariables
  >(AppQueriesDocument, options);
}
export function useAppQueriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.AppQueriesQuery,
    Types.AppQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.AppQueriesQuery,
    Types.AppQueriesQueryVariables
  >(AppQueriesDocument, options);
}
export type AppQueriesQueryHookResult = ReturnType<typeof useAppQueriesQuery>;
export type AppQueriesLazyQueryHookResult = ReturnType<
  typeof useAppQueriesLazyQuery
>;
export type AppQueriesSuspenseQueryHookResult = ReturnType<
  typeof useAppQueriesSuspenseQuery
>;
export type AppQueriesQueryResult = Apollo.QueryResult<
  Types.AppQueriesQuery,
  Types.AppQueriesQueryVariables
>;
export const DocumentDocument = /*#__PURE__*/ gql`
  query Document($documentId: String!) {
    document(documentId: $documentId) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DocumentQuery,
    Types.DocumentQueryVariables
  > &
    (
      | { variables: Types.DocumentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.DocumentQuery, Types.DocumentQueryVariables>(
    DocumentDocument,
    options,
  );
}
export function useDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DocumentQuery,
    Types.DocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.DocumentQuery, Types.DocumentQueryVariables>(
    DocumentDocument,
    options,
  );
}
export function useDocumentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.DocumentQuery,
    Types.DocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.DocumentQuery,
    Types.DocumentQueryVariables
  >(DocumentDocument, options);
}
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<
  typeof useDocumentLazyQuery
>;
export type DocumentSuspenseQueryHookResult = ReturnType<
  typeof useDocumentSuspenseQuery
>;
export type DocumentQueryResult = Apollo.QueryResult<
  Types.DocumentQuery,
  Types.DocumentQueryVariables
>;
export const DocumentStorageDataDocument = /*#__PURE__*/ gql`
  query DocumentStorageData($documentId: String!) {
    document(documentId: $documentId) {
      ...DocumentStorageData
    }
  }
  ${DocumentStorageDataFragmentDoc}
`;

/**
 * __useDocumentStorageDataQuery__
 *
 * To run a query within a React component, call `useDocumentStorageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentStorageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentStorageDataQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentStorageDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DocumentStorageDataQuery,
    Types.DocumentStorageDataQueryVariables
  > &
    (
      | { variables: Types.DocumentStorageDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.DocumentStorageDataQuery,
    Types.DocumentStorageDataQueryVariables
  >(DocumentStorageDataDocument, options);
}
export function useDocumentStorageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DocumentStorageDataQuery,
    Types.DocumentStorageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.DocumentStorageDataQuery,
    Types.DocumentStorageDataQueryVariables
  >(DocumentStorageDataDocument, options);
}
export function useDocumentStorageDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.DocumentStorageDataQuery,
    Types.DocumentStorageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.DocumentStorageDataQuery,
    Types.DocumentStorageDataQueryVariables
  >(DocumentStorageDataDocument, options);
}
export type DocumentStorageDataQueryHookResult = ReturnType<
  typeof useDocumentStorageDataQuery
>;
export type DocumentStorageDataLazyQueryHookResult = ReturnType<
  typeof useDocumentStorageDataLazyQuery
>;
export type DocumentStorageDataSuspenseQueryHookResult = ReturnType<
  typeof useDocumentStorageDataSuspenseQuery
>;
export type DocumentStorageDataQueryResult = Apollo.QueryResult<
  Types.DocumentStorageDataQuery,
  Types.DocumentStorageDataQueryVariables
>;
export const DocumentsDocument = /*#__PURE__*/ gql`
  query Documents(
    $filters: [DocumentFilter!]
    $limit: Int
    $sort: [SortField!]
    $page: Int
  ) {
    documents(filters: $filters, sort: $sort, limit: $limit, page: $page) {
      count
      items {
        ...DocumentFieldsBase
      }
    }
  }
  ${DocumentFieldsBaseFragmentDoc}
`;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DocumentsQuery,
    Types.DocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.DocumentsQuery, Types.DocumentsQueryVariables>(
    DocumentsDocument,
    options,
  );
}
export function useDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DocumentsQuery,
    Types.DocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.DocumentsQuery,
    Types.DocumentsQueryVariables
  >(DocumentsDocument, options);
}
export function useDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.DocumentsQuery,
    Types.DocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.DocumentsQuery,
    Types.DocumentsQueryVariables
  >(DocumentsDocument, options);
}
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<
  typeof useDocumentsLazyQuery
>;
export type DocumentsSuspenseQueryHookResult = ReturnType<
  typeof useDocumentsSuspenseQuery
>;
export type DocumentsQueryResult = Apollo.QueryResult<
  Types.DocumentsQuery,
  Types.DocumentsQueryVariables
>;
export const DocumentsCreateEstimateDocument = /*#__PURE__*/ gql`
  query DocumentsCreateEstimate(
    $inputs: [DocumentsCreateEstimateInput!]!
    $orgId: String!
    $siteId: String!
  ) {
    documentsCreateEstimate(
      documentCreateEstimate: $inputs
      orgId: $orgId
      siteId: $siteId
    ) {
      documentType
      documentSubtype
      status
    }
  }
`;

/**
 * __useDocumentsCreateEstimateQuery__
 *
 * To run a query within a React component, call `useDocumentsCreateEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsCreateEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsCreateEstimateQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      orgId: // value for 'orgId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDocumentsCreateEstimateQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DocumentsCreateEstimateQuery,
    Types.DocumentsCreateEstimateQueryVariables
  > &
    (
      | {
          variables: Types.DocumentsCreateEstimateQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.DocumentsCreateEstimateQuery,
    Types.DocumentsCreateEstimateQueryVariables
  >(DocumentsCreateEstimateDocument, options);
}
export function useDocumentsCreateEstimateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DocumentsCreateEstimateQuery,
    Types.DocumentsCreateEstimateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.DocumentsCreateEstimateQuery,
    Types.DocumentsCreateEstimateQueryVariables
  >(DocumentsCreateEstimateDocument, options);
}
export function useDocumentsCreateEstimateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.DocumentsCreateEstimateQuery,
    Types.DocumentsCreateEstimateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.DocumentsCreateEstimateQuery,
    Types.DocumentsCreateEstimateQueryVariables
  >(DocumentsCreateEstimateDocument, options);
}
export type DocumentsCreateEstimateQueryHookResult = ReturnType<
  typeof useDocumentsCreateEstimateQuery
>;
export type DocumentsCreateEstimateLazyQueryHookResult = ReturnType<
  typeof useDocumentsCreateEstimateLazyQuery
>;
export type DocumentsCreateEstimateSuspenseQueryHookResult = ReturnType<
  typeof useDocumentsCreateEstimateSuspenseQuery
>;
export type DocumentsCreateEstimateQueryResult = Apollo.QueryResult<
  Types.DocumentsCreateEstimateQuery,
  Types.DocumentsCreateEstimateQueryVariables
>;
export const GetExcelDocument = /*#__PURE__*/ gql`
  query GetExcel(
    $context: ExcelGenerationContext!
    $data: ExcelGenerationData!
    $fn: ExcelGenerationFunctions!
  ) {
    getExcel(context: $context, data: $data, fn: $fn) {
      data
      format
    }
  }
`;

/**
 * __useGetExcelQuery__
 *
 * To run a query within a React component, call `useGetExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExcelQuery({
 *   variables: {
 *      context: // value for 'context'
 *      data: // value for 'data'
 *      fn: // value for 'fn'
 *   },
 * });
 */
export function useGetExcelQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetExcelQuery,
    Types.GetExcelQueryVariables
  > &
    (
      | { variables: Types.GetExcelQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetExcelQuery, Types.GetExcelQueryVariables>(
    GetExcelDocument,
    options,
  );
}
export function useGetExcelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetExcelQuery,
    Types.GetExcelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetExcelQuery, Types.GetExcelQueryVariables>(
    GetExcelDocument,
    options,
  );
}
export function useGetExcelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetExcelQuery,
    Types.GetExcelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetExcelQuery,
    Types.GetExcelQueryVariables
  >(GetExcelDocument, options);
}
export type GetExcelQueryHookResult = ReturnType<typeof useGetExcelQuery>;
export type GetExcelLazyQueryHookResult = ReturnType<
  typeof useGetExcelLazyQuery
>;
export type GetExcelSuspenseQueryHookResult = ReturnType<
  typeof useGetExcelSuspenseQuery
>;
export type GetExcelQueryResult = Apollo.QueryResult<
  Types.GetExcelQuery,
  Types.GetExcelQueryVariables
>;
export const ExportConnectDocument = /*#__PURE__*/ gql`
  query ExportConnect(
    $generationContext: GenerationContextInput!
    $seoConnectData: SEOConnectInput!
  ) {
    exportConnect(
      generationContext: $generationContext
      seoConnectData: $seoConnectData
    ) {
      data
      format
    }
  }
`;

/**
 * __useExportConnectQuery__
 *
 * To run a query within a React component, call `useExportConnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportConnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportConnectQuery({
 *   variables: {
 *      generationContext: // value for 'generationContext'
 *      seoConnectData: // value for 'seoConnectData'
 *   },
 * });
 */
export function useExportConnectQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExportConnectQuery,
    Types.ExportConnectQueryVariables
  > &
    (
      | { variables: Types.ExportConnectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExportConnectQuery,
    Types.ExportConnectQueryVariables
  >(ExportConnectDocument, options);
}
export function useExportConnectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExportConnectQuery,
    Types.ExportConnectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExportConnectQuery,
    Types.ExportConnectQueryVariables
  >(ExportConnectDocument, options);
}
export function useExportConnectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ExportConnectQuery,
    Types.ExportConnectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ExportConnectQuery,
    Types.ExportConnectQueryVariables
  >(ExportConnectDocument, options);
}
export type ExportConnectQueryHookResult = ReturnType<
  typeof useExportConnectQuery
>;
export type ExportConnectLazyQueryHookResult = ReturnType<
  typeof useExportConnectLazyQuery
>;
export type ExportConnectSuspenseQueryHookResult = ReturnType<
  typeof useExportConnectSuspenseQuery
>;
export type ExportConnectQueryResult = Apollo.QueryResult<
  Types.ExportConnectQuery,
  Types.ExportConnectQueryVariables
>;
export const ExportDocumentsDocument = /*#__PURE__*/ gql`
  query ExportDocuments($documentIds: [String!]!) {
    exportDocuments(documentIds: $documentIds) {
      data
      format
    }
  }
`;

/**
 * __useExportDocumentsQuery__
 *
 * To run a query within a React component, call `useExportDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDocumentsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useExportDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExportDocumentsQuery,
    Types.ExportDocumentsQueryVariables
  > &
    (
      | { variables: Types.ExportDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExportDocumentsQuery,
    Types.ExportDocumentsQueryVariables
  >(ExportDocumentsDocument, options);
}
export function useExportDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExportDocumentsQuery,
    Types.ExportDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExportDocumentsQuery,
    Types.ExportDocumentsQueryVariables
  >(ExportDocumentsDocument, options);
}
export function useExportDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ExportDocumentsQuery,
    Types.ExportDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ExportDocumentsQuery,
    Types.ExportDocumentsQueryVariables
  >(ExportDocumentsDocument, options);
}
export type ExportDocumentsQueryHookResult = ReturnType<
  typeof useExportDocumentsQuery
>;
export type ExportDocumentsLazyQueryHookResult = ReturnType<
  typeof useExportDocumentsLazyQuery
>;
export type ExportDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useExportDocumentsSuspenseQuery
>;
export type ExportDocumentsQueryResult = Apollo.QueryResult<
  Types.ExportDocumentsQuery,
  Types.ExportDocumentsQueryVariables
>;
export const ExportHeatmapDocument = /*#__PURE__*/ gql`
  query ExportHeatmap(
    $generationContext: GenerationContextInput!
    $knowledgeGraphItems: [KnowledgeGraphItemInput!]!
    $organicSerpItemPageKgData: [OrganicSerpItemPageKgDataInput!]!
    $userProvidedPage: OrganicSerpItemPageKgDataInput
    $filterContext: FilterContextInput!
  ) {
    exportHeatmap(
      generationContext: $generationContext
      knowledgeGraphItems: $knowledgeGraphItems
      organicSerpItemPageKgData: $organicSerpItemPageKgData
      userProvidedPage: $userProvidedPage
      filterContext: $filterContext
    ) {
      data
      format
    }
  }
`;

/**
 * __useExportHeatmapQuery__
 *
 * To run a query within a React component, call `useExportHeatmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportHeatmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportHeatmapQuery({
 *   variables: {
 *      generationContext: // value for 'generationContext'
 *      knowledgeGraphItems: // value for 'knowledgeGraphItems'
 *      organicSerpItemPageKgData: // value for 'organicSerpItemPageKgData'
 *      userProvidedPage: // value for 'userProvidedPage'
 *      filterContext: // value for 'filterContext'
 *   },
 * });
 */
export function useExportHeatmapQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExportHeatmapQuery,
    Types.ExportHeatmapQueryVariables
  > &
    (
      | { variables: Types.ExportHeatmapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExportHeatmapQuery,
    Types.ExportHeatmapQueryVariables
  >(ExportHeatmapDocument, options);
}
export function useExportHeatmapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExportHeatmapQuery,
    Types.ExportHeatmapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExportHeatmapQuery,
    Types.ExportHeatmapQueryVariables
  >(ExportHeatmapDocument, options);
}
export function useExportHeatmapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ExportHeatmapQuery,
    Types.ExportHeatmapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ExportHeatmapQuery,
    Types.ExportHeatmapQueryVariables
  >(ExportHeatmapDocument, options);
}
export type ExportHeatmapQueryHookResult = ReturnType<
  typeof useExportHeatmapQuery
>;
export type ExportHeatmapLazyQueryHookResult = ReturnType<
  typeof useExportHeatmapLazyQuery
>;
export type ExportHeatmapSuspenseQueryHookResult = ReturnType<
  typeof useExportHeatmapSuspenseQuery
>;
export type ExportHeatmapQueryResult = Apollo.QueryResult<
  Types.ExportHeatmapQuery,
  Types.ExportHeatmapQueryVariables
>;
export const ExportInventoryItemsDocument = /*#__PURE__*/ gql`
  query ExportInventoryItems(
    $columnNames: [ColumnNameInput!]!
    $filters: [JSON!] = null
    $limit: Int! = 10000
    $mode: String! = "pageTopics"
    $search: String = null
    $siteId: String!
    $sort: InventorySortFields = null
  ) {
    exportInventoryItems(
      columnNames: $columnNames
      filters: $filters
      limit: $limit
      mode: $mode
      search: $search
      siteId: $siteId
      sort: $sort
    ) {
      data
      format
    }
  }
`;

/**
 * __useExportInventoryItemsQuery__
 *
 * To run a query within a React component, call `useExportInventoryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportInventoryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportInventoryItemsQuery({
 *   variables: {
 *      columnNames: // value for 'columnNames'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      mode: // value for 'mode'
 *      search: // value for 'search'
 *      siteId: // value for 'siteId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportInventoryItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExportInventoryItemsQuery,
    Types.ExportInventoryItemsQueryVariables
  > &
    (
      | { variables: Types.ExportInventoryItemsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExportInventoryItemsQuery,
    Types.ExportInventoryItemsQueryVariables
  >(ExportInventoryItemsDocument, options);
}
export function useExportInventoryItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExportInventoryItemsQuery,
    Types.ExportInventoryItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExportInventoryItemsQuery,
    Types.ExportInventoryItemsQueryVariables
  >(ExportInventoryItemsDocument, options);
}
export function useExportInventoryItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ExportInventoryItemsQuery,
    Types.ExportInventoryItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ExportInventoryItemsQuery,
    Types.ExportInventoryItemsQueryVariables
  >(ExportInventoryItemsDocument, options);
}
export type ExportInventoryItemsQueryHookResult = ReturnType<
  typeof useExportInventoryItemsQuery
>;
export type ExportInventoryItemsLazyQueryHookResult = ReturnType<
  typeof useExportInventoryItemsLazyQuery
>;
export type ExportInventoryItemsSuspenseQueryHookResult = ReturnType<
  typeof useExportInventoryItemsSuspenseQuery
>;
export type ExportInventoryItemsQueryResult = Apollo.QueryResult<
  Types.ExportInventoryItemsQuery,
  Types.ExportInventoryItemsQueryVariables
>;
export const ExportSerpXrayDocument = /*#__PURE__*/ gql`
  query ExportSerpXray(
    $generationContext: GenerationContextInput!
    $intentData: IntentDataInput!
    $kgMetrics: [KGMetricsInput!]!
    $kgMetricsAverage: KGMetricsInput!
    $organicSerpItemPageAverages: OnPageMetricsAveragesInput!
    $organicSerpItemPageKgData: [OrganicSerpItemPageKgDataInput!]!
    $organicSerpItemPages: [OrganicSerpItemPageInput!]!
    $organicSerpItems: [OrganicSerpItemInput!]!
    $serpExportUserProvidedPage: SerpExportUserProvidedPageInput
    $userProvidedPage: UserProvidedPageInput
  ) {
    exportSerpXray(
      generationContext: $generationContext
      intentData: $intentData
      kgMetrics: $kgMetrics
      kgMetricsAverage: $kgMetricsAverage
      organicSerpItemPageAverages: $organicSerpItemPageAverages
      organicSerpItemPageKgData: $organicSerpItemPageKgData
      organicSerpItemPages: $organicSerpItemPages
      organicSerpItems: $organicSerpItems
      serpExportUserProvidedPage: $serpExportUserProvidedPage
      userProvidedPage: $userProvidedPage
    ) {
      data
      format
    }
  }
`;

/**
 * __useExportSerpXrayQuery__
 *
 * To run a query within a React component, call `useExportSerpXrayQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSerpXrayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSerpXrayQuery({
 *   variables: {
 *      generationContext: // value for 'generationContext'
 *      intentData: // value for 'intentData'
 *      kgMetrics: // value for 'kgMetrics'
 *      kgMetricsAverage: // value for 'kgMetricsAverage'
 *      organicSerpItemPageAverages: // value for 'organicSerpItemPageAverages'
 *      organicSerpItemPageKgData: // value for 'organicSerpItemPageKgData'
 *      organicSerpItemPages: // value for 'organicSerpItemPages'
 *      organicSerpItems: // value for 'organicSerpItems'
 *      serpExportUserProvidedPage: // value for 'serpExportUserProvidedPage'
 *      userProvidedPage: // value for 'userProvidedPage'
 *   },
 * });
 */
export function useExportSerpXrayQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExportSerpXrayQuery,
    Types.ExportSerpXrayQueryVariables
  > &
    (
      | { variables: Types.ExportSerpXrayQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExportSerpXrayQuery,
    Types.ExportSerpXrayQueryVariables
  >(ExportSerpXrayDocument, options);
}
export function useExportSerpXrayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExportSerpXrayQuery,
    Types.ExportSerpXrayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExportSerpXrayQuery,
    Types.ExportSerpXrayQueryVariables
  >(ExportSerpXrayDocument, options);
}
export function useExportSerpXraySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ExportSerpXrayQuery,
    Types.ExportSerpXrayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ExportSerpXrayQuery,
    Types.ExportSerpXrayQueryVariables
  >(ExportSerpXrayDocument, options);
}
export type ExportSerpXrayQueryHookResult = ReturnType<
  typeof useExportSerpXrayQuery
>;
export type ExportSerpXrayLazyQueryHookResult = ReturnType<
  typeof useExportSerpXrayLazyQuery
>;
export type ExportSerpXraySuspenseQueryHookResult = ReturnType<
  typeof useExportSerpXraySuspenseQuery
>;
export type ExportSerpXrayQueryResult = Apollo.QueryResult<
  Types.ExportSerpXrayQuery,
  Types.ExportSerpXrayQueryVariables
>;
export const ExportTopicNavigatorDocument = /*#__PURE__*/ gql`
  query ExportTopicNavigator(
    $generationContext: GenerationContextInput!
    $keywordsTabData: [AdWordsItemInput!]
    $questionsTabData: [AdWordsItemInput!]
    $reflectTabData: [ReflectItemInput!]
    $topicModelTabData: [KnowledgeGraphItemInput!]
  ) {
    exportTable(
      generationContext: $generationContext
      keywordsTabData: $keywordsTabData
      questionsTabData: $questionsTabData
      reflectTabData: $reflectTabData
      topicModelTabData: $topicModelTabData
    ) {
      data
      format
    }
  }
`;

/**
 * __useExportTopicNavigatorQuery__
 *
 * To run a query within a React component, call `useExportTopicNavigatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTopicNavigatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTopicNavigatorQuery({
 *   variables: {
 *      generationContext: // value for 'generationContext'
 *      keywordsTabData: // value for 'keywordsTabData'
 *      questionsTabData: // value for 'questionsTabData'
 *      reflectTabData: // value for 'reflectTabData'
 *      topicModelTabData: // value for 'topicModelTabData'
 *   },
 * });
 */
export function useExportTopicNavigatorQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExportTopicNavigatorQuery,
    Types.ExportTopicNavigatorQueryVariables
  > &
    (
      | { variables: Types.ExportTopicNavigatorQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExportTopicNavigatorQuery,
    Types.ExportTopicNavigatorQueryVariables
  >(ExportTopicNavigatorDocument, options);
}
export function useExportTopicNavigatorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExportTopicNavigatorQuery,
    Types.ExportTopicNavigatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExportTopicNavigatorQuery,
    Types.ExportTopicNavigatorQueryVariables
  >(ExportTopicNavigatorDocument, options);
}
export function useExportTopicNavigatorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ExportTopicNavigatorQuery,
    Types.ExportTopicNavigatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ExportTopicNavigatorQuery,
    Types.ExportTopicNavigatorQueryVariables
  >(ExportTopicNavigatorDocument, options);
}
export type ExportTopicNavigatorQueryHookResult = ReturnType<
  typeof useExportTopicNavigatorQuery
>;
export type ExportTopicNavigatorLazyQueryHookResult = ReturnType<
  typeof useExportTopicNavigatorLazyQuery
>;
export type ExportTopicNavigatorSuspenseQueryHookResult = ReturnType<
  typeof useExportTopicNavigatorSuspenseQuery
>;
export type ExportTopicNavigatorQueryResult = Apollo.QueryResult<
  Types.ExportTopicNavigatorQuery,
  Types.ExportTopicNavigatorQueryVariables
>;
export const GenaiChangeToneDocument = /*#__PURE__*/ gql`
  query GenaiChangeTone(
    $contentInput: String!
    $focusTerm: String!
    $tone: Tone!
    $topicModelTerms: [String!]!
  ) {
    genaiChangeTone(
      contentInput: $contentInput
      focusTerm: $focusTerm
      tone: $tone
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiChangeToneQuery__
 *
 * To run a query within a React component, call `useGenaiChangeToneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiChangeToneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiChangeToneQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      tone: // value for 'tone'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiChangeToneQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiChangeToneQuery,
    Types.GenaiChangeToneQueryVariables
  > &
    (
      | { variables: Types.GenaiChangeToneQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiChangeToneQuery,
    Types.GenaiChangeToneQueryVariables
  >(GenaiChangeToneDocument, options);
}
export function useGenaiChangeToneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiChangeToneQuery,
    Types.GenaiChangeToneQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiChangeToneQuery,
    Types.GenaiChangeToneQueryVariables
  >(GenaiChangeToneDocument, options);
}
export function useGenaiChangeToneSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiChangeToneQuery,
    Types.GenaiChangeToneQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiChangeToneQuery,
    Types.GenaiChangeToneQueryVariables
  >(GenaiChangeToneDocument, options);
}
export type GenaiChangeToneQueryHookResult = ReturnType<
  typeof useGenaiChangeToneQuery
>;
export type GenaiChangeToneLazyQueryHookResult = ReturnType<
  typeof useGenaiChangeToneLazyQuery
>;
export type GenaiChangeToneSuspenseQueryHookResult = ReturnType<
  typeof useGenaiChangeToneSuspenseQuery
>;
export type GenaiChangeToneQueryResult = Apollo.QueryResult<
  Types.GenaiChangeToneQuery,
  Types.GenaiChangeToneQueryVariables
>;
export const GenaiCreateOutlineDocument = /*#__PURE__*/ gql`
  query GenaiCreateOutline(
    $focusTerm: String!
    $promptInput: String!
    $topicModelTerms: [String!]!
  ) {
    genaiCreateOutline(
      focusTerm: $focusTerm
      promptInput: $promptInput
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiCreateOutlineQuery__
 *
 * To run a query within a React component, call `useGenaiCreateOutlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiCreateOutlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiCreateOutlineQuery({
 *   variables: {
 *      focusTerm: // value for 'focusTerm'
 *      promptInput: // value for 'promptInput'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiCreateOutlineQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiCreateOutlineQuery,
    Types.GenaiCreateOutlineQueryVariables
  > &
    (
      | { variables: Types.GenaiCreateOutlineQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiCreateOutlineQuery,
    Types.GenaiCreateOutlineQueryVariables
  >(GenaiCreateOutlineDocument, options);
}
export function useGenaiCreateOutlineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiCreateOutlineQuery,
    Types.GenaiCreateOutlineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiCreateOutlineQuery,
    Types.GenaiCreateOutlineQueryVariables
  >(GenaiCreateOutlineDocument, options);
}
export function useGenaiCreateOutlineSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiCreateOutlineQuery,
    Types.GenaiCreateOutlineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiCreateOutlineQuery,
    Types.GenaiCreateOutlineQueryVariables
  >(GenaiCreateOutlineDocument, options);
}
export type GenaiCreateOutlineQueryHookResult = ReturnType<
  typeof useGenaiCreateOutlineQuery
>;
export type GenaiCreateOutlineLazyQueryHookResult = ReturnType<
  typeof useGenaiCreateOutlineLazyQuery
>;
export type GenaiCreateOutlineSuspenseQueryHookResult = ReturnType<
  typeof useGenaiCreateOutlineSuspenseQuery
>;
export type GenaiCreateOutlineQueryResult = Apollo.QueryResult<
  Types.GenaiCreateOutlineQuery,
  Types.GenaiCreateOutlineQueryVariables
>;
export const GenaiCreateSummaryDocument = /*#__PURE__*/ gql`
  query GenaiCreateSummary(
    $contentInput: String!
    $focusTerm: String!
    $promptInput: String!
    $topicModelTerms: [String!]!
  ) {
    genaiCreateSummary(
      contentInput: $contentInput
      focusTerm: $focusTerm
      promptInput: $promptInput
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiCreateSummaryQuery__
 *
 * To run a query within a React component, call `useGenaiCreateSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiCreateSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiCreateSummaryQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      promptInput: // value for 'promptInput'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiCreateSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiCreateSummaryQuery,
    Types.GenaiCreateSummaryQueryVariables
  > &
    (
      | { variables: Types.GenaiCreateSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiCreateSummaryQuery,
    Types.GenaiCreateSummaryQueryVariables
  >(GenaiCreateSummaryDocument, options);
}
export function useGenaiCreateSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiCreateSummaryQuery,
    Types.GenaiCreateSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiCreateSummaryQuery,
    Types.GenaiCreateSummaryQueryVariables
  >(GenaiCreateSummaryDocument, options);
}
export function useGenaiCreateSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiCreateSummaryQuery,
    Types.GenaiCreateSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiCreateSummaryQuery,
    Types.GenaiCreateSummaryQueryVariables
  >(GenaiCreateSummaryDocument, options);
}
export type GenaiCreateSummaryQueryHookResult = ReturnType<
  typeof useGenaiCreateSummaryQuery
>;
export type GenaiCreateSummaryLazyQueryHookResult = ReturnType<
  typeof useGenaiCreateSummaryLazyQuery
>;
export type GenaiCreateSummarySuspenseQueryHookResult = ReturnType<
  typeof useGenaiCreateSummarySuspenseQuery
>;
export type GenaiCreateSummaryQueryResult = Apollo.QueryResult<
  Types.GenaiCreateSummaryQuery,
  Types.GenaiCreateSummaryQueryVariables
>;
export const GenaiCustomPromptDocument = /*#__PURE__*/ gql`
  query GenaiCustomPrompt(
    $contentInput: String
    $focusTerm: String!
    $promptInput: String!
    $topicModelTerms: [String!]!
  ) {
    genaiCustomPrompt(
      contentInput: $contentInput
      focusTerm: $focusTerm
      promptInput: $promptInput
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiCustomPromptQuery__
 *
 * To run a query within a React component, call `useGenaiCustomPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiCustomPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiCustomPromptQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      promptInput: // value for 'promptInput'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiCustomPromptQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiCustomPromptQuery,
    Types.GenaiCustomPromptQueryVariables
  > &
    (
      | { variables: Types.GenaiCustomPromptQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiCustomPromptQuery,
    Types.GenaiCustomPromptQueryVariables
  >(GenaiCustomPromptDocument, options);
}
export function useGenaiCustomPromptLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiCustomPromptQuery,
    Types.GenaiCustomPromptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiCustomPromptQuery,
    Types.GenaiCustomPromptQueryVariables
  >(GenaiCustomPromptDocument, options);
}
export function useGenaiCustomPromptSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiCustomPromptQuery,
    Types.GenaiCustomPromptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiCustomPromptQuery,
    Types.GenaiCustomPromptQueryVariables
  >(GenaiCustomPromptDocument, options);
}
export type GenaiCustomPromptQueryHookResult = ReturnType<
  typeof useGenaiCustomPromptQuery
>;
export type GenaiCustomPromptLazyQueryHookResult = ReturnType<
  typeof useGenaiCustomPromptLazyQuery
>;
export type GenaiCustomPromptSuspenseQueryHookResult = ReturnType<
  typeof useGenaiCustomPromptSuspenseQuery
>;
export type GenaiCustomPromptQueryResult = Apollo.QueryResult<
  Types.GenaiCustomPromptQuery,
  Types.GenaiCustomPromptQueryVariables
>;
export const GenaiExpandConceptDocument = /*#__PURE__*/ gql`
  query genaiExpandConcept(
    $contentInput: String
    $focusTerm: String!
    $promptInput: String!
    $topicModelTerms: [String!]!
  ) {
    genaiExpandConcept(
      contentInput: $contentInput
      focusTerm: $focusTerm
      promptInput: $promptInput
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiExpandConceptQuery__
 *
 * To run a query within a React component, call `useGenaiExpandConceptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiExpandConceptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiExpandConceptQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      promptInput: // value for 'promptInput'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiExpandConceptQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiExpandConceptQuery,
    Types.GenaiExpandConceptQueryVariables
  > &
    (
      | { variables: Types.GenaiExpandConceptQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiExpandConceptQuery,
    Types.GenaiExpandConceptQueryVariables
  >(GenaiExpandConceptDocument, options);
}
export function useGenaiExpandConceptLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiExpandConceptQuery,
    Types.GenaiExpandConceptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiExpandConceptQuery,
    Types.GenaiExpandConceptQueryVariables
  >(GenaiExpandConceptDocument, options);
}
export function useGenaiExpandConceptSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiExpandConceptQuery,
    Types.GenaiExpandConceptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiExpandConceptQuery,
    Types.GenaiExpandConceptQueryVariables
  >(GenaiExpandConceptDocument, options);
}
export type GenaiExpandConceptQueryHookResult = ReturnType<
  typeof useGenaiExpandConceptQuery
>;
export type GenaiExpandConceptLazyQueryHookResult = ReturnType<
  typeof useGenaiExpandConceptLazyQuery
>;
export type GenaiExpandConceptSuspenseQueryHookResult = ReturnType<
  typeof useGenaiExpandConceptSuspenseQuery
>;
export type GenaiExpandConceptQueryResult = Apollo.QueryResult<
  Types.GenaiExpandConceptQuery,
  Types.GenaiExpandConceptQueryVariables
>;
export const GenaiFixSpellingDocument = /*#__PURE__*/ gql`
  query GenaiFixSpelling($contentInput: String!, $focusTerm: String!) {
    genaiFixSpelling(contentInput: $contentInput, focusTerm: $focusTerm) {
      response
    }
  }
`;

/**
 * __useGenaiFixSpellingQuery__
 *
 * To run a query within a React component, call `useGenaiFixSpellingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiFixSpellingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiFixSpellingQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *   },
 * });
 */
export function useGenaiFixSpellingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiFixSpellingQuery,
    Types.GenaiFixSpellingQueryVariables
  > &
    (
      | { variables: Types.GenaiFixSpellingQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiFixSpellingQuery,
    Types.GenaiFixSpellingQueryVariables
  >(GenaiFixSpellingDocument, options);
}
export function useGenaiFixSpellingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiFixSpellingQuery,
    Types.GenaiFixSpellingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiFixSpellingQuery,
    Types.GenaiFixSpellingQueryVariables
  >(GenaiFixSpellingDocument, options);
}
export function useGenaiFixSpellingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiFixSpellingQuery,
    Types.GenaiFixSpellingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiFixSpellingQuery,
    Types.GenaiFixSpellingQueryVariables
  >(GenaiFixSpellingDocument, options);
}
export type GenaiFixSpellingQueryHookResult = ReturnType<
  typeof useGenaiFixSpellingQuery
>;
export type GenaiFixSpellingLazyQueryHookResult = ReturnType<
  typeof useGenaiFixSpellingLazyQuery
>;
export type GenaiFixSpellingSuspenseQueryHookResult = ReturnType<
  typeof useGenaiFixSpellingSuspenseQuery
>;
export type GenaiFixSpellingQueryResult = Apollo.QueryResult<
  Types.GenaiFixSpellingQuery,
  Types.GenaiFixSpellingQueryVariables
>;
export const GenaiFollowUpContinueWritingDocument = /*#__PURE__*/ gql`
  query GenaiFollowUpContinueWriting(
    $contentInput: String
    $focusTerm: String!
    $initial: FollowUpInitialInput!
    $previousFollowUps: [FollowUpInput!]
    $promptInput: String
    $tone: Tone
    $topicModelTerms: [String!]!
  ) {
    genaiFollowUpContinueWriting(
      contentInput: $contentInput
      focusTerm: $focusTerm
      initial: $initial
      previousFollowUps: $previousFollowUps
      promptInput: $promptInput
      tone: $tone
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiFollowUpContinueWritingQuery__
 *
 * To run a query within a React component, call `useGenaiFollowUpContinueWritingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiFollowUpContinueWritingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiFollowUpContinueWritingQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      initial: // value for 'initial'
 *      previousFollowUps: // value for 'previousFollowUps'
 *      promptInput: // value for 'promptInput'
 *      tone: // value for 'tone'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiFollowUpContinueWritingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiFollowUpContinueWritingQuery,
    Types.GenaiFollowUpContinueWritingQueryVariables
  > &
    (
      | {
          variables: Types.GenaiFollowUpContinueWritingQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiFollowUpContinueWritingQuery,
    Types.GenaiFollowUpContinueWritingQueryVariables
  >(GenaiFollowUpContinueWritingDocument, options);
}
export function useGenaiFollowUpContinueWritingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiFollowUpContinueWritingQuery,
    Types.GenaiFollowUpContinueWritingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiFollowUpContinueWritingQuery,
    Types.GenaiFollowUpContinueWritingQueryVariables
  >(GenaiFollowUpContinueWritingDocument, options);
}
export function useGenaiFollowUpContinueWritingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiFollowUpContinueWritingQuery,
    Types.GenaiFollowUpContinueWritingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiFollowUpContinueWritingQuery,
    Types.GenaiFollowUpContinueWritingQueryVariables
  >(GenaiFollowUpContinueWritingDocument, options);
}
export type GenaiFollowUpContinueWritingQueryHookResult = ReturnType<
  typeof useGenaiFollowUpContinueWritingQuery
>;
export type GenaiFollowUpContinueWritingLazyQueryHookResult = ReturnType<
  typeof useGenaiFollowUpContinueWritingLazyQuery
>;
export type GenaiFollowUpContinueWritingSuspenseQueryHookResult = ReturnType<
  typeof useGenaiFollowUpContinueWritingSuspenseQuery
>;
export type GenaiFollowUpContinueWritingQueryResult = Apollo.QueryResult<
  Types.GenaiFollowUpContinueWritingQuery,
  Types.GenaiFollowUpContinueWritingQueryVariables
>;
export const GenaiFollowUpCustomDocument = /*#__PURE__*/ gql`
  query GenaiFollowUpCustom(
    $contentInput: String
    $customPrompt: String!
    $focusTerm: String!
    $initial: FollowUpInitialInput!
    $previousFollowUps: [FollowUpInput!]
    $promptInput: String
    $tone: Tone
    $topicModelTerms: [String!]!
  ) {
    genaiFollowUpCustom(
      contentInput: $contentInput
      customPrompt: $customPrompt
      focusTerm: $focusTerm
      initial: $initial
      previousFollowUps: $previousFollowUps
      promptInput: $promptInput
      tone: $tone
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiFollowUpCustomQuery__
 *
 * To run a query within a React component, call `useGenaiFollowUpCustomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiFollowUpCustomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiFollowUpCustomQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      customPrompt: // value for 'customPrompt'
 *      focusTerm: // value for 'focusTerm'
 *      initial: // value for 'initial'
 *      previousFollowUps: // value for 'previousFollowUps'
 *      promptInput: // value for 'promptInput'
 *      tone: // value for 'tone'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiFollowUpCustomQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiFollowUpCustomQuery,
    Types.GenaiFollowUpCustomQueryVariables
  > &
    (
      | { variables: Types.GenaiFollowUpCustomQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiFollowUpCustomQuery,
    Types.GenaiFollowUpCustomQueryVariables
  >(GenaiFollowUpCustomDocument, options);
}
export function useGenaiFollowUpCustomLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiFollowUpCustomQuery,
    Types.GenaiFollowUpCustomQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiFollowUpCustomQuery,
    Types.GenaiFollowUpCustomQueryVariables
  >(GenaiFollowUpCustomDocument, options);
}
export function useGenaiFollowUpCustomSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiFollowUpCustomQuery,
    Types.GenaiFollowUpCustomQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiFollowUpCustomQuery,
    Types.GenaiFollowUpCustomQueryVariables
  >(GenaiFollowUpCustomDocument, options);
}
export type GenaiFollowUpCustomQueryHookResult = ReturnType<
  typeof useGenaiFollowUpCustomQuery
>;
export type GenaiFollowUpCustomLazyQueryHookResult = ReturnType<
  typeof useGenaiFollowUpCustomLazyQuery
>;
export type GenaiFollowUpCustomSuspenseQueryHookResult = ReturnType<
  typeof useGenaiFollowUpCustomSuspenseQuery
>;
export type GenaiFollowUpCustomQueryResult = Apollo.QueryResult<
  Types.GenaiFollowUpCustomQuery,
  Types.GenaiFollowUpCustomQueryVariables
>;
export const GenaiFollowUpMakeLongerDocument = /*#__PURE__*/ gql`
  query GenaiFollowUpMakeLonger(
    $contentInput: String
    $focusTerm: String!
    $initial: FollowUpInitialInput!
    $previousFollowUps: [FollowUpInput!]
    $promptInput: String
    $tone: Tone
    $topicModelTerms: [String!]!
  ) {
    genaiFollowUpMakeLonger(
      contentInput: $contentInput
      focusTerm: $focusTerm
      initial: $initial
      previousFollowUps: $previousFollowUps
      promptInput: $promptInput
      tone: $tone
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiFollowUpMakeLongerQuery__
 *
 * To run a query within a React component, call `useGenaiFollowUpMakeLongerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiFollowUpMakeLongerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiFollowUpMakeLongerQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      initial: // value for 'initial'
 *      previousFollowUps: // value for 'previousFollowUps'
 *      promptInput: // value for 'promptInput'
 *      tone: // value for 'tone'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiFollowUpMakeLongerQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiFollowUpMakeLongerQuery,
    Types.GenaiFollowUpMakeLongerQueryVariables
  > &
    (
      | {
          variables: Types.GenaiFollowUpMakeLongerQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiFollowUpMakeLongerQuery,
    Types.GenaiFollowUpMakeLongerQueryVariables
  >(GenaiFollowUpMakeLongerDocument, options);
}
export function useGenaiFollowUpMakeLongerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiFollowUpMakeLongerQuery,
    Types.GenaiFollowUpMakeLongerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiFollowUpMakeLongerQuery,
    Types.GenaiFollowUpMakeLongerQueryVariables
  >(GenaiFollowUpMakeLongerDocument, options);
}
export function useGenaiFollowUpMakeLongerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiFollowUpMakeLongerQuery,
    Types.GenaiFollowUpMakeLongerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiFollowUpMakeLongerQuery,
    Types.GenaiFollowUpMakeLongerQueryVariables
  >(GenaiFollowUpMakeLongerDocument, options);
}
export type GenaiFollowUpMakeLongerQueryHookResult = ReturnType<
  typeof useGenaiFollowUpMakeLongerQuery
>;
export type GenaiFollowUpMakeLongerLazyQueryHookResult = ReturnType<
  typeof useGenaiFollowUpMakeLongerLazyQuery
>;
export type GenaiFollowUpMakeLongerSuspenseQueryHookResult = ReturnType<
  typeof useGenaiFollowUpMakeLongerSuspenseQuery
>;
export type GenaiFollowUpMakeLongerQueryResult = Apollo.QueryResult<
  Types.GenaiFollowUpMakeLongerQuery,
  Types.GenaiFollowUpMakeLongerQueryVariables
>;
export const GenaiFollowUpTryAgainDocument = /*#__PURE__*/ gql`
  query GenaiFollowUpTryAgain(
    $contentInput: String
    $focusTerm: String!
    $initial: FollowUpInitialInput!
    $previousFollowUps: [FollowUpInput!]
    $promptInput: String
    $tone: Tone
    $topicModelTerms: [String!]!
  ) {
    genaiFollowUpTryAgain(
      contentInput: $contentInput
      focusTerm: $focusTerm
      initial: $initial
      previousFollowUps: $previousFollowUps
      promptInput: $promptInput
      tone: $tone
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiFollowUpTryAgainQuery__
 *
 * To run a query within a React component, call `useGenaiFollowUpTryAgainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiFollowUpTryAgainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiFollowUpTryAgainQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      initial: // value for 'initial'
 *      previousFollowUps: // value for 'previousFollowUps'
 *      promptInput: // value for 'promptInput'
 *      tone: // value for 'tone'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiFollowUpTryAgainQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiFollowUpTryAgainQuery,
    Types.GenaiFollowUpTryAgainQueryVariables
  > &
    (
      | { variables: Types.GenaiFollowUpTryAgainQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiFollowUpTryAgainQuery,
    Types.GenaiFollowUpTryAgainQueryVariables
  >(GenaiFollowUpTryAgainDocument, options);
}
export function useGenaiFollowUpTryAgainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiFollowUpTryAgainQuery,
    Types.GenaiFollowUpTryAgainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiFollowUpTryAgainQuery,
    Types.GenaiFollowUpTryAgainQueryVariables
  >(GenaiFollowUpTryAgainDocument, options);
}
export function useGenaiFollowUpTryAgainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiFollowUpTryAgainQuery,
    Types.GenaiFollowUpTryAgainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiFollowUpTryAgainQuery,
    Types.GenaiFollowUpTryAgainQueryVariables
  >(GenaiFollowUpTryAgainDocument, options);
}
export type GenaiFollowUpTryAgainQueryHookResult = ReturnType<
  typeof useGenaiFollowUpTryAgainQuery
>;
export type GenaiFollowUpTryAgainLazyQueryHookResult = ReturnType<
  typeof useGenaiFollowUpTryAgainLazyQuery
>;
export type GenaiFollowUpTryAgainSuspenseQueryHookResult = ReturnType<
  typeof useGenaiFollowUpTryAgainSuspenseQuery
>;
export type GenaiFollowUpTryAgainQueryResult = Apollo.QueryResult<
  Types.GenaiFollowUpTryAgainQuery,
  Types.GenaiFollowUpTryAgainQueryVariables
>;
export const GenaiImproveWritingDocument = /*#__PURE__*/ gql`
  query GenaiImproveWriting(
    $contentInput: String!
    $focusTerm: String!
    $topicModelTerms: [String!]!
  ) {
    genaiImproveWriting(
      contentInput: $contentInput
      focusTerm: $focusTerm
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiImproveWritingQuery__
 *
 * To run a query within a React component, call `useGenaiImproveWritingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiImproveWritingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiImproveWritingQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiImproveWritingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiImproveWritingQuery,
    Types.GenaiImproveWritingQueryVariables
  > &
    (
      | { variables: Types.GenaiImproveWritingQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiImproveWritingQuery,
    Types.GenaiImproveWritingQueryVariables
  >(GenaiImproveWritingDocument, options);
}
export function useGenaiImproveWritingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiImproveWritingQuery,
    Types.GenaiImproveWritingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiImproveWritingQuery,
    Types.GenaiImproveWritingQueryVariables
  >(GenaiImproveWritingDocument, options);
}
export function useGenaiImproveWritingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiImproveWritingQuery,
    Types.GenaiImproveWritingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiImproveWritingQuery,
    Types.GenaiImproveWritingQueryVariables
  >(GenaiImproveWritingDocument, options);
}
export type GenaiImproveWritingQueryHookResult = ReturnType<
  typeof useGenaiImproveWritingQuery
>;
export type GenaiImproveWritingLazyQueryHookResult = ReturnType<
  typeof useGenaiImproveWritingLazyQuery
>;
export type GenaiImproveWritingSuspenseQueryHookResult = ReturnType<
  typeof useGenaiImproveWritingSuspenseQuery
>;
export type GenaiImproveWritingQueryResult = Apollo.QueryResult<
  Types.GenaiImproveWritingQuery,
  Types.GenaiImproveWritingQueryVariables
>;
export const GenaiMakeLongerDocument = /*#__PURE__*/ gql`
  query GenaiMakeLonger(
    $contentInput: String!
    $focusTerm: String!
    $topicModelTerms: [String!]!
  ) {
    genaiMakeLonger(
      contentInput: $contentInput
      focusTerm: $focusTerm
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiMakeLongerQuery__
 *
 * To run a query within a React component, call `useGenaiMakeLongerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiMakeLongerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiMakeLongerQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiMakeLongerQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiMakeLongerQuery,
    Types.GenaiMakeLongerQueryVariables
  > &
    (
      | { variables: Types.GenaiMakeLongerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiMakeLongerQuery,
    Types.GenaiMakeLongerQueryVariables
  >(GenaiMakeLongerDocument, options);
}
export function useGenaiMakeLongerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiMakeLongerQuery,
    Types.GenaiMakeLongerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiMakeLongerQuery,
    Types.GenaiMakeLongerQueryVariables
  >(GenaiMakeLongerDocument, options);
}
export function useGenaiMakeLongerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiMakeLongerQuery,
    Types.GenaiMakeLongerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiMakeLongerQuery,
    Types.GenaiMakeLongerQueryVariables
  >(GenaiMakeLongerDocument, options);
}
export type GenaiMakeLongerQueryHookResult = ReturnType<
  typeof useGenaiMakeLongerQuery
>;
export type GenaiMakeLongerLazyQueryHookResult = ReturnType<
  typeof useGenaiMakeLongerLazyQuery
>;
export type GenaiMakeLongerSuspenseQueryHookResult = ReturnType<
  typeof useGenaiMakeLongerSuspenseQuery
>;
export type GenaiMakeLongerQueryResult = Apollo.QueryResult<
  Types.GenaiMakeLongerQuery,
  Types.GenaiMakeLongerQueryVariables
>;
export const GenaiMakeShorterDocument = /*#__PURE__*/ gql`
  query GenaiMakeShorter(
    $contentInput: String!
    $focusTerm: String!
    $topicModelTerms: [String!]!
  ) {
    genaiMakeShorter(
      contentInput: $contentInput
      focusTerm: $focusTerm
      topicModelTerms: $topicModelTerms
    ) {
      response
    }
  }
`;

/**
 * __useGenaiMakeShorterQuery__
 *
 * To run a query within a React component, call `useGenaiMakeShorterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenaiMakeShorterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenaiMakeShorterQuery({
 *   variables: {
 *      contentInput: // value for 'contentInput'
 *      focusTerm: // value for 'focusTerm'
 *      topicModelTerms: // value for 'topicModelTerms'
 *   },
 * });
 */
export function useGenaiMakeShorterQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GenaiMakeShorterQuery,
    Types.GenaiMakeShorterQueryVariables
  > &
    (
      | { variables: Types.GenaiMakeShorterQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GenaiMakeShorterQuery,
    Types.GenaiMakeShorterQueryVariables
  >(GenaiMakeShorterDocument, options);
}
export function useGenaiMakeShorterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GenaiMakeShorterQuery,
    Types.GenaiMakeShorterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GenaiMakeShorterQuery,
    Types.GenaiMakeShorterQueryVariables
  >(GenaiMakeShorterDocument, options);
}
export function useGenaiMakeShorterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GenaiMakeShorterQuery,
    Types.GenaiMakeShorterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GenaiMakeShorterQuery,
    Types.GenaiMakeShorterQueryVariables
  >(GenaiMakeShorterDocument, options);
}
export type GenaiMakeShorterQueryHookResult = ReturnType<
  typeof useGenaiMakeShorterQuery
>;
export type GenaiMakeShorterLazyQueryHookResult = ReturnType<
  typeof useGenaiMakeShorterLazyQuery
>;
export type GenaiMakeShorterSuspenseQueryHookResult = ReturnType<
  typeof useGenaiMakeShorterSuspenseQuery
>;
export type GenaiMakeShorterQueryResult = Apollo.QueryResult<
  Types.GenaiMakeShorterQuery,
  Types.GenaiMakeShorterQueryVariables
>;
export const GetAppDataDocument = /*#__PURE__*/ gql`
  query GetAppData(
    $app: String!
    $params: AppDataParamsInput!
    $siteId: String!
  ) {
    getAppData(app: $app, params: $params, siteId: $siteId) {
      kg
      kgNews
      keywords
      scores
      scoresNews
      compareKgsNews
      lr
      qts
      appRuns {
        ...AppRunsFields
      }
      params {
        ...AppDataParamsFields
      }
    }
  }
  ${AppRunsFieldsFragmentDoc}
  ${AppDataParamsFieldsFragmentDoc}
`;

/**
 * __useGetAppDataQuery__
 *
 * To run a query within a React component, call `useGetAppDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppDataQuery({
 *   variables: {
 *      app: // value for 'app'
 *      params: // value for 'params'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetAppDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetAppDataQuery,
    Types.GetAppDataQueryVariables
  > &
    (
      | { variables: Types.GetAppDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAppDataQuery, Types.GetAppDataQueryVariables>(
    GetAppDataDocument,
    options,
  );
}
export function useGetAppDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetAppDataQuery,
    Types.GetAppDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetAppDataQuery,
    Types.GetAppDataQueryVariables
  >(GetAppDataDocument, options);
}
export function useGetAppDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetAppDataQuery,
    Types.GetAppDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetAppDataQuery,
    Types.GetAppDataQueryVariables
  >(GetAppDataDocument, options);
}
export type GetAppDataQueryHookResult = ReturnType<typeof useGetAppDataQuery>;
export type GetAppDataLazyQueryHookResult = ReturnType<
  typeof useGetAppDataLazyQuery
>;
export type GetAppDataSuspenseQueryHookResult = ReturnType<
  typeof useGetAppDataSuspenseQuery
>;
export type GetAppDataQueryResult = Apollo.QueryResult<
  Types.GetAppDataQuery,
  Types.GetAppDataQueryVariables
>;
export const GetSitesByOrgDocument = /*#__PURE__*/ gql`
  query GetSitesByOrg($id: String!) {
    organization(id: $id) {
      sites {
        ...SiteInventoryDataFields
        ...SiteFieldsAll
      }
    }
  }
  ${SiteInventoryDataFieldsFragmentDoc}
  ${SiteFieldsAllFragmentDoc}
`;

/**
 * __useGetSitesByOrgQuery__
 *
 * To run a query within a React component, call `useGetSitesByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesByOrgQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSitesByOrgQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSitesByOrgQuery,
    Types.GetSitesByOrgQueryVariables
  > &
    (
      | { variables: Types.GetSitesByOrgQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetSitesByOrgQuery,
    Types.GetSitesByOrgQueryVariables
  >(GetSitesByOrgDocument, options);
}
export function useGetSitesByOrgLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSitesByOrgQuery,
    Types.GetSitesByOrgQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetSitesByOrgQuery,
    Types.GetSitesByOrgQueryVariables
  >(GetSitesByOrgDocument, options);
}
export function useGetSitesByOrgSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetSitesByOrgQuery,
    Types.GetSitesByOrgQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetSitesByOrgQuery,
    Types.GetSitesByOrgQueryVariables
  >(GetSitesByOrgDocument, options);
}
export type GetSitesByOrgQueryHookResult = ReturnType<
  typeof useGetSitesByOrgQuery
>;
export type GetSitesByOrgLazyQueryHookResult = ReturnType<
  typeof useGetSitesByOrgLazyQuery
>;
export type GetSitesByOrgSuspenseQueryHookResult = ReturnType<
  typeof useGetSitesByOrgSuspenseQuery
>;
export type GetSitesByOrgQueryResult = Apollo.QueryResult<
  Types.GetSitesByOrgQuery,
  Types.GetSitesByOrgQueryVariables
>;
export const InventoryItemsPageTopicsDocument = /*#__PURE__*/ gql`
  query InventoryItemsPageTopics(
    $filters: [JSON!]
    $isManualQuery: Boolean
    $limit: Int
    $offset: Int
    $search: String
    $showHidden: Boolean
    $siteId: String!
    $sort: InventorySortFields
  ) {
    inventoryItems(
      filters: $filters
      isManualQuery: $isManualQuery
      limit: $limit
      mode: "pageTopics"
      offset: $offset
      search: $search
      showHidden: $showHidden
      siteId: $siteId
      sort: $sort
    ) {
      count
      items {
        key
        type
        page {
          ...InventoryPage
        }
        topic {
          ...InventoryTopic
        }
        pageTopic {
          ...InventoryPageTopic
        }
      }
    }
  }
  ${InventoryPageFragmentDoc}
  ${InventoryTopicFragmentDoc}
  ${InventoryPageTopicFragmentDoc}
`;

/**
 * __useInventoryItemsPageTopicsQuery__
 *
 * To run a query within a React component, call `useInventoryItemsPageTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsPageTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemsPageTopicsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      isManualQuery: // value for 'isManualQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      showHidden: // value for 'showHidden'
 *      siteId: // value for 'siteId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInventoryItemsPageTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventoryItemsPageTopicsQuery,
    Types.InventoryItemsPageTopicsQueryVariables
  > &
    (
      | {
          variables: Types.InventoryItemsPageTopicsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventoryItemsPageTopicsQuery,
    Types.InventoryItemsPageTopicsQueryVariables
  >(InventoryItemsPageTopicsDocument, options);
}
export function useInventoryItemsPageTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventoryItemsPageTopicsQuery,
    Types.InventoryItemsPageTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventoryItemsPageTopicsQuery,
    Types.InventoryItemsPageTopicsQueryVariables
  >(InventoryItemsPageTopicsDocument, options);
}
export function useInventoryItemsPageTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventoryItemsPageTopicsQuery,
    Types.InventoryItemsPageTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventoryItemsPageTopicsQuery,
    Types.InventoryItemsPageTopicsQueryVariables
  >(InventoryItemsPageTopicsDocument, options);
}
export type InventoryItemsPageTopicsQueryHookResult = ReturnType<
  typeof useInventoryItemsPageTopicsQuery
>;
export type InventoryItemsPageTopicsLazyQueryHookResult = ReturnType<
  typeof useInventoryItemsPageTopicsLazyQuery
>;
export type InventoryItemsPageTopicsSuspenseQueryHookResult = ReturnType<
  typeof useInventoryItemsPageTopicsSuspenseQuery
>;
export type InventoryItemsPageTopicsQueryResult = Apollo.QueryResult<
  Types.InventoryItemsPageTopicsQuery,
  Types.InventoryItemsPageTopicsQueryVariables
>;
export const InventoryItemsPagesDocument = /*#__PURE__*/ gql`
  query InventoryItemsPages(
    $filters: [JSON!]
    $isManualQuery: Boolean
    $limit: Int
    $offset: Int
    $search: String
    $showHidden: Boolean
    $siteId: String!
    $sort: InventorySortFields
  ) {
    inventoryItems(
      filters: $filters
      isManualQuery: $isManualQuery
      limit: $limit
      mode: "pages"
      offset: $offset
      search: $search
      showHidden: $showHidden
      siteId: $siteId
      sort: $sort
    ) {
      count
      items {
        key
        type
        page {
          ...InventoryPage
          topValuedTopic
        }
      }
    }
  }
  ${InventoryPageFragmentDoc}
`;

/**
 * __useInventoryItemsPagesQuery__
 *
 * To run a query within a React component, call `useInventoryItemsPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemsPagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      isManualQuery: // value for 'isManualQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      showHidden: // value for 'showHidden'
 *      siteId: // value for 'siteId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInventoryItemsPagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventoryItemsPagesQuery,
    Types.InventoryItemsPagesQueryVariables
  > &
    (
      | { variables: Types.InventoryItemsPagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventoryItemsPagesQuery,
    Types.InventoryItemsPagesQueryVariables
  >(InventoryItemsPagesDocument, options);
}
export function useInventoryItemsPagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventoryItemsPagesQuery,
    Types.InventoryItemsPagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventoryItemsPagesQuery,
    Types.InventoryItemsPagesQueryVariables
  >(InventoryItemsPagesDocument, options);
}
export function useInventoryItemsPagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventoryItemsPagesQuery,
    Types.InventoryItemsPagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventoryItemsPagesQuery,
    Types.InventoryItemsPagesQueryVariables
  >(InventoryItemsPagesDocument, options);
}
export type InventoryItemsPagesQueryHookResult = ReturnType<
  typeof useInventoryItemsPagesQuery
>;
export type InventoryItemsPagesLazyQueryHookResult = ReturnType<
  typeof useInventoryItemsPagesLazyQuery
>;
export type InventoryItemsPagesSuspenseQueryHookResult = ReturnType<
  typeof useInventoryItemsPagesSuspenseQuery
>;
export type InventoryItemsPagesQueryResult = Apollo.QueryResult<
  Types.InventoryItemsPagesQuery,
  Types.InventoryItemsPagesQueryVariables
>;
export const InventoryItemsPrimaryAttributesDocument = /*#__PURE__*/ gql`
  query InventoryItemsPrimaryAttributes(
    $filters: [JSON!]
    $mode: String!
    $siteId: String!
  ) {
    inventoryItems(
      filters: $filters
      isManualQuery: false
      limit: 10000
      mode: $mode
      offset: 0
      showHidden: false
      siteId: $siteId
    ) {
      count
      items {
        key
        type
        topic {
          term
        }
        page {
          url
        }
      }
    }
  }
`;

/**
 * __useInventoryItemsPrimaryAttributesQuery__
 *
 * To run a query within a React component, call `useInventoryItemsPrimaryAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsPrimaryAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemsPrimaryAttributesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      mode: // value for 'mode'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useInventoryItemsPrimaryAttributesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventoryItemsPrimaryAttributesQuery,
    Types.InventoryItemsPrimaryAttributesQueryVariables
  > &
    (
      | {
          variables: Types.InventoryItemsPrimaryAttributesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventoryItemsPrimaryAttributesQuery,
    Types.InventoryItemsPrimaryAttributesQueryVariables
  >(InventoryItemsPrimaryAttributesDocument, options);
}
export function useInventoryItemsPrimaryAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventoryItemsPrimaryAttributesQuery,
    Types.InventoryItemsPrimaryAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventoryItemsPrimaryAttributesQuery,
    Types.InventoryItemsPrimaryAttributesQueryVariables
  >(InventoryItemsPrimaryAttributesDocument, options);
}
export function useInventoryItemsPrimaryAttributesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventoryItemsPrimaryAttributesQuery,
    Types.InventoryItemsPrimaryAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventoryItemsPrimaryAttributesQuery,
    Types.InventoryItemsPrimaryAttributesQueryVariables
  >(InventoryItemsPrimaryAttributesDocument, options);
}
export type InventoryItemsPrimaryAttributesQueryHookResult = ReturnType<
  typeof useInventoryItemsPrimaryAttributesQuery
>;
export type InventoryItemsPrimaryAttributesLazyQueryHookResult = ReturnType<
  typeof useInventoryItemsPrimaryAttributesLazyQuery
>;
export type InventoryItemsPrimaryAttributesSuspenseQueryHookResult = ReturnType<
  typeof useInventoryItemsPrimaryAttributesSuspenseQuery
>;
export type InventoryItemsPrimaryAttributesQueryResult = Apollo.QueryResult<
  Types.InventoryItemsPrimaryAttributesQuery,
  Types.InventoryItemsPrimaryAttributesQueryVariables
>;
export const InventoryItemsProjectsDocument = /*#__PURE__*/ gql`
  query InventoryItemsProjects(
    $filters: [JSON!]
    $isManualQuery: Boolean
    $limit: Int
    $offset: Int
    $search: String
    $showHidden: Boolean
    $siteId: String!
    $sort: InventorySortFields
  ) {
    inventoryItems(
      filters: $filters
      isManualQuery: $isManualQuery
      limit: $limit
      mode: "projects"
      offset: $offset
      search: $search
      showHidden: $showHidden
      siteId: $siteId
      sort: $sort
    ) {
      count
      items {
        key
        type
        page {
          url
        }
        topic {
          term
        }
      }
    }
  }
`;

/**
 * __useInventoryItemsProjectsQuery__
 *
 * To run a query within a React component, call `useInventoryItemsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemsProjectsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      isManualQuery: // value for 'isManualQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      showHidden: // value for 'showHidden'
 *      siteId: // value for 'siteId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInventoryItemsProjectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventoryItemsProjectsQuery,
    Types.InventoryItemsProjectsQueryVariables
  > &
    (
      | {
          variables: Types.InventoryItemsProjectsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventoryItemsProjectsQuery,
    Types.InventoryItemsProjectsQueryVariables
  >(InventoryItemsProjectsDocument, options);
}
export function useInventoryItemsProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventoryItemsProjectsQuery,
    Types.InventoryItemsProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventoryItemsProjectsQuery,
    Types.InventoryItemsProjectsQueryVariables
  >(InventoryItemsProjectsDocument, options);
}
export function useInventoryItemsProjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventoryItemsProjectsQuery,
    Types.InventoryItemsProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventoryItemsProjectsQuery,
    Types.InventoryItemsProjectsQueryVariables
  >(InventoryItemsProjectsDocument, options);
}
export type InventoryItemsProjectsQueryHookResult = ReturnType<
  typeof useInventoryItemsProjectsQuery
>;
export type InventoryItemsProjectsLazyQueryHookResult = ReturnType<
  typeof useInventoryItemsProjectsLazyQuery
>;
export type InventoryItemsProjectsSuspenseQueryHookResult = ReturnType<
  typeof useInventoryItemsProjectsSuspenseQuery
>;
export type InventoryItemsProjectsQueryResult = Apollo.QueryResult<
  Types.InventoryItemsProjectsQuery,
  Types.InventoryItemsProjectsQueryVariables
>;
export const InventoryItemsTopicsDocument = /*#__PURE__*/ gql`
  query InventoryItemsTopics(
    $filters: [JSON!]
    $isManualQuery: Boolean
    $limit: Int
    $offset: Int
    $search: String
    $showHidden: Boolean
    $siteId: String!
    $sort: InventorySortFields
  ) {
    inventoryItems(
      filters: $filters
      isManualQuery: $isManualQuery
      limit: $limit
      mode: "topics"
      offset: $offset
      search: $search
      showHidden: $showHidden
      siteId: $siteId
      sort: $sort
    ) {
      count
      items {
        key
        type
        topic {
          ...InventoryTopic
          topRankingPage
        }
      }
    }
  }
  ${InventoryTopicFragmentDoc}
`;

/**
 * __useInventoryItemsTopicsQuery__
 *
 * To run a query within a React component, call `useInventoryItemsTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemsTopicsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      isManualQuery: // value for 'isManualQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      showHidden: // value for 'showHidden'
 *      siteId: // value for 'siteId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInventoryItemsTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventoryItemsTopicsQuery,
    Types.InventoryItemsTopicsQueryVariables
  > &
    (
      | { variables: Types.InventoryItemsTopicsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventoryItemsTopicsQuery,
    Types.InventoryItemsTopicsQueryVariables
  >(InventoryItemsTopicsDocument, options);
}
export function useInventoryItemsTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventoryItemsTopicsQuery,
    Types.InventoryItemsTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventoryItemsTopicsQuery,
    Types.InventoryItemsTopicsQueryVariables
  >(InventoryItemsTopicsDocument, options);
}
export function useInventoryItemsTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventoryItemsTopicsQuery,
    Types.InventoryItemsTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventoryItemsTopicsQuery,
    Types.InventoryItemsTopicsQueryVariables
  >(InventoryItemsTopicsDocument, options);
}
export type InventoryItemsTopicsQueryHookResult = ReturnType<
  typeof useInventoryItemsTopicsQuery
>;
export type InventoryItemsTopicsLazyQueryHookResult = ReturnType<
  typeof useInventoryItemsTopicsLazyQuery
>;
export type InventoryItemsTopicsSuspenseQueryHookResult = ReturnType<
  typeof useInventoryItemsTopicsSuspenseQuery
>;
export type InventoryItemsTopicsQueryResult = Apollo.QueryResult<
  Types.InventoryItemsTopicsQuery,
  Types.InventoryItemsTopicsQueryVariables
>;
export const InventoryPageSuggestionsDocument = /*#__PURE__*/ gql`
  query InventoryPageSuggestions(
    $search: String
    $siteId: String!
    $sort: InventorySortFields
  ) {
    inventoryItems(
      mode: "pages"
      search: $search
      showHidden: false
      siteId: $siteId
      sort: $sort
      limit: 10
    ) {
      count
      items {
        key
        type
        page {
          id
          title
          url
        }
      }
    }
  }
`;

/**
 * __useInventoryPageSuggestionsQuery__
 *
 * To run a query within a React component, call `useInventoryPageSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryPageSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryPageSuggestionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      siteId: // value for 'siteId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInventoryPageSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventoryPageSuggestionsQuery,
    Types.InventoryPageSuggestionsQueryVariables
  > &
    (
      | {
          variables: Types.InventoryPageSuggestionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventoryPageSuggestionsQuery,
    Types.InventoryPageSuggestionsQueryVariables
  >(InventoryPageSuggestionsDocument, options);
}
export function useInventoryPageSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventoryPageSuggestionsQuery,
    Types.InventoryPageSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventoryPageSuggestionsQuery,
    Types.InventoryPageSuggestionsQueryVariables
  >(InventoryPageSuggestionsDocument, options);
}
export function useInventoryPageSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventoryPageSuggestionsQuery,
    Types.InventoryPageSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventoryPageSuggestionsQuery,
    Types.InventoryPageSuggestionsQueryVariables
  >(InventoryPageSuggestionsDocument, options);
}
export type InventoryPageSuggestionsQueryHookResult = ReturnType<
  typeof useInventoryPageSuggestionsQuery
>;
export type InventoryPageSuggestionsLazyQueryHookResult = ReturnType<
  typeof useInventoryPageSuggestionsLazyQuery
>;
export type InventoryPageSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useInventoryPageSuggestionsSuspenseQuery
>;
export type InventoryPageSuggestionsQueryResult = Apollo.QueryResult<
  Types.InventoryPageSuggestionsQuery,
  Types.InventoryPageSuggestionsQueryVariables
>;
export const InventorySeoTopicsDocument = /*#__PURE__*/ gql`
  query InventorySeoTopics($terms: [String!]!, $siteId: String!, $limit: Int) {
    inventoryItems(
      mode: "topics"
      offset: 0
      search: ""
      showHidden: false
      sort: { table: "topics", direction: ASC, field: "term" }
      siteId: $siteId
      limit: $limit
      filters: [
        {
          field: "topics.term"
          operand: "find_in_set"
          qualifier: "and"
          value: $terms
        }
      ]
    ) {
      count
      items {
        key
        type
        topic {
          term
          topRankingPage
          topRankingPageTitle
          maxRank
          mmPersonalizedDifficulty
          mmPersonalizedAdvantage
        }
      }
    }
  }
`;

/**
 * __useInventorySeoTopicsQuery__
 *
 * To run a query within a React component, call `useInventorySeoTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventorySeoTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventorySeoTopicsQuery({
 *   variables: {
 *      terms: // value for 'terms'
 *      siteId: // value for 'siteId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInventorySeoTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventorySeoTopicsQuery,
    Types.InventorySeoTopicsQueryVariables
  > &
    (
      | { variables: Types.InventorySeoTopicsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventorySeoTopicsQuery,
    Types.InventorySeoTopicsQueryVariables
  >(InventorySeoTopicsDocument, options);
}
export function useInventorySeoTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventorySeoTopicsQuery,
    Types.InventorySeoTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventorySeoTopicsQuery,
    Types.InventorySeoTopicsQueryVariables
  >(InventorySeoTopicsDocument, options);
}
export function useInventorySeoTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventorySeoTopicsQuery,
    Types.InventorySeoTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventorySeoTopicsQuery,
    Types.InventorySeoTopicsQueryVariables
  >(InventorySeoTopicsDocument, options);
}
export type InventorySeoTopicsQueryHookResult = ReturnType<
  typeof useInventorySeoTopicsQuery
>;
export type InventorySeoTopicsLazyQueryHookResult = ReturnType<
  typeof useInventorySeoTopicsLazyQuery
>;
export type InventorySeoTopicsSuspenseQueryHookResult = ReturnType<
  typeof useInventorySeoTopicsSuspenseQuery
>;
export type InventorySeoTopicsQueryResult = Apollo.QueryResult<
  Types.InventorySeoTopicsQuery,
  Types.InventorySeoTopicsQueryVariables
>;
export const InventorySubdomainsDocument = /*#__PURE__*/ gql`
  query InventorySubdomains($siteId: String!, $domain: String!) {
    inventorySubdomains(siteId: $siteId, domain: $domain)
  }
`;

/**
 * __useInventorySubdomainsQuery__
 *
 * To run a query within a React component, call `useInventorySubdomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventorySubdomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventorySubdomainsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useInventorySubdomainsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InventorySubdomainsQuery,
    Types.InventorySubdomainsQueryVariables
  > &
    (
      | { variables: Types.InventorySubdomainsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InventorySubdomainsQuery,
    Types.InventorySubdomainsQueryVariables
  >(InventorySubdomainsDocument, options);
}
export function useInventorySubdomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InventorySubdomainsQuery,
    Types.InventorySubdomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InventorySubdomainsQuery,
    Types.InventorySubdomainsQueryVariables
  >(InventorySubdomainsDocument, options);
}
export function useInventorySubdomainsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.InventorySubdomainsQuery,
    Types.InventorySubdomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.InventorySubdomainsQuery,
    Types.InventorySubdomainsQueryVariables
  >(InventorySubdomainsDocument, options);
}
export type InventorySubdomainsQueryHookResult = ReturnType<
  typeof useInventorySubdomainsQuery
>;
export type InventorySubdomainsLazyQueryHookResult = ReturnType<
  typeof useInventorySubdomainsLazyQuery
>;
export type InventorySubdomainsSuspenseQueryHookResult = ReturnType<
  typeof useInventorySubdomainsSuspenseQuery
>;
export type InventorySubdomainsQueryResult = Apollo.QueryResult<
  Types.InventorySubdomainsQuery,
  Types.InventorySubdomainsQueryVariables
>;
export const GetInventoryVersionDocument = /*#__PURE__*/ gql`
  query GetInventoryVersion($siteId: String!) {
    inventoryVersion(siteId: $siteId) {
      ...InventoryVersionFields
    }
  }
  ${InventoryVersionFieldsFragmentDoc}
`;

/**
 * __useGetInventoryVersionQuery__
 *
 * To run a query within a React component, call `useGetInventoryVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryVersionQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetInventoryVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetInventoryVersionQuery,
    Types.GetInventoryVersionQueryVariables
  > &
    (
      | { variables: Types.GetInventoryVersionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetInventoryVersionQuery,
    Types.GetInventoryVersionQueryVariables
  >(GetInventoryVersionDocument, options);
}
export function useGetInventoryVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetInventoryVersionQuery,
    Types.GetInventoryVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetInventoryVersionQuery,
    Types.GetInventoryVersionQueryVariables
  >(GetInventoryVersionDocument, options);
}
export function useGetInventoryVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetInventoryVersionQuery,
    Types.GetInventoryVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetInventoryVersionQuery,
    Types.GetInventoryVersionQueryVariables
  >(GetInventoryVersionDocument, options);
}
export type GetInventoryVersionQueryHookResult = ReturnType<
  typeof useGetInventoryVersionQuery
>;
export type GetInventoryVersionLazyQueryHookResult = ReturnType<
  typeof useGetInventoryVersionLazyQuery
>;
export type GetInventoryVersionSuspenseQueryHookResult = ReturnType<
  typeof useGetInventoryVersionSuspenseQuery
>;
export type GetInventoryVersionQueryResult = Apollo.QueryResult<
  Types.GetInventoryVersionQuery,
  Types.GetInventoryVersionQueryVariables
>;
export const GetInventoryVersionsDocument = /*#__PURE__*/ gql`
  query GetInventoryVersions(
    $siteId: String!
    $startTime: DateTimeWithUnixTimeStamp!
  ) {
    inventoryVersions(siteId: $siteId, startTime: $startTime) {
      ...InventoryVersionFields
    }
  }
  ${InventoryVersionFieldsFragmentDoc}
`;

/**
 * __useGetInventoryVersionsQuery__
 *
 * To run a query within a React component, call `useGetInventoryVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryVersionsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useGetInventoryVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetInventoryVersionsQuery,
    Types.GetInventoryVersionsQueryVariables
  > &
    (
      | { variables: Types.GetInventoryVersionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetInventoryVersionsQuery,
    Types.GetInventoryVersionsQueryVariables
  >(GetInventoryVersionsDocument, options);
}
export function useGetInventoryVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetInventoryVersionsQuery,
    Types.GetInventoryVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetInventoryVersionsQuery,
    Types.GetInventoryVersionsQueryVariables
  >(GetInventoryVersionsDocument, options);
}
export function useGetInventoryVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetInventoryVersionsQuery,
    Types.GetInventoryVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetInventoryVersionsQuery,
    Types.GetInventoryVersionsQueryVariables
  >(GetInventoryVersionsDocument, options);
}
export type GetInventoryVersionsQueryHookResult = ReturnType<
  typeof useGetInventoryVersionsQuery
>;
export type GetInventoryVersionsLazyQueryHookResult = ReturnType<
  typeof useGetInventoryVersionsLazyQuery
>;
export type GetInventoryVersionsSuspenseQueryHookResult = ReturnType<
  typeof useGetInventoryVersionsSuspenseQuery
>;
export type GetInventoryVersionsQueryResult = Apollo.QueryResult<
  Types.GetInventoryVersionsQuery,
  Types.GetInventoryVersionsQueryVariables
>;
export const GetOrgDocument = /*#__PURE__*/ gql`
  query GetOrg($id: String!) {
    organization(id: $id) {
      ...OrganizationFields
      sites {
        ...SiteFields
      }
      users {
        ...UserFields
      }
      subscription {
        id
      }
      documentAllotment {
        ...DocumentsAllotmentFields
      }
    }
  }
  ${OrganizationFieldsFragmentDoc}
  ${SiteFieldsFragmentDoc}
  ${UserFieldsFragmentDoc}
  ${DocumentsAllotmentFieldsFragmentDoc}
`;

/**
 * __useGetOrgQuery__
 *
 * To run a query within a React component, call `useGetOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrgQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetOrgQuery,
    Types.GetOrgQueryVariables
  > &
    (
      | { variables: Types.GetOrgQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetOrgQuery, Types.GetOrgQueryVariables>(
    GetOrgDocument,
    options,
  );
}
export function useGetOrgLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetOrgQuery,
    Types.GetOrgQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetOrgQuery, Types.GetOrgQueryVariables>(
    GetOrgDocument,
    options,
  );
}
export function useGetOrgSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetOrgQuery,
    Types.GetOrgQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetOrgQuery, Types.GetOrgQueryVariables>(
    GetOrgDocument,
    options,
  );
}
export type GetOrgQueryHookResult = ReturnType<typeof useGetOrgQuery>;
export type GetOrgLazyQueryHookResult = ReturnType<typeof useGetOrgLazyQuery>;
export type GetOrgSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgSuspenseQuery
>;
export type GetOrgQueryResult = Apollo.QueryResult<
  Types.GetOrgQuery,
  Types.GetOrgQueryVariables
>;
export const OrganizationCountsDocument = /*#__PURE__*/ gql`
  query OrganizationCounts($id: String!) {
    organization(id: $id) {
      maxUsers
      topicsAllocated
      topicsMax
      documentAllotment {
        ...DocumentsAllotmentFields
      }
      sites {
        ...SiteFieldsBase
        topicsAllocated
      }
    }
  }
  ${DocumentsAllotmentFieldsFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
`;

/**
 * __useOrganizationCountsQuery__
 *
 * To run a query within a React component, call `useOrganizationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.OrganizationCountsQuery,
    Types.OrganizationCountsQueryVariables
  > &
    (
      | { variables: Types.OrganizationCountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.OrganizationCountsQuery,
    Types.OrganizationCountsQueryVariables
  >(OrganizationCountsDocument, options);
}
export function useOrganizationCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrganizationCountsQuery,
    Types.OrganizationCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.OrganizationCountsQuery,
    Types.OrganizationCountsQueryVariables
  >(OrganizationCountsDocument, options);
}
export function useOrganizationCountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.OrganizationCountsQuery,
    Types.OrganizationCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.OrganizationCountsQuery,
    Types.OrganizationCountsQueryVariables
  >(OrganizationCountsDocument, options);
}
export type OrganizationCountsQueryHookResult = ReturnType<
  typeof useOrganizationCountsQuery
>;
export type OrganizationCountsLazyQueryHookResult = ReturnType<
  typeof useOrganizationCountsLazyQuery
>;
export type OrganizationCountsSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationCountsSuspenseQuery
>;
export type OrganizationCountsQueryResult = Apollo.QueryResult<
  Types.OrganizationCountsQuery,
  Types.OrganizationCountsQueryVariables
>;
export const GetOrgsDocument = /*#__PURE__*/ gql`
  query GetOrgs(
    $filters: [OrganizationFilter!]
    $limit: Int
    $order: String
    $page: Int
  ) {
    organizations(
      filters: $filters
      order: $order
      limit: $limit
      page: $page
    ) {
      count
      items {
        id
        name
        slug
        clientTier
        createdAt
        selfReportOrdering
        sfdcAccountId
        users {
          ...UserFieldsBase
        }
        sites {
          ...SiteFieldsBase
        }
      }
    }
  }
  ${UserFieldsBaseFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
`;

/**
 * __useGetOrgsQuery__
 *
 * To run a query within a React component, call `useGetOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetOrgsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetOrgsQuery,
    Types.GetOrgsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetOrgsQuery, Types.GetOrgsQueryVariables>(
    GetOrgsDocument,
    options,
  );
}
export function useGetOrgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetOrgsQuery,
    Types.GetOrgsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetOrgsQuery, Types.GetOrgsQueryVariables>(
    GetOrgsDocument,
    options,
  );
}
export function useGetOrgsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetOrgsQuery,
    Types.GetOrgsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetOrgsQuery,
    Types.GetOrgsQueryVariables
  >(GetOrgsDocument, options);
}
export type GetOrgsQueryHookResult = ReturnType<typeof useGetOrgsQuery>;
export type GetOrgsLazyQueryHookResult = ReturnType<typeof useGetOrgsLazyQuery>;
export type GetOrgsSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgsSuspenseQuery
>;
export type GetOrgsQueryResult = Apollo.QueryResult<
  Types.GetOrgsQuery,
  Types.GetOrgsQueryVariables
>;
export const PermissionsDocument = /*#__PURE__*/ gql`
  query Permissions($siteId: String!) {
    permissions(siteId: $siteId) {
      resource
      action
      status
    }
  }
`;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function usePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PermissionsQuery,
    Types.PermissionsQueryVariables
  > &
    (
      | { variables: Types.PermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PermissionsQuery,
    Types.PermissionsQueryVariables
  >(PermissionsDocument, options);
}
export function usePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PermissionsQuery,
    Types.PermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PermissionsQuery,
    Types.PermissionsQueryVariables
  >(PermissionsDocument, options);
}
export function usePermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.PermissionsQuery,
    Types.PermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.PermissionsQuery,
    Types.PermissionsQueryVariables
  >(PermissionsDocument, options);
}
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<
  typeof usePermissionsLazyQuery
>;
export type PermissionsSuspenseQueryHookResult = ReturnType<
  typeof usePermissionsSuspenseQuery
>;
export type PermissionsQueryResult = Apollo.QueryResult<
  Types.PermissionsQuery,
  Types.PermissionsQueryVariables
>;
export const PermissionsEntityAdminDocument = /*#__PURE__*/ gql`
  query PermissionsEntityAdmin($entityId: String!, $scope: PermissionScope!) {
    permissionsEntityAdmin(entityId: $entityId, scope: $scope) {
      permissions {
        resource
        action
        status
      }
      resourceActionPairs {
        resource
        action
      }
    }
  }
`;

/**
 * __usePermissionsEntityAdminQuery__
 *
 * To run a query within a React component, call `usePermissionsEntityAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsEntityAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsEntityAdminQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function usePermissionsEntityAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PermissionsEntityAdminQuery,
    Types.PermissionsEntityAdminQueryVariables
  > &
    (
      | {
          variables: Types.PermissionsEntityAdminQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PermissionsEntityAdminQuery,
    Types.PermissionsEntityAdminQueryVariables
  >(PermissionsEntityAdminDocument, options);
}
export function usePermissionsEntityAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PermissionsEntityAdminQuery,
    Types.PermissionsEntityAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PermissionsEntityAdminQuery,
    Types.PermissionsEntityAdminQueryVariables
  >(PermissionsEntityAdminDocument, options);
}
export function usePermissionsEntityAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.PermissionsEntityAdminQuery,
    Types.PermissionsEntityAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.PermissionsEntityAdminQuery,
    Types.PermissionsEntityAdminQueryVariables
  >(PermissionsEntityAdminDocument, options);
}
export type PermissionsEntityAdminQueryHookResult = ReturnType<
  typeof usePermissionsEntityAdminQuery
>;
export type PermissionsEntityAdminLazyQueryHookResult = ReturnType<
  typeof usePermissionsEntityAdminLazyQuery
>;
export type PermissionsEntityAdminSuspenseQueryHookResult = ReturnType<
  typeof usePermissionsEntityAdminSuspenseQuery
>;
export type PermissionsEntityAdminQueryResult = Apollo.QueryResult<
  Types.PermissionsEntityAdminQuery,
  Types.PermissionsEntityAdminQueryVariables
>;
export const RecurlyGetAccountDocument = /*#__PURE__*/ gql`
  query RecurlyGetAccount($accountCode: String!) {
    recurlyGetAccount(accountCode: $accountCode) {
      ...RecurlyAccountFields
      address {
        ...RecurlyAddressFields
      }
      billingInfo {
        ...RecurlyBillingInfoFields
      }
      shippingAddresses {
        ...RecurlyShippingAddress
      }
      customFields {
        name
        value
      }
    }
  }
  ${RecurlyAccountFieldsFragmentDoc}
  ${RecurlyAddressFieldsFragmentDoc}
  ${RecurlyBillingInfoFieldsFragmentDoc}
  ${RecurlyShippingAddressFragmentDoc}
`;

/**
 * __useRecurlyGetAccountQuery__
 *
 * To run a query within a React component, call `useRecurlyGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurlyGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurlyGetAccountQuery({
 *   variables: {
 *      accountCode: // value for 'accountCode'
 *   },
 * });
 */
export function useRecurlyGetAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.RecurlyGetAccountQuery,
    Types.RecurlyGetAccountQueryVariables
  > &
    (
      | { variables: Types.RecurlyGetAccountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.RecurlyGetAccountQuery,
    Types.RecurlyGetAccountQueryVariables
  >(RecurlyGetAccountDocument, options);
}
export function useRecurlyGetAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RecurlyGetAccountQuery,
    Types.RecurlyGetAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.RecurlyGetAccountQuery,
    Types.RecurlyGetAccountQueryVariables
  >(RecurlyGetAccountDocument, options);
}
export function useRecurlyGetAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.RecurlyGetAccountQuery,
    Types.RecurlyGetAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.RecurlyGetAccountQuery,
    Types.RecurlyGetAccountQueryVariables
  >(RecurlyGetAccountDocument, options);
}
export type RecurlyGetAccountQueryHookResult = ReturnType<
  typeof useRecurlyGetAccountQuery
>;
export type RecurlyGetAccountLazyQueryHookResult = ReturnType<
  typeof useRecurlyGetAccountLazyQuery
>;
export type RecurlyGetAccountSuspenseQueryHookResult = ReturnType<
  typeof useRecurlyGetAccountSuspenseQuery
>;
export type RecurlyGetAccountQueryResult = Apollo.QueryResult<
  Types.RecurlyGetAccountQuery,
  Types.RecurlyGetAccountQueryVariables
>;
export const RecurlyGetCouponDocument = /*#__PURE__*/ gql`
  query RecurlyGetCoupon($couponId: String!) {
    recurlyGetCoupon(couponId: $couponId) {
      ...RecurlyCouponFields
    }
  }
  ${RecurlyCouponFieldsFragmentDoc}
`;

/**
 * __useRecurlyGetCouponQuery__
 *
 * To run a query within a React component, call `useRecurlyGetCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurlyGetCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurlyGetCouponQuery({
 *   variables: {
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useRecurlyGetCouponQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.RecurlyGetCouponQuery,
    Types.RecurlyGetCouponQueryVariables
  > &
    (
      | { variables: Types.RecurlyGetCouponQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.RecurlyGetCouponQuery,
    Types.RecurlyGetCouponQueryVariables
  >(RecurlyGetCouponDocument, options);
}
export function useRecurlyGetCouponLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RecurlyGetCouponQuery,
    Types.RecurlyGetCouponQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.RecurlyGetCouponQuery,
    Types.RecurlyGetCouponQueryVariables
  >(RecurlyGetCouponDocument, options);
}
export function useRecurlyGetCouponSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.RecurlyGetCouponQuery,
    Types.RecurlyGetCouponQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.RecurlyGetCouponQuery,
    Types.RecurlyGetCouponQueryVariables
  >(RecurlyGetCouponDocument, options);
}
export type RecurlyGetCouponQueryHookResult = ReturnType<
  typeof useRecurlyGetCouponQuery
>;
export type RecurlyGetCouponLazyQueryHookResult = ReturnType<
  typeof useRecurlyGetCouponLazyQuery
>;
export type RecurlyGetCouponSuspenseQueryHookResult = ReturnType<
  typeof useRecurlyGetCouponSuspenseQuery
>;
export type RecurlyGetCouponQueryResult = Apollo.QueryResult<
  Types.RecurlyGetCouponQuery,
  Types.RecurlyGetCouponQueryVariables
>;
export const RecurlyGetSubscriptionsDocument = /*#__PURE__*/ gql`
  query RecurlyGetSubscriptions($accountCode: String!) {
    recurlyGetSubscriptions(accountCode: $accountCode) {
      ...RecurlySubscriptionFields
      account {
        code
        company
        email
        firstName
        lastName
      }
      couponRedemptions {
        coupon {
          code
          couponType
          expiredAt
          id
          name
          object
          state
          discount {
            percent
            trial {
              length
              unit
            }
            type
            currencies {
              amount
              currency
            }
          }
        }
        createdAt
        discounted
        id
        object
        state
      }
      addOns {
        id
        unitAmount
        quantity
        addOn {
          accountingCode
          addOnType
          code
          externalSku
          id
        }
      }
      plan {
        code
        id
        name
        object
      }
    }
  }
  ${RecurlySubscriptionFieldsFragmentDoc}
`;

/**
 * __useRecurlyGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useRecurlyGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurlyGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurlyGetSubscriptionsQuery({
 *   variables: {
 *      accountCode: // value for 'accountCode'
 *   },
 * });
 */
export function useRecurlyGetSubscriptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.RecurlyGetSubscriptionsQuery,
    Types.RecurlyGetSubscriptionsQueryVariables
  > &
    (
      | {
          variables: Types.RecurlyGetSubscriptionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.RecurlyGetSubscriptionsQuery,
    Types.RecurlyGetSubscriptionsQueryVariables
  >(RecurlyGetSubscriptionsDocument, options);
}
export function useRecurlyGetSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RecurlyGetSubscriptionsQuery,
    Types.RecurlyGetSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.RecurlyGetSubscriptionsQuery,
    Types.RecurlyGetSubscriptionsQueryVariables
  >(RecurlyGetSubscriptionsDocument, options);
}
export function useRecurlyGetSubscriptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.RecurlyGetSubscriptionsQuery,
    Types.RecurlyGetSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.RecurlyGetSubscriptionsQuery,
    Types.RecurlyGetSubscriptionsQueryVariables
  >(RecurlyGetSubscriptionsDocument, options);
}
export type RecurlyGetSubscriptionsQueryHookResult = ReturnType<
  typeof useRecurlyGetSubscriptionsQuery
>;
export type RecurlyGetSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useRecurlyGetSubscriptionsLazyQuery
>;
export type RecurlyGetSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useRecurlyGetSubscriptionsSuspenseQuery
>;
export type RecurlyGetSubscriptionsQueryResult = Apollo.QueryResult<
  Types.RecurlyGetSubscriptionsQuery,
  Types.RecurlyGetSubscriptionsQueryVariables
>;
export const RecurlyHydrateStateDocument = /*#__PURE__*/ gql`
  query RecurlyHydrateState($accountCode: String!) {
    recurlyGetAccount(accountCode: $accountCode) {
      ...RecurlyAccountFields
      address {
        ...RecurlyAddressFields
      }
      billingInfo {
        ...RecurlyBillingInfoFields
      }
      shippingAddresses {
        ...RecurlyShippingAddress
      }
      customFields {
        name
        value
      }
    }
    recurlyGetSubscriptions(accountCode: $accountCode) {
      ...RecurlySubscriptionFields
      account {
        code
        company
        email
        firstName
        lastName
      }
      couponRedemptions {
        coupon {
          code
          couponType
          expiredAt
          id
          name
          object
          state
          discount {
            percent
            trial {
              length
              unit
            }
            type
            currencies {
              amount
              currency
            }
          }
        }
        createdAt
        discounted
        id
        object
        state
      }
      addOns {
        id
        unitAmount
        quantity
        addOn {
          accountingCode
          addOnType
          code
          externalSku
          id
        }
      }
      plan {
        code
        id
        name
        object
      }
    }
  }
  ${RecurlyAccountFieldsFragmentDoc}
  ${RecurlyAddressFieldsFragmentDoc}
  ${RecurlyBillingInfoFieldsFragmentDoc}
  ${RecurlyShippingAddressFragmentDoc}
  ${RecurlySubscriptionFieldsFragmentDoc}
`;

/**
 * __useRecurlyHydrateStateQuery__
 *
 * To run a query within a React component, call `useRecurlyHydrateStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurlyHydrateStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurlyHydrateStateQuery({
 *   variables: {
 *      accountCode: // value for 'accountCode'
 *   },
 * });
 */
export function useRecurlyHydrateStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.RecurlyHydrateStateQuery,
    Types.RecurlyHydrateStateQueryVariables
  > &
    (
      | { variables: Types.RecurlyHydrateStateQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.RecurlyHydrateStateQuery,
    Types.RecurlyHydrateStateQueryVariables
  >(RecurlyHydrateStateDocument, options);
}
export function useRecurlyHydrateStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RecurlyHydrateStateQuery,
    Types.RecurlyHydrateStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.RecurlyHydrateStateQuery,
    Types.RecurlyHydrateStateQueryVariables
  >(RecurlyHydrateStateDocument, options);
}
export function useRecurlyHydrateStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.RecurlyHydrateStateQuery,
    Types.RecurlyHydrateStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.RecurlyHydrateStateQuery,
    Types.RecurlyHydrateStateQueryVariables
  >(RecurlyHydrateStateDocument, options);
}
export type RecurlyHydrateStateQueryHookResult = ReturnType<
  typeof useRecurlyHydrateStateQuery
>;
export type RecurlyHydrateStateLazyQueryHookResult = ReturnType<
  typeof useRecurlyHydrateStateLazyQuery
>;
export type RecurlyHydrateStateSuspenseQueryHookResult = ReturnType<
  typeof useRecurlyHydrateStateSuspenseQuery
>;
export type RecurlyHydrateStateQueryResult = Apollo.QueryResult<
  Types.RecurlyHydrateStateQuery,
  Types.RecurlyHydrateStateQueryVariables
>;
export const GetSavedViewsDocument = /*#__PURE__*/ gql`
  query GetSavedViews(
    $siteId: String!
    $filters: [SavedViewFilter!]
    $limit: Int
    $order: String
    $page: Int
  ) {
    savedViews(
      siteId: $siteId
      filters: $filters
      order: $order
      limit: $limit
      page: $page
    ) {
      ...SavedViewFields
      site {
        ...SiteFieldsBase
      }
      createdBy {
        ...UserFieldsBase
      }
      updatedBy {
        ...UserFieldsBase
      }
    }
  }
  ${SavedViewFieldsFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
`;

/**
 * __useGetSavedViewsQuery__
 *
 * To run a query within a React component, call `useGetSavedViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedViewsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetSavedViewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSavedViewsQuery,
    Types.GetSavedViewsQueryVariables
  > &
    (
      | { variables: Types.GetSavedViewsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetSavedViewsQuery,
    Types.GetSavedViewsQueryVariables
  >(GetSavedViewsDocument, options);
}
export function useGetSavedViewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSavedViewsQuery,
    Types.GetSavedViewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetSavedViewsQuery,
    Types.GetSavedViewsQueryVariables
  >(GetSavedViewsDocument, options);
}
export function useGetSavedViewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetSavedViewsQuery,
    Types.GetSavedViewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetSavedViewsQuery,
    Types.GetSavedViewsQueryVariables
  >(GetSavedViewsDocument, options);
}
export type GetSavedViewsQueryHookResult = ReturnType<
  typeof useGetSavedViewsQuery
>;
export type GetSavedViewsLazyQueryHookResult = ReturnType<
  typeof useGetSavedViewsLazyQuery
>;
export type GetSavedViewsSuspenseQueryHookResult = ReturnType<
  typeof useGetSavedViewsSuspenseQuery
>;
export type GetSavedViewsQueryResult = Apollo.QueryResult<
  Types.GetSavedViewsQuery,
  Types.GetSavedViewsQueryVariables
>;
export const GetSavedViewsEachDocument = /*#__PURE__*/ gql`
  query GetSavedViewsEach(
    $siteId: String!
    $each: [InventoryType!]
    $filters: [SavedViewFilter!]
    $limit: Int
    $order: String
    $page: Int
  ) {
    savedViewsEach(
      siteId: $siteId
      each: $each
      filters: $filters
      order: $order
      limit: $limit
      page: $page
    ) {
      inventoryType
      items {
        ...SavedViewFields
        site {
          ...SiteFieldsBase
        }
        createdBy {
          ...UserFieldsBase
        }
        updatedBy {
          ...UserFieldsBase
        }
      }
    }
  }
  ${SavedViewFieldsFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
`;

/**
 * __useGetSavedViewsEachQuery__
 *
 * To run a query within a React component, call `useGetSavedViewsEachQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedViewsEachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedViewsEachQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      each: // value for 'each'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetSavedViewsEachQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSavedViewsEachQuery,
    Types.GetSavedViewsEachQueryVariables
  > &
    (
      | { variables: Types.GetSavedViewsEachQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetSavedViewsEachQuery,
    Types.GetSavedViewsEachQueryVariables
  >(GetSavedViewsEachDocument, options);
}
export function useGetSavedViewsEachLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSavedViewsEachQuery,
    Types.GetSavedViewsEachQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetSavedViewsEachQuery,
    Types.GetSavedViewsEachQueryVariables
  >(GetSavedViewsEachDocument, options);
}
export function useGetSavedViewsEachSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetSavedViewsEachQuery,
    Types.GetSavedViewsEachQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetSavedViewsEachQuery,
    Types.GetSavedViewsEachQueryVariables
  >(GetSavedViewsEachDocument, options);
}
export type GetSavedViewsEachQueryHookResult = ReturnType<
  typeof useGetSavedViewsEachQuery
>;
export type GetSavedViewsEachLazyQueryHookResult = ReturnType<
  typeof useGetSavedViewsEachLazyQuery
>;
export type GetSavedViewsEachSuspenseQueryHookResult = ReturnType<
  typeof useGetSavedViewsEachSuspenseQuery
>;
export type GetSavedViewsEachQueryResult = Apollo.QueryResult<
  Types.GetSavedViewsEachQuery,
  Types.GetSavedViewsEachQueryVariables
>;
export const GetSeoAdwordsKeywordsDocument = /*#__PURE__*/ gql`
  query getSeoAdwordsKeywords(
    $country: Country!
    $language: Language!
    $term: String!
  ) {
    seoAdwordsKeywords(country: $country, language: $language, term: $term) {
      ...AdWordsItemFields
    }
  }
  ${AdWordsItemFieldsFragmentDoc}
`;

/**
 * __useGetSeoAdwordsKeywordsQuery__
 *
 * To run a query within a React component, call `useGetSeoAdwordsKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoAdwordsKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoAdwordsKeywordsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetSeoAdwordsKeywordsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSeoAdwordsKeywordsQuery,
    Types.GetSeoAdwordsKeywordsQueryVariables
  > &
    (
      | { variables: Types.GetSeoAdwordsKeywordsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetSeoAdwordsKeywordsQuery,
    Types.GetSeoAdwordsKeywordsQueryVariables
  >(GetSeoAdwordsKeywordsDocument, options);
}
export function useGetSeoAdwordsKeywordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSeoAdwordsKeywordsQuery,
    Types.GetSeoAdwordsKeywordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetSeoAdwordsKeywordsQuery,
    Types.GetSeoAdwordsKeywordsQueryVariables
  >(GetSeoAdwordsKeywordsDocument, options);
}
export function useGetSeoAdwordsKeywordsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetSeoAdwordsKeywordsQuery,
    Types.GetSeoAdwordsKeywordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetSeoAdwordsKeywordsQuery,
    Types.GetSeoAdwordsKeywordsQueryVariables
  >(GetSeoAdwordsKeywordsDocument, options);
}
export type GetSeoAdwordsKeywordsQueryHookResult = ReturnType<
  typeof useGetSeoAdwordsKeywordsQuery
>;
export type GetSeoAdwordsKeywordsLazyQueryHookResult = ReturnType<
  typeof useGetSeoAdwordsKeywordsLazyQuery
>;
export type GetSeoAdwordsKeywordsSuspenseQueryHookResult = ReturnType<
  typeof useGetSeoAdwordsKeywordsSuspenseQuery
>;
export type GetSeoAdwordsKeywordsQueryResult = Apollo.QueryResult<
  Types.GetSeoAdwordsKeywordsQuery,
  Types.GetSeoAdwordsKeywordsQueryVariables
>;
export const GetSeoAdwordsQuestionsDocument = /*#__PURE__*/ gql`
  query getSeoAdwordsQuestions(
    $country: Country!
    $language: Language!
    $term: String!
  ) {
    seoAdwordsQuestions(country: $country, language: $language, term: $term) {
      ...AdWordsItemFields
    }
  }
  ${AdWordsItemFieldsFragmentDoc}
`;

/**
 * __useGetSeoAdwordsQuestionsQuery__
 *
 * To run a query within a React component, call `useGetSeoAdwordsQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoAdwordsQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoAdwordsQuestionsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetSeoAdwordsQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSeoAdwordsQuestionsQuery,
    Types.GetSeoAdwordsQuestionsQueryVariables
  > &
    (
      | {
          variables: Types.GetSeoAdwordsQuestionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetSeoAdwordsQuestionsQuery,
    Types.GetSeoAdwordsQuestionsQueryVariables
  >(GetSeoAdwordsQuestionsDocument, options);
}
export function useGetSeoAdwordsQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSeoAdwordsQuestionsQuery,
    Types.GetSeoAdwordsQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetSeoAdwordsQuestionsQuery,
    Types.GetSeoAdwordsQuestionsQueryVariables
  >(GetSeoAdwordsQuestionsDocument, options);
}
export function useGetSeoAdwordsQuestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetSeoAdwordsQuestionsQuery,
    Types.GetSeoAdwordsQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetSeoAdwordsQuestionsQuery,
    Types.GetSeoAdwordsQuestionsQueryVariables
  >(GetSeoAdwordsQuestionsDocument, options);
}
export type GetSeoAdwordsQuestionsQueryHookResult = ReturnType<
  typeof useGetSeoAdwordsQuestionsQuery
>;
export type GetSeoAdwordsQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetSeoAdwordsQuestionsLazyQuery
>;
export type GetSeoAdwordsQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetSeoAdwordsQuestionsSuspenseQuery
>;
export type GetSeoAdwordsQuestionsQueryResult = Apollo.QueryResult<
  Types.GetSeoAdwordsQuestionsQuery,
  Types.GetSeoAdwordsQuestionsQueryVariables
>;
export const SeoBulkAdwordsKeywordsCompleteDocument = /*#__PURE__*/ gql`
  query SeoBulkAdwordsKeywordsComplete(
    $terms: [String!]!
    $country: Country!
    $language: Language!
  ) {
    seoBulkAdwordsKeywords(
      terms: $terms
      country: $country
      language: $language
    ) {
      term
      volume
      costPerClick
      history {
        ...HistoryFields
      }
      variants {
        term
        volume
        costPerClick
      }
    }
  }
  ${HistoryFieldsFragmentDoc}
`;

/**
 * __useSeoBulkAdwordsKeywordsCompleteQuery__
 *
 * To run a query within a React component, call `useSeoBulkAdwordsKeywordsCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoBulkAdwordsKeywordsCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoBulkAdwordsKeywordsCompleteQuery({
 *   variables: {
 *      terms: // value for 'terms'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSeoBulkAdwordsKeywordsCompleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoBulkAdwordsKeywordsCompleteQuery,
    Types.SeoBulkAdwordsKeywordsCompleteQueryVariables
  > &
    (
      | {
          variables: Types.SeoBulkAdwordsKeywordsCompleteQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoBulkAdwordsKeywordsCompleteQuery,
    Types.SeoBulkAdwordsKeywordsCompleteQueryVariables
  >(SeoBulkAdwordsKeywordsCompleteDocument, options);
}
export function useSeoBulkAdwordsKeywordsCompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoBulkAdwordsKeywordsCompleteQuery,
    Types.SeoBulkAdwordsKeywordsCompleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoBulkAdwordsKeywordsCompleteQuery,
    Types.SeoBulkAdwordsKeywordsCompleteQueryVariables
  >(SeoBulkAdwordsKeywordsCompleteDocument, options);
}
export function useSeoBulkAdwordsKeywordsCompleteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoBulkAdwordsKeywordsCompleteQuery,
    Types.SeoBulkAdwordsKeywordsCompleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoBulkAdwordsKeywordsCompleteQuery,
    Types.SeoBulkAdwordsKeywordsCompleteQueryVariables
  >(SeoBulkAdwordsKeywordsCompleteDocument, options);
}
export type SeoBulkAdwordsKeywordsCompleteQueryHookResult = ReturnType<
  typeof useSeoBulkAdwordsKeywordsCompleteQuery
>;
export type SeoBulkAdwordsKeywordsCompleteLazyQueryHookResult = ReturnType<
  typeof useSeoBulkAdwordsKeywordsCompleteLazyQuery
>;
export type SeoBulkAdwordsKeywordsCompleteSuspenseQueryHookResult = ReturnType<
  typeof useSeoBulkAdwordsKeywordsCompleteSuspenseQuery
>;
export type SeoBulkAdwordsKeywordsCompleteQueryResult = Apollo.QueryResult<
  Types.SeoBulkAdwordsKeywordsCompleteQuery,
  Types.SeoBulkAdwordsKeywordsCompleteQueryVariables
>;
export const SeoBulkAdwordsKeywordsMinimalDocument = /*#__PURE__*/ gql`
  query SeoBulkAdwordsKeywordsMinimal(
    $terms: [String!]!
    $country: Country!
    $language: Language!
  ) {
    seoBulkAdwordsKeywords(
      terms: $terms
      country: $country
      language: $language
    ) {
      term
      variants {
        term
      }
    }
  }
`;

/**
 * __useSeoBulkAdwordsKeywordsMinimalQuery__
 *
 * To run a query within a React component, call `useSeoBulkAdwordsKeywordsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoBulkAdwordsKeywordsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoBulkAdwordsKeywordsMinimalQuery({
 *   variables: {
 *      terms: // value for 'terms'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSeoBulkAdwordsKeywordsMinimalQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoBulkAdwordsKeywordsMinimalQuery,
    Types.SeoBulkAdwordsKeywordsMinimalQueryVariables
  > &
    (
      | {
          variables: Types.SeoBulkAdwordsKeywordsMinimalQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoBulkAdwordsKeywordsMinimalQuery,
    Types.SeoBulkAdwordsKeywordsMinimalQueryVariables
  >(SeoBulkAdwordsKeywordsMinimalDocument, options);
}
export function useSeoBulkAdwordsKeywordsMinimalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoBulkAdwordsKeywordsMinimalQuery,
    Types.SeoBulkAdwordsKeywordsMinimalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoBulkAdwordsKeywordsMinimalQuery,
    Types.SeoBulkAdwordsKeywordsMinimalQueryVariables
  >(SeoBulkAdwordsKeywordsMinimalDocument, options);
}
export function useSeoBulkAdwordsKeywordsMinimalSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoBulkAdwordsKeywordsMinimalQuery,
    Types.SeoBulkAdwordsKeywordsMinimalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoBulkAdwordsKeywordsMinimalQuery,
    Types.SeoBulkAdwordsKeywordsMinimalQueryVariables
  >(SeoBulkAdwordsKeywordsMinimalDocument, options);
}
export type SeoBulkAdwordsKeywordsMinimalQueryHookResult = ReturnType<
  typeof useSeoBulkAdwordsKeywordsMinimalQuery
>;
export type SeoBulkAdwordsKeywordsMinimalLazyQueryHookResult = ReturnType<
  typeof useSeoBulkAdwordsKeywordsMinimalLazyQuery
>;
export type SeoBulkAdwordsKeywordsMinimalSuspenseQueryHookResult = ReturnType<
  typeof useSeoBulkAdwordsKeywordsMinimalSuspenseQuery
>;
export type SeoBulkAdwordsKeywordsMinimalQueryResult = Apollo.QueryResult<
  Types.SeoBulkAdwordsKeywordsMinimalQuery,
  Types.SeoBulkAdwordsKeywordsMinimalQueryVariables
>;
export const SeoConnectDocument = /*#__PURE__*/ gql`
  query seoConnect(
    $term: String!
    $domain: String!
    $country: Country!
    $language: Language!
    $competitorDomains: [String!]
    $networkDomains: [String!]
  ) {
    seoConnect(
      term: $term
      domain: $domain
      country: $country
      language: $language
      competitorSites: $competitorDomains
      networkSites: $networkDomains
    ) {
      internalLinkingRecommendations {
        term
        recommendations {
          url
          title
        }
      }
      externalLinkingRecommendations {
        term
        recommendations {
          url
          title
        }
      }
      networkLinkingRecommendations {
        term
        recommendations {
          url
          title
        }
      }
      competitionLinkingRecommendations {
        term
        recommendations {
          url
          title
        }
      }
    }
  }
`;

/**
 * __useSeoConnectQuery__
 *
 * To run a query within a React component, call `useSeoConnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoConnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoConnectQuery({
 *   variables: {
 *      term: // value for 'term'
 *      domain: // value for 'domain'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      competitorDomains: // value for 'competitorDomains'
 *      networkDomains: // value for 'networkDomains'
 *   },
 * });
 */
export function useSeoConnectQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoConnectQuery,
    Types.SeoConnectQueryVariables
  > &
    (
      | { variables: Types.SeoConnectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.SeoConnectQuery, Types.SeoConnectQueryVariables>(
    SeoConnectDocument,
    options,
  );
}
export function useSeoConnectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoConnectQuery,
    Types.SeoConnectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoConnectQuery,
    Types.SeoConnectQueryVariables
  >(SeoConnectDocument, options);
}
export function useSeoConnectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoConnectQuery,
    Types.SeoConnectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoConnectQuery,
    Types.SeoConnectQueryVariables
  >(SeoConnectDocument, options);
}
export type SeoConnectQueryHookResult = ReturnType<typeof useSeoConnectQuery>;
export type SeoConnectLazyQueryHookResult = ReturnType<
  typeof useSeoConnectLazyQuery
>;
export type SeoConnectSuspenseQueryHookResult = ReturnType<
  typeof useSeoConnectSuspenseQuery
>;
export type SeoConnectQueryResult = Apollo.QueryResult<
  Types.SeoConnectQuery,
  Types.SeoConnectQueryVariables
>;
export const SeoKnowledgeGraphCompleteDocument = /*#__PURE__*/ gql`
  query SeoKnowledgeGraphComplete(
    $country: Country!
    $language: Language!
    $term: String!
    $url: String = null
    $skipPageScrapping: Boolean
  ) {
    seoKnowledgeGraph(
      term: $term
      url: $url
      country: $country
      language: $language
      skipPageScrapping: $skipPageScrapping
    ) {
      knowledgeGraphItems {
        term
        recommendedMentions
        userProvidedPageMentions
      }
      metrics {
        targetWordCount
        averageWordCount
        highestWordCount
        targetContentScore
        averageContentScore
        highestContentScore
      }
      organicSerpItemPagesKgData {
        ...OrganicSerpItemPageKgDataFields
        title
        wordCount
      }
      userProvidedPage {
        ...OrganicSerpItemPageKgDataFields
        title
        wordCount
      }
    }
  }
  ${OrganicSerpItemPageKgDataFieldsFragmentDoc}
`;

/**
 * __useSeoKnowledgeGraphCompleteQuery__
 *
 * To run a query within a React component, call `useSeoKnowledgeGraphCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoKnowledgeGraphCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoKnowledgeGraphCompleteQuery({
 *   variables: {
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      term: // value for 'term'
 *      url: // value for 'url'
 *      skipPageScrapping: // value for 'skipPageScrapping'
 *   },
 * });
 */
export function useSeoKnowledgeGraphCompleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoKnowledgeGraphCompleteQuery,
    Types.SeoKnowledgeGraphCompleteQueryVariables
  > &
    (
      | {
          variables: Types.SeoKnowledgeGraphCompleteQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoKnowledgeGraphCompleteQuery,
    Types.SeoKnowledgeGraphCompleteQueryVariables
  >(SeoKnowledgeGraphCompleteDocument, options);
}
export function useSeoKnowledgeGraphCompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoKnowledgeGraphCompleteQuery,
    Types.SeoKnowledgeGraphCompleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoKnowledgeGraphCompleteQuery,
    Types.SeoKnowledgeGraphCompleteQueryVariables
  >(SeoKnowledgeGraphCompleteDocument, options);
}
export function useSeoKnowledgeGraphCompleteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoKnowledgeGraphCompleteQuery,
    Types.SeoKnowledgeGraphCompleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoKnowledgeGraphCompleteQuery,
    Types.SeoKnowledgeGraphCompleteQueryVariables
  >(SeoKnowledgeGraphCompleteDocument, options);
}
export type SeoKnowledgeGraphCompleteQueryHookResult = ReturnType<
  typeof useSeoKnowledgeGraphCompleteQuery
>;
export type SeoKnowledgeGraphCompleteLazyQueryHookResult = ReturnType<
  typeof useSeoKnowledgeGraphCompleteLazyQuery
>;
export type SeoKnowledgeGraphCompleteSuspenseQueryHookResult = ReturnType<
  typeof useSeoKnowledgeGraphCompleteSuspenseQuery
>;
export type SeoKnowledgeGraphCompleteQueryResult = Apollo.QueryResult<
  Types.SeoKnowledgeGraphCompleteQuery,
  Types.SeoKnowledgeGraphCompleteQueryVariables
>;
export const SeoKnowledgeGraphResearchDocument = /*#__PURE__*/ gql`
  query SeoKnowledgeGraphResearch(
    $country: Country!
    $language: Language!
    $term: String!
    $url: String = null
    $skipPageScrapping: Boolean
  ) {
    seoKnowledgeGraph(
      term: $term
      url: $url
      country: $country
      language: $language
      skipPageScrapping: $skipPageScrapping
    ) {
      knowledgeGraphItems {
        ...KGItem
      }
      metrics {
        targetWordCount
        targetContentScore
        averageContentScore
        highestContentScore
      }
      organicSerpItemPagesKgData {
        ...OrganicSerpItemPageKgDataFields
      }
      userProvidedPage {
        ...OrganicSerpItemPageKgDataFields
      }
    }
  }
  ${KgItemFragmentDoc}
  ${OrganicSerpItemPageKgDataFieldsFragmentDoc}
`;

/**
 * __useSeoKnowledgeGraphResearchQuery__
 *
 * To run a query within a React component, call `useSeoKnowledgeGraphResearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoKnowledgeGraphResearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoKnowledgeGraphResearchQuery({
 *   variables: {
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      term: // value for 'term'
 *      url: // value for 'url'
 *      skipPageScrapping: // value for 'skipPageScrapping'
 *   },
 * });
 */
export function useSeoKnowledgeGraphResearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoKnowledgeGraphResearchQuery,
    Types.SeoKnowledgeGraphResearchQueryVariables
  > &
    (
      | {
          variables: Types.SeoKnowledgeGraphResearchQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoKnowledgeGraphResearchQuery,
    Types.SeoKnowledgeGraphResearchQueryVariables
  >(SeoKnowledgeGraphResearchDocument, options);
}
export function useSeoKnowledgeGraphResearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoKnowledgeGraphResearchQuery,
    Types.SeoKnowledgeGraphResearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoKnowledgeGraphResearchQuery,
    Types.SeoKnowledgeGraphResearchQueryVariables
  >(SeoKnowledgeGraphResearchDocument, options);
}
export function useSeoKnowledgeGraphResearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoKnowledgeGraphResearchQuery,
    Types.SeoKnowledgeGraphResearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoKnowledgeGraphResearchQuery,
    Types.SeoKnowledgeGraphResearchQueryVariables
  >(SeoKnowledgeGraphResearchDocument, options);
}
export type SeoKnowledgeGraphResearchQueryHookResult = ReturnType<
  typeof useSeoKnowledgeGraphResearchQuery
>;
export type SeoKnowledgeGraphResearchLazyQueryHookResult = ReturnType<
  typeof useSeoKnowledgeGraphResearchLazyQuery
>;
export type SeoKnowledgeGraphResearchSuspenseQueryHookResult = ReturnType<
  typeof useSeoKnowledgeGraphResearchSuspenseQuery
>;
export type SeoKnowledgeGraphResearchQueryResult = Apollo.QueryResult<
  Types.SeoKnowledgeGraphResearchQuery,
  Types.SeoKnowledgeGraphResearchQueryVariables
>;
export const SeoPageProcessorDocument = /*#__PURE__*/ gql`
  query SeoPageProcessor($url: String!) {
    seoPageProcessor(url: $url) {
      html
      statusCode
      url
    }
  }
`;

/**
 * __useSeoPageProcessorQuery__
 *
 * To run a query within a React component, call `useSeoPageProcessorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoPageProcessorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoPageProcessorQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSeoPageProcessorQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoPageProcessorQuery,
    Types.SeoPageProcessorQueryVariables
  > &
    (
      | { variables: Types.SeoPageProcessorQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoPageProcessorQuery,
    Types.SeoPageProcessorQueryVariables
  >(SeoPageProcessorDocument, options);
}
export function useSeoPageProcessorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoPageProcessorQuery,
    Types.SeoPageProcessorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoPageProcessorQuery,
    Types.SeoPageProcessorQueryVariables
  >(SeoPageProcessorDocument, options);
}
export function useSeoPageProcessorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoPageProcessorQuery,
    Types.SeoPageProcessorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoPageProcessorQuery,
    Types.SeoPageProcessorQueryVariables
  >(SeoPageProcessorDocument, options);
}
export type SeoPageProcessorQueryHookResult = ReturnType<
  typeof useSeoPageProcessorQuery
>;
export type SeoPageProcessorLazyQueryHookResult = ReturnType<
  typeof useSeoPageProcessorLazyQuery
>;
export type SeoPageProcessorSuspenseQueryHookResult = ReturnType<
  typeof useSeoPageProcessorSuspenseQuery
>;
export type SeoPageProcessorQueryResult = Apollo.QueryResult<
  Types.SeoPageProcessorQuery,
  Types.SeoPageProcessorQueryVariables
>;
export const SeoSerpDataDocument = /*#__PURE__*/ gql`
  query seoSerpData(
    $term: String!
    $url: URL
    $country: Country!
    $language: Language!
  ) {
    seoSerpData(
      term: $term
      url: $url
      country: $country
      language: $language
    ) {
      serpFeaturesPresent
      userProvidedPage {
        url
        position
        description
        title
      }
      organicSerpItems {
        url
        position
        description
        title
      }
    }
  }
`;

/**
 * __useSeoSerpDataQuery__
 *
 * To run a query within a React component, call `useSeoSerpDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoSerpDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoSerpDataQuery({
 *   variables: {
 *      term: // value for 'term'
 *      url: // value for 'url'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSeoSerpDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoSerpDataQuery,
    Types.SeoSerpDataQueryVariables
  > &
    (
      | { variables: Types.SeoSerpDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoSerpDataQuery,
    Types.SeoSerpDataQueryVariables
  >(SeoSerpDataDocument, options);
}
export function useSeoSerpDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoSerpDataQuery,
    Types.SeoSerpDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoSerpDataQuery,
    Types.SeoSerpDataQueryVariables
  >(SeoSerpDataDocument, options);
}
export function useSeoSerpDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoSerpDataQuery,
    Types.SeoSerpDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoSerpDataQuery,
    Types.SeoSerpDataQueryVariables
  >(SeoSerpDataDocument, options);
}
export type SeoSerpDataQueryHookResult = ReturnType<typeof useSeoSerpDataQuery>;
export type SeoSerpDataLazyQueryHookResult = ReturnType<
  typeof useSeoSerpDataLazyQuery
>;
export type SeoSerpDataSuspenseQueryHookResult = ReturnType<
  typeof useSeoSerpDataSuspenseQuery
>;
export type SeoSerpDataQueryResult = Apollo.QueryResult<
  Types.SeoSerpDataQuery,
  Types.SeoSerpDataQueryVariables
>;
export const SeoSerpPageDataDocument = /*#__PURE__*/ gql`
  query seoSerpPageData(
    $term: String!
    $url: String
    $country: Country!
    $language: Language!
  ) {
    seoSerpPageData(
      term: $term
      url: $url
      country: $country
      language: $language
      returnTopN: 20
    ) {
      userProvidedPage {
        externalLinkCount
        description
        position
        title
        url
        h2Count
        imagesCount
        internalLinkCount
        videoCount
        wordCount
      }
      organicSerpItemPages {
        externalLinkCount
        position
        url
        h2Count
        imagesCount
        internalLinkCount
        videoCount
        wordCount
      }
      organicSerpItemPageAverages {
        externalLinkCount
        h2Count
        imagesCount
        internalLinkCount
        videoCount
        wordCount
      }
    }
  }
`;

/**
 * __useSeoSerpPageDataQuery__
 *
 * To run a query within a React component, call `useSeoSerpPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoSerpPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoSerpPageDataQuery({
 *   variables: {
 *      term: // value for 'term'
 *      url: // value for 'url'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSeoSerpPageDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoSerpPageDataQuery,
    Types.SeoSerpPageDataQueryVariables
  > &
    (
      | { variables: Types.SeoSerpPageDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoSerpPageDataQuery,
    Types.SeoSerpPageDataQueryVariables
  >(SeoSerpPageDataDocument, options);
}
export function useSeoSerpPageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoSerpPageDataQuery,
    Types.SeoSerpPageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoSerpPageDataQuery,
    Types.SeoSerpPageDataQueryVariables
  >(SeoSerpPageDataDocument, options);
}
export function useSeoSerpPageDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoSerpPageDataQuery,
    Types.SeoSerpPageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoSerpPageDataQuery,
    Types.SeoSerpPageDataQueryVariables
  >(SeoSerpPageDataDocument, options);
}
export type SeoSerpPageDataQueryHookResult = ReturnType<
  typeof useSeoSerpPageDataQuery
>;
export type SeoSerpPageDataLazyQueryHookResult = ReturnType<
  typeof useSeoSerpPageDataLazyQuery
>;
export type SeoSerpPageDataSuspenseQueryHookResult = ReturnType<
  typeof useSeoSerpPageDataSuspenseQuery
>;
export type SeoSerpPageDataQueryResult = Apollo.QueryResult<
  Types.SeoSerpPageDataQuery,
  Types.SeoSerpPageDataQueryVariables
>;
export const GetSeoSerpQuestionsDocument = /*#__PURE__*/ gql`
  query getSeoSerpQuestions(
    $country: Country!
    $language: Language!
    $term: String!
  ) {
    seoSerpQuestions(country: $country, language: $language, term: $term) {
      ...AdWordsItemFields
    }
  }
  ${AdWordsItemFieldsFragmentDoc}
`;

/**
 * __useGetSeoSerpQuestionsQuery__
 *
 * To run a query within a React component, call `useGetSeoSerpQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoSerpQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoSerpQuestionsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetSeoSerpQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSeoSerpQuestionsQuery,
    Types.GetSeoSerpQuestionsQueryVariables
  > &
    (
      | { variables: Types.GetSeoSerpQuestionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetSeoSerpQuestionsQuery,
    Types.GetSeoSerpQuestionsQueryVariables
  >(GetSeoSerpQuestionsDocument, options);
}
export function useGetSeoSerpQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSeoSerpQuestionsQuery,
    Types.GetSeoSerpQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetSeoSerpQuestionsQuery,
    Types.GetSeoSerpQuestionsQueryVariables
  >(GetSeoSerpQuestionsDocument, options);
}
export function useGetSeoSerpQuestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetSeoSerpQuestionsQuery,
    Types.GetSeoSerpQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetSeoSerpQuestionsQuery,
    Types.GetSeoSerpQuestionsQueryVariables
  >(GetSeoSerpQuestionsDocument, options);
}
export type GetSeoSerpQuestionsQueryHookResult = ReturnType<
  typeof useGetSeoSerpQuestionsQuery
>;
export type GetSeoSerpQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetSeoSerpQuestionsLazyQuery
>;
export type GetSeoSerpQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetSeoSerpQuestionsSuspenseQuery
>;
export type GetSeoSerpQuestionsQueryResult = Apollo.QueryResult<
  Types.GetSeoSerpQuestionsQuery,
  Types.GetSeoSerpQuestionsQueryVariables
>;
export const SeoSerpUserIntentDataDocument = /*#__PURE__*/ gql`
  query seoSerpUserIntentData(
    $term: String!
    $url: URL
    $country: Country!
    $language: Language!
  ) {
    seoSerpUserIntentData(
      term: $term
      url: $url
      country: $country
      language: $language
    ) {
      intentData {
        primarySerpIntent
        intentBreakdown {
          infoKnow
          infoKnowSimple
          infoComparison
          transactional
          local
          websiteQuery
        }
      }
      userProvidedPage {
        url
        intent
      }
      organicSerpItemIntents {
        url
        intent
      }
    }
  }
`;

/**
 * __useSeoSerpUserIntentDataQuery__
 *
 * To run a query within a React component, call `useSeoSerpUserIntentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoSerpUserIntentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoSerpUserIntentDataQuery({
 *   variables: {
 *      term: // value for 'term'
 *      url: // value for 'url'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSeoSerpUserIntentDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SeoSerpUserIntentDataQuery,
    Types.SeoSerpUserIntentDataQueryVariables
  > &
    (
      | { variables: Types.SeoSerpUserIntentDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SeoSerpUserIntentDataQuery,
    Types.SeoSerpUserIntentDataQueryVariables
  >(SeoSerpUserIntentDataDocument, options);
}
export function useSeoSerpUserIntentDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SeoSerpUserIntentDataQuery,
    Types.SeoSerpUserIntentDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SeoSerpUserIntentDataQuery,
    Types.SeoSerpUserIntentDataQueryVariables
  >(SeoSerpUserIntentDataDocument, options);
}
export function useSeoSerpUserIntentDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SeoSerpUserIntentDataQuery,
    Types.SeoSerpUserIntentDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SeoSerpUserIntentDataQuery,
    Types.SeoSerpUserIntentDataQueryVariables
  >(SeoSerpUserIntentDataDocument, options);
}
export type SeoSerpUserIntentDataQueryHookResult = ReturnType<
  typeof useSeoSerpUserIntentDataQuery
>;
export type SeoSerpUserIntentDataLazyQueryHookResult = ReturnType<
  typeof useSeoSerpUserIntentDataLazyQuery
>;
export type SeoSerpUserIntentDataSuspenseQueryHookResult = ReturnType<
  typeof useSeoSerpUserIntentDataSuspenseQuery
>;
export type SeoSerpUserIntentDataQueryResult = Apollo.QueryResult<
  Types.SeoSerpUserIntentDataQuery,
  Types.SeoSerpUserIntentDataQueryVariables
>;
export const ShareDocumentAttributesDocument = /*#__PURE__*/ gql`
  query ShareDocumentAttributes($shareId: String!) {
    share(shareId: $shareId) {
      ...ShareFieldsBase
      node {
        ... on Document {
          ...DocumentFields
        }
      }
    }
  }
  ${ShareFieldsBaseFragmentDoc}
  ${DocumentFieldsFragmentDoc}
`;

/**
 * __useShareDocumentAttributesQuery__
 *
 * To run a query within a React component, call `useShareDocumentAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareDocumentAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareDocumentAttributesQuery({
 *   variables: {
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useShareDocumentAttributesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ShareDocumentAttributesQuery,
    Types.ShareDocumentAttributesQueryVariables
  > &
    (
      | {
          variables: Types.ShareDocumentAttributesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ShareDocumentAttributesQuery,
    Types.ShareDocumentAttributesQueryVariables
  >(ShareDocumentAttributesDocument, options);
}
export function useShareDocumentAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ShareDocumentAttributesQuery,
    Types.ShareDocumentAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ShareDocumentAttributesQuery,
    Types.ShareDocumentAttributesQueryVariables
  >(ShareDocumentAttributesDocument, options);
}
export function useShareDocumentAttributesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ShareDocumentAttributesQuery,
    Types.ShareDocumentAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ShareDocumentAttributesQuery,
    Types.ShareDocumentAttributesQueryVariables
  >(ShareDocumentAttributesDocument, options);
}
export type ShareDocumentAttributesQueryHookResult = ReturnType<
  typeof useShareDocumentAttributesQuery
>;
export type ShareDocumentAttributesLazyQueryHookResult = ReturnType<
  typeof useShareDocumentAttributesLazyQuery
>;
export type ShareDocumentAttributesSuspenseQueryHookResult = ReturnType<
  typeof useShareDocumentAttributesSuspenseQuery
>;
export type ShareDocumentAttributesQueryResult = Apollo.QueryResult<
  Types.ShareDocumentAttributesQuery,
  Types.ShareDocumentAttributesQueryVariables
>;
export const ShareDocumentStorageDataDocument = /*#__PURE__*/ gql`
  query ShareDocumentStorageData($shareId: String!) {
    share(shareId: $shareId) {
      ...ShareFieldsBase
      node {
        ... on Document {
          ...DocumentStorageData
        }
      }
    }
  }
  ${ShareFieldsBaseFragmentDoc}
  ${DocumentStorageDataFragmentDoc}
`;

/**
 * __useShareDocumentStorageDataQuery__
 *
 * To run a query within a React component, call `useShareDocumentStorageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareDocumentStorageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareDocumentStorageDataQuery({
 *   variables: {
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useShareDocumentStorageDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ShareDocumentStorageDataQuery,
    Types.ShareDocumentStorageDataQueryVariables
  > &
    (
      | {
          variables: Types.ShareDocumentStorageDataQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ShareDocumentStorageDataQuery,
    Types.ShareDocumentStorageDataQueryVariables
  >(ShareDocumentStorageDataDocument, options);
}
export function useShareDocumentStorageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ShareDocumentStorageDataQuery,
    Types.ShareDocumentStorageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ShareDocumentStorageDataQuery,
    Types.ShareDocumentStorageDataQueryVariables
  >(ShareDocumentStorageDataDocument, options);
}
export function useShareDocumentStorageDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ShareDocumentStorageDataQuery,
    Types.ShareDocumentStorageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ShareDocumentStorageDataQuery,
    Types.ShareDocumentStorageDataQueryVariables
  >(ShareDocumentStorageDataDocument, options);
}
export type ShareDocumentStorageDataQueryHookResult = ReturnType<
  typeof useShareDocumentStorageDataQuery
>;
export type ShareDocumentStorageDataLazyQueryHookResult = ReturnType<
  typeof useShareDocumentStorageDataLazyQuery
>;
export type ShareDocumentStorageDataSuspenseQueryHookResult = ReturnType<
  typeof useShareDocumentStorageDataSuspenseQuery
>;
export type ShareDocumentStorageDataQueryResult = Apollo.QueryResult<
  Types.ShareDocumentStorageDataQuery,
  Types.ShareDocumentStorageDataQueryVariables
>;
export const SharePreliminaryDocument = /*#__PURE__*/ gql`
  query SharePreliminary($shareId: String!) {
    sharePermissions(shareId: $shareId) {
      ...PermissionFields
    }
    share(shareId: $shareId) {
      ...ShareFieldsBase
      node {
        ... on Document {
          title
        }
      }
    }
  }
  ${PermissionFieldsFragmentDoc}
  ${ShareFieldsBaseFragmentDoc}
`;

/**
 * __useSharePreliminaryQuery__
 *
 * To run a query within a React component, call `useSharePreliminaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharePreliminaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharePreliminaryQuery({
 *   variables: {
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useSharePreliminaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SharePreliminaryQuery,
    Types.SharePreliminaryQueryVariables
  > &
    (
      | { variables: Types.SharePreliminaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SharePreliminaryQuery,
    Types.SharePreliminaryQueryVariables
  >(SharePreliminaryDocument, options);
}
export function useSharePreliminaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SharePreliminaryQuery,
    Types.SharePreliminaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SharePreliminaryQuery,
    Types.SharePreliminaryQueryVariables
  >(SharePreliminaryDocument, options);
}
export function useSharePreliminarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SharePreliminaryQuery,
    Types.SharePreliminaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SharePreliminaryQuery,
    Types.SharePreliminaryQueryVariables
  >(SharePreliminaryDocument, options);
}
export type SharePreliminaryQueryHookResult = ReturnType<
  typeof useSharePreliminaryQuery
>;
export type SharePreliminaryLazyQueryHookResult = ReturnType<
  typeof useSharePreliminaryLazyQuery
>;
export type SharePreliminarySuspenseQueryHookResult = ReturnType<
  typeof useSharePreliminarySuspenseQuery
>;
export type SharePreliminaryQueryResult = Apollo.QueryResult<
  Types.SharePreliminaryQuery,
  Types.SharePreliminaryQueryVariables
>;
export const SignInDocument = /*#__PURE__*/ gql`
  query SignIn($email: String!, $siteId: String) {
    signIn(email: $email, siteId: $siteId) {
      user {
        ...UserFields
      }
      org {
        ...OrganizationFields
        sites {
          ...SiteFieldsAll
        }
        users {
          ...UserFieldsBase
          orgRole
          suspended
        }
        maxUsers
        documentAllotment {
          ...DocumentsAllotmentFields
        }
      }
      site {
        ...SiteFieldsAll
      }
      subscription {
        ...SubscriptionEntityFields
      }
      permissions {
        ...PermissionFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${OrganizationFieldsFragmentDoc}
  ${SiteFieldsAllFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
  ${DocumentsAllotmentFieldsFragmentDoc}
  ${SubscriptionEntityFieldsFragmentDoc}
  ${PermissionFieldsFragmentDoc}
`;

/**
 * __useSignInQuery__
 *
 * To run a query within a React component, call `useSignInQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignInQuery({
 *   variables: {
 *      email: // value for 'email'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSignInQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SignInQuery,
    Types.SignInQueryVariables
  > &
    (
      | { variables: Types.SignInQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.SignInQuery, Types.SignInQueryVariables>(
    SignInDocument,
    options,
  );
}
export function useSignInLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SignInQuery,
    Types.SignInQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.SignInQuery, Types.SignInQueryVariables>(
    SignInDocument,
    options,
  );
}
export function useSignInSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SignInQuery,
    Types.SignInQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.SignInQuery, Types.SignInQueryVariables>(
    SignInDocument,
    options,
  );
}
export type SignInQueryHookResult = ReturnType<typeof useSignInQuery>;
export type SignInLazyQueryHookResult = ReturnType<typeof useSignInLazyQuery>;
export type SignInSuspenseQueryHookResult = ReturnType<
  typeof useSignInSuspenseQuery
>;
export type SignInQueryResult = Apollo.QueryResult<
  Types.SignInQuery,
  Types.SignInQueryVariables
>;
export const SignProsperStackPayloadDocument = /*#__PURE__*/ gql`
  query SignProsperStackPayload($payload: String!) {
    signProsperStackPayload(payload: $payload)
  }
`;

/**
 * __useSignProsperStackPayloadQuery__
 *
 * To run a query within a React component, call `useSignProsperStackPayloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignProsperStackPayloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignProsperStackPayloadQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSignProsperStackPayloadQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SignProsperStackPayloadQuery,
    Types.SignProsperStackPayloadQueryVariables
  > &
    (
      | {
          variables: Types.SignProsperStackPayloadQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SignProsperStackPayloadQuery,
    Types.SignProsperStackPayloadQueryVariables
  >(SignProsperStackPayloadDocument, options);
}
export function useSignProsperStackPayloadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SignProsperStackPayloadQuery,
    Types.SignProsperStackPayloadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SignProsperStackPayloadQuery,
    Types.SignProsperStackPayloadQueryVariables
  >(SignProsperStackPayloadDocument, options);
}
export function useSignProsperStackPayloadSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SignProsperStackPayloadQuery,
    Types.SignProsperStackPayloadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SignProsperStackPayloadQuery,
    Types.SignProsperStackPayloadQueryVariables
  >(SignProsperStackPayloadDocument, options);
}
export type SignProsperStackPayloadQueryHookResult = ReturnType<
  typeof useSignProsperStackPayloadQuery
>;
export type SignProsperStackPayloadLazyQueryHookResult = ReturnType<
  typeof useSignProsperStackPayloadLazyQuery
>;
export type SignProsperStackPayloadSuspenseQueryHookResult = ReturnType<
  typeof useSignProsperStackPayloadSuspenseQuery
>;
export type SignProsperStackPayloadQueryResult = Apollo.QueryResult<
  Types.SignProsperStackPayloadQuery,
  Types.SignProsperStackPayloadQueryVariables
>;
export const SiteDocument = /*#__PURE__*/ gql`
  query Site($id: String!) {
    site(id: $id) {
      ...SiteFieldsAll
    }
  }
  ${SiteFieldsAllFragmentDoc}
`;

/**
 * __useSiteQuery__
 *
 * To run a query within a React component, call `useSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SiteQuery,
    Types.SiteQueryVariables
  > &
    (
      | { variables: Types.SiteQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.SiteQuery, Types.SiteQueryVariables>(
    SiteDocument,
    options,
  );
}
export function useSiteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SiteQuery,
    Types.SiteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.SiteQuery, Types.SiteQueryVariables>(
    SiteDocument,
    options,
  );
}
export function useSiteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SiteQuery,
    Types.SiteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.SiteQuery, Types.SiteQueryVariables>(
    SiteDocument,
    options,
  );
}
export type SiteQueryHookResult = ReturnType<typeof useSiteQuery>;
export type SiteLazyQueryHookResult = ReturnType<typeof useSiteLazyQuery>;
export type SiteSuspenseQueryHookResult = ReturnType<
  typeof useSiteSuspenseQuery
>;
export type SiteQueryResult = Apollo.QueryResult<
  Types.SiteQuery,
  Types.SiteQueryVariables
>;
export const SiteAggregateAppRunsDocument = /*#__PURE__*/ gql`
  query SiteAggregateAppRuns($siteId: String!) {
    siteAggregateStats(siteId: $siteId) {
      appRuns {
        ...AppRunsFields
      }
    }
  }
  ${AppRunsFieldsFragmentDoc}
`;

/**
 * __useSiteAggregateAppRunsQuery__
 *
 * To run a query within a React component, call `useSiteAggregateAppRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAggregateAppRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAggregateAppRunsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteAggregateAppRunsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SiteAggregateAppRunsQuery,
    Types.SiteAggregateAppRunsQueryVariables
  > &
    (
      | { variables: Types.SiteAggregateAppRunsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SiteAggregateAppRunsQuery,
    Types.SiteAggregateAppRunsQueryVariables
  >(SiteAggregateAppRunsDocument, options);
}
export function useSiteAggregateAppRunsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SiteAggregateAppRunsQuery,
    Types.SiteAggregateAppRunsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SiteAggregateAppRunsQuery,
    Types.SiteAggregateAppRunsQueryVariables
  >(SiteAggregateAppRunsDocument, options);
}
export function useSiteAggregateAppRunsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SiteAggregateAppRunsQuery,
    Types.SiteAggregateAppRunsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SiteAggregateAppRunsQuery,
    Types.SiteAggregateAppRunsQueryVariables
  >(SiteAggregateAppRunsDocument, options);
}
export type SiteAggregateAppRunsQueryHookResult = ReturnType<
  typeof useSiteAggregateAppRunsQuery
>;
export type SiteAggregateAppRunsLazyQueryHookResult = ReturnType<
  typeof useSiteAggregateAppRunsLazyQuery
>;
export type SiteAggregateAppRunsSuspenseQueryHookResult = ReturnType<
  typeof useSiteAggregateAppRunsSuspenseQuery
>;
export type SiteAggregateAppRunsQueryResult = Apollo.QueryResult<
  Types.SiteAggregateAppRunsQuery,
  Types.SiteAggregateAppRunsQueryVariables
>;
export const SiteAggregateStatsDocument = /*#__PURE__*/ gql`
  query SiteAggregateStats($siteId: String!) {
    siteAggregateStats(siteId: $siteId) {
      topicsAll
      pagesAll
      pageTopicsAll
      appRuns {
        ...AppRunsFields
      }
    }
  }
  ${AppRunsFieldsFragmentDoc}
`;

/**
 * __useSiteAggregateStatsQuery__
 *
 * To run a query within a React component, call `useSiteAggregateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAggregateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAggregateStatsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteAggregateStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SiteAggregateStatsQuery,
    Types.SiteAggregateStatsQueryVariables
  > &
    (
      | { variables: Types.SiteAggregateStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SiteAggregateStatsQuery,
    Types.SiteAggregateStatsQueryVariables
  >(SiteAggregateStatsDocument, options);
}
export function useSiteAggregateStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SiteAggregateStatsQuery,
    Types.SiteAggregateStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SiteAggregateStatsQuery,
    Types.SiteAggregateStatsQueryVariables
  >(SiteAggregateStatsDocument, options);
}
export function useSiteAggregateStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SiteAggregateStatsQuery,
    Types.SiteAggregateStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SiteAggregateStatsQuery,
    Types.SiteAggregateStatsQueryVariables
  >(SiteAggregateStatsDocument, options);
}
export type SiteAggregateStatsQueryHookResult = ReturnType<
  typeof useSiteAggregateStatsQuery
>;
export type SiteAggregateStatsLazyQueryHookResult = ReturnType<
  typeof useSiteAggregateStatsLazyQuery
>;
export type SiteAggregateStatsSuspenseQueryHookResult = ReturnType<
  typeof useSiteAggregateStatsSuspenseQuery
>;
export type SiteAggregateStatsQueryResult = Apollo.QueryResult<
  Types.SiteAggregateStatsQuery,
  Types.SiteAggregateStatsQueryVariables
>;
export const SiteRecommendedTopicsDocument = /*#__PURE__*/ gql`
  query SiteRecommendedTopics($domain: String!, $country: Country!) {
    siteRecommendedTopics(domain: $domain, country: $country) {
      topicCount
    }
  }
`;

/**
 * __useSiteRecommendedTopicsQuery__
 *
 * To run a query within a React component, call `useSiteRecommendedTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteRecommendedTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteRecommendedTopicsQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSiteRecommendedTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SiteRecommendedTopicsQuery,
    Types.SiteRecommendedTopicsQueryVariables
  > &
    (
      | { variables: Types.SiteRecommendedTopicsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SiteRecommendedTopicsQuery,
    Types.SiteRecommendedTopicsQueryVariables
  >(SiteRecommendedTopicsDocument, options);
}
export function useSiteRecommendedTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SiteRecommendedTopicsQuery,
    Types.SiteRecommendedTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SiteRecommendedTopicsQuery,
    Types.SiteRecommendedTopicsQueryVariables
  >(SiteRecommendedTopicsDocument, options);
}
export function useSiteRecommendedTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SiteRecommendedTopicsQuery,
    Types.SiteRecommendedTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SiteRecommendedTopicsQuery,
    Types.SiteRecommendedTopicsQueryVariables
  >(SiteRecommendedTopicsDocument, options);
}
export type SiteRecommendedTopicsQueryHookResult = ReturnType<
  typeof useSiteRecommendedTopicsQuery
>;
export type SiteRecommendedTopicsLazyQueryHookResult = ReturnType<
  typeof useSiteRecommendedTopicsLazyQuery
>;
export type SiteRecommendedTopicsSuspenseQueryHookResult = ReturnType<
  typeof useSiteRecommendedTopicsSuspenseQuery
>;
export type SiteRecommendedTopicsQueryResult = Apollo.QueryResult<
  Types.SiteRecommendedTopicsQuery,
  Types.SiteRecommendedTopicsQueryVariables
>;
export const SubscriptionDocument = /*#__PURE__*/ gql`
  query Subscription($subscriptionId: String!) {
    subscription(subscriptionId: $subscriptionId) {
      ...SubscriptionEntityFields
    }
  }
  ${SubscriptionEntityFieldsFragmentDoc}
`;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SubscriptionQuery,
    Types.SubscriptionQueryVariables
  > &
    (
      | { variables: Types.SubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SubscriptionQuery,
    Types.SubscriptionQueryVariables
  >(SubscriptionDocument, options);
}
export function useSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SubscriptionQuery,
    Types.SubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SubscriptionQuery,
    Types.SubscriptionQueryVariables
  >(SubscriptionDocument, options);
}
export function useSubscriptionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SubscriptionQuery,
    Types.SubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SubscriptionQuery,
    Types.SubscriptionQueryVariables
  >(SubscriptionDocument, options);
}
export type SubscriptionQueryHookResult = ReturnType<
  typeof useSubscriptionQuery
>;
export type SubscriptionLazyQueryHookResult = ReturnType<
  typeof useSubscriptionLazyQuery
>;
export type SubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionSuspenseQuery
>;
export type SubscriptionQueryResult = Apollo.QueryResult<
  Types.SubscriptionQuery,
  Types.SubscriptionQueryVariables
>;
export const SubscriptionAddonTypesAvailableDocument = /*#__PURE__*/ gql`
  query SubscriptionAddonTypesAvailable(
    $filters: [SubscriptionAddonTypesAvailableFilter!]
    $sort: [SortField!]
    $limit: Int
    $page: Int
  ) {
    subscriptionAddonTypesAvailable(
      filters: $filters
      sort: $sort
      limit: $limit
      page: $page
    ) {
      count
      items {
        ...SubscriptionAddonTypeFields
      }
    }
  }
  ${SubscriptionAddonTypeFieldsFragmentDoc}
`;

/**
 * __useSubscriptionAddonTypesAvailableQuery__
 *
 * To run a query within a React component, call `useSubscriptionAddonTypesAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAddonTypesAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionAddonTypesAvailableQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSubscriptionAddonTypesAvailableQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.SubscriptionAddonTypesAvailableQuery,
    Types.SubscriptionAddonTypesAvailableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SubscriptionAddonTypesAvailableQuery,
    Types.SubscriptionAddonTypesAvailableQueryVariables
  >(SubscriptionAddonTypesAvailableDocument, options);
}
export function useSubscriptionAddonTypesAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SubscriptionAddonTypesAvailableQuery,
    Types.SubscriptionAddonTypesAvailableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SubscriptionAddonTypesAvailableQuery,
    Types.SubscriptionAddonTypesAvailableQueryVariables
  >(SubscriptionAddonTypesAvailableDocument, options);
}
export function useSubscriptionAddonTypesAvailableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SubscriptionAddonTypesAvailableQuery,
    Types.SubscriptionAddonTypesAvailableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SubscriptionAddonTypesAvailableQuery,
    Types.SubscriptionAddonTypesAvailableQueryVariables
  >(SubscriptionAddonTypesAvailableDocument, options);
}
export type SubscriptionAddonTypesAvailableQueryHookResult = ReturnType<
  typeof useSubscriptionAddonTypesAvailableQuery
>;
export type SubscriptionAddonTypesAvailableLazyQueryHookResult = ReturnType<
  typeof useSubscriptionAddonTypesAvailableLazyQuery
>;
export type SubscriptionAddonTypesAvailableSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionAddonTypesAvailableSuspenseQuery
>;
export type SubscriptionAddonTypesAvailableQueryResult = Apollo.QueryResult<
  Types.SubscriptionAddonTypesAvailableQuery,
  Types.SubscriptionAddonTypesAvailableQueryVariables
>;
export const SubscriptionPlansDocument = /*#__PURE__*/ gql`
  query SubscriptionPlans(
    $filters: [SubscriptionPlanFilter!]
    $sort: [SortField!]
    $limit: Int
    $page: Int
  ) {
    subscriptionPlans(
      filters: $filters
      sort: $sort
      limit: $limit
      page: $page
    ) {
      count
      items {
        ...SubscriptionPlanFields
      }
    }
  }
  ${SubscriptionPlanFieldsFragmentDoc}
`;

/**
 * __useSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPlansQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSubscriptionPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.SubscriptionPlansQuery,
    Types.SubscriptionPlansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SubscriptionPlansQuery,
    Types.SubscriptionPlansQueryVariables
  >(SubscriptionPlansDocument, options);
}
export function useSubscriptionPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SubscriptionPlansQuery,
    Types.SubscriptionPlansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SubscriptionPlansQuery,
    Types.SubscriptionPlansQueryVariables
  >(SubscriptionPlansDocument, options);
}
export function useSubscriptionPlansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SubscriptionPlansQuery,
    Types.SubscriptionPlansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SubscriptionPlansQuery,
    Types.SubscriptionPlansQueryVariables
  >(SubscriptionPlansDocument, options);
}
export type SubscriptionPlansQueryHookResult = ReturnType<
  typeof useSubscriptionPlansQuery
>;
export type SubscriptionPlansLazyQueryHookResult = ReturnType<
  typeof useSubscriptionPlansLazyQuery
>;
export type SubscriptionPlansSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionPlansSuspenseQuery
>;
export type SubscriptionPlansQueryResult = Apollo.QueryResult<
  Types.SubscriptionPlansQuery,
  Types.SubscriptionPlansQueryVariables
>;
export const SubscriptionRenewalInvoicePreviewDocument = /*#__PURE__*/ gql`
  query SubscriptionRenewalInvoicePreview($orgId: String) {
    subscriptionRenewalInvoicePreview(orgId: $orgId) {
      ...RecurlyInvoiceCollectionFields
    }
  }
  ${RecurlyInvoiceCollectionFieldsFragmentDoc}
`;

/**
 * __useSubscriptionRenewalInvoicePreviewQuery__
 *
 * To run a query within a React component, call `useSubscriptionRenewalInvoicePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionRenewalInvoicePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionRenewalInvoicePreviewQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useSubscriptionRenewalInvoicePreviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.SubscriptionRenewalInvoicePreviewQuery,
    Types.SubscriptionRenewalInvoicePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SubscriptionRenewalInvoicePreviewQuery,
    Types.SubscriptionRenewalInvoicePreviewQueryVariables
  >(SubscriptionRenewalInvoicePreviewDocument, options);
}
export function useSubscriptionRenewalInvoicePreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SubscriptionRenewalInvoicePreviewQuery,
    Types.SubscriptionRenewalInvoicePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SubscriptionRenewalInvoicePreviewQuery,
    Types.SubscriptionRenewalInvoicePreviewQueryVariables
  >(SubscriptionRenewalInvoicePreviewDocument, options);
}
export function useSubscriptionRenewalInvoicePreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.SubscriptionRenewalInvoicePreviewQuery,
    Types.SubscriptionRenewalInvoicePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.SubscriptionRenewalInvoicePreviewQuery,
    Types.SubscriptionRenewalInvoicePreviewQueryVariables
  >(SubscriptionRenewalInvoicePreviewDocument, options);
}
export type SubscriptionRenewalInvoicePreviewQueryHookResult = ReturnType<
  typeof useSubscriptionRenewalInvoicePreviewQuery
>;
export type SubscriptionRenewalInvoicePreviewLazyQueryHookResult = ReturnType<
  typeof useSubscriptionRenewalInvoicePreviewLazyQuery
>;
export type SubscriptionRenewalInvoicePreviewSuspenseQueryHookResult =
  ReturnType<typeof useSubscriptionRenewalInvoicePreviewSuspenseQuery>;
export type SubscriptionRenewalInvoicePreviewQueryResult = Apollo.QueryResult<
  Types.SubscriptionRenewalInvoicePreviewQuery,
  Types.SubscriptionRenewalInvoicePreviewQueryVariables
>;
export const TagsPrimaryAttributesDocument = /*#__PURE__*/ gql`
  query TagsPrimaryAttributes(
    $filters: [TagFilter!]
    $sort: [SortField!]
    $limit: Int
    $page: Int
  ) {
    tags(filters: $filters, sort: $sort, limit: $limit, page: $page) {
      count
      items {
        ...TagFieldsBase
      }
    }
  }
  ${TagFieldsBaseFragmentDoc}
`;

/**
 * __useTagsPrimaryAttributesQuery__
 *
 * To run a query within a React component, call `useTagsPrimaryAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsPrimaryAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsPrimaryAttributesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTagsPrimaryAttributesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.TagsPrimaryAttributesQuery,
    Types.TagsPrimaryAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.TagsPrimaryAttributesQuery,
    Types.TagsPrimaryAttributesQueryVariables
  >(TagsPrimaryAttributesDocument, options);
}
export function useTagsPrimaryAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TagsPrimaryAttributesQuery,
    Types.TagsPrimaryAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.TagsPrimaryAttributesQuery,
    Types.TagsPrimaryAttributesQueryVariables
  >(TagsPrimaryAttributesDocument, options);
}
export function useTagsPrimaryAttributesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.TagsPrimaryAttributesQuery,
    Types.TagsPrimaryAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.TagsPrimaryAttributesQuery,
    Types.TagsPrimaryAttributesQueryVariables
  >(TagsPrimaryAttributesDocument, options);
}
export type TagsPrimaryAttributesQueryHookResult = ReturnType<
  typeof useTagsPrimaryAttributesQuery
>;
export type TagsPrimaryAttributesLazyQueryHookResult = ReturnType<
  typeof useTagsPrimaryAttributesLazyQuery
>;
export type TagsPrimaryAttributesSuspenseQueryHookResult = ReturnType<
  typeof useTagsPrimaryAttributesSuspenseQuery
>;
export type TagsPrimaryAttributesQueryResult = Apollo.QueryResult<
  Types.TagsPrimaryAttributesQuery,
  Types.TagsPrimaryAttributesQueryVariables
>;
export const TagsDocument = /*#__PURE__*/ gql`
  query Tags(
    $filters: [TagFilter!]
    $sort: [SortField!]
    $limit: Int
    $page: Int
  ) {
    tags(filters: $filters, sort: $sort, limit: $limit, page: $page) {
      count
      items {
        createdAt
        updatedAt
        id
        title
        terms
        urls
        urlTerms {
          url
          term
        }
        documents {
          id
        }
        createdBy {
          ...UserFieldsBase
        }
        updatedBy {
          ...UserFieldsBase
        }
        site {
          ...SiteFieldsBase
        }
      }
    }
  }
  ${UserFieldsBaseFragmentDoc}
  ${SiteFieldsBaseFragmentDoc}
`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.TagsQuery,
    Types.TagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.TagsQuery, Types.TagsQueryVariables>(
    TagsDocument,
    options,
  );
}
export function useTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TagsQuery,
    Types.TagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.TagsQuery, Types.TagsQueryVariables>(
    TagsDocument,
    options,
  );
}
export function useTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.TagsQuery,
    Types.TagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.TagsQuery, Types.TagsQueryVariables>(
    TagsDocument,
    options,
  );
}
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<
  typeof useTagsSuspenseQuery
>;
export type TagsQueryResult = Apollo.QueryResult<
  Types.TagsQuery,
  Types.TagsQueryVariables
>;
export const GetUserDocument = /*#__PURE__*/ gql`
  query GetUser($email: String, $id: String) {
    user(email: $email, id: $id) {
      ...UserFields
      org {
        ...OrganizationFieldsBase
        recurlyAccountCode
        recurlyAccountCodeTest
        sites {
          ...SiteFields
          appSumoCodes
        }
        users {
          ...UserFieldsBase
        }
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${OrganizationFieldsBaseFragmentDoc}
  ${SiteFieldsFragmentDoc}
  ${UserFieldsBaseFragmentDoc}
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetUserQuery,
    Types.GetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetUserQuery, Types.GetUserQueryVariables>(
    GetUserDocument,
    options,
  );
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetUserQuery,
    Types.GetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetUserQuery, Types.GetUserQueryVariables>(
    GetUserDocument,
    options,
  );
}
export function useGetUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetUserQuery,
    Types.GetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetUserQuery,
    Types.GetUserQueryVariables
  >(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<
  typeof useGetUserSuspenseQuery
>;
export type GetUserQueryResult = Apollo.QueryResult<
  Types.GetUserQuery,
  Types.GetUserQueryVariables
>;
export const GhostAsUserDocument = /*#__PURE__*/ gql`
  query GhostAsUser($id: String, $orgId: String) {
    user(id: $id) {
      ...UserFields
      org {
        ...OrganizationFields
        recurlyAccountCode
        recurlyAccountCodeTest
        sites {
          ...SiteFieldsAll
          appSumoCodes
        }
        users {
          ...UserFields
        }
        maxUsers
        subscription {
          ...SubscriptionEntityFields
        }
        documentAllotment {
          ...DocumentsAllotmentFields
        }
      }
    }
    subscriptionRenewalInvoicePreview(orgId: $orgId) {
      ...RecurlyInvoiceCollectionFields
    }
  }
  ${UserFieldsFragmentDoc}
  ${OrganizationFieldsFragmentDoc}
  ${SiteFieldsAllFragmentDoc}
  ${SubscriptionEntityFieldsFragmentDoc}
  ${DocumentsAllotmentFieldsFragmentDoc}
  ${RecurlyInvoiceCollectionFieldsFragmentDoc}
`;

/**
 * __useGhostAsUserQuery__
 *
 * To run a query within a React component, call `useGhostAsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhostAsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhostAsUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGhostAsUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GhostAsUserQuery,
    Types.GhostAsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GhostAsUserQuery,
    Types.GhostAsUserQueryVariables
  >(GhostAsUserDocument, options);
}
export function useGhostAsUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GhostAsUserQuery,
    Types.GhostAsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GhostAsUserQuery,
    Types.GhostAsUserQueryVariables
  >(GhostAsUserDocument, options);
}
export function useGhostAsUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GhostAsUserQuery,
    Types.GhostAsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GhostAsUserQuery,
    Types.GhostAsUserQueryVariables
  >(GhostAsUserDocument, options);
}
export type GhostAsUserQueryHookResult = ReturnType<typeof useGhostAsUserQuery>;
export type GhostAsUserLazyQueryHookResult = ReturnType<
  typeof useGhostAsUserLazyQuery
>;
export type GhostAsUserSuspenseQueryHookResult = ReturnType<
  typeof useGhostAsUserSuspenseQuery
>;
export type GhostAsUserQueryResult = Apollo.QueryResult<
  Types.GhostAsUserQuery,
  Types.GhostAsUserQueryVariables
>;
export const GetUsersDocument = /*#__PURE__*/ gql`
  query GetUsers(
    $filters: [UserFilter!]
    $limit: Int
    $order: String
    $page: Int
  ) {
    users(filters: $filters, limit: $limit, order: $order, page: $page) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetUsersQuery,
    Types.GetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetUsersQuery,
    Types.GetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.GetUsersQuery,
    Types.GetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetUsersQuery,
    Types.GetUsersQueryVariables
  >(GetUsersDocument, options);
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetUsersSuspenseQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  Types.GetUsersQuery,
  Types.GetUsersQueryVariables
>;
export const ValidateEmailDocument = /*#__PURE__*/ gql`
  query ValidateEmail($email: String!) {
    validateEmail(email: $email) {
      valid
      exists
      allowedDomain
      formatValid
      message
    }
  }
`;

/**
 * __useValidateEmailQuery__
 *
 * To run a query within a React component, call `useValidateEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidateEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ValidateEmailQuery,
    Types.ValidateEmailQueryVariables
  > &
    (
      | { variables: Types.ValidateEmailQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ValidateEmailQuery,
    Types.ValidateEmailQueryVariables
  >(ValidateEmailDocument, options);
}
export function useValidateEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ValidateEmailQuery,
    Types.ValidateEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ValidateEmailQuery,
    Types.ValidateEmailQueryVariables
  >(ValidateEmailDocument, options);
}
export function useValidateEmailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Types.ValidateEmailQuery,
    Types.ValidateEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ValidateEmailQuery,
    Types.ValidateEmailQueryVariables
  >(ValidateEmailDocument, options);
}
export type ValidateEmailQueryHookResult = ReturnType<
  typeof useValidateEmailQuery
>;
export type ValidateEmailLazyQueryHookResult = ReturnType<
  typeof useValidateEmailLazyQuery
>;
export type ValidateEmailSuspenseQueryHookResult = ReturnType<
  typeof useValidateEmailSuspenseQuery
>;
export type ValidateEmailQueryResult = Apollo.QueryResult<
  Types.ValidateEmailQuery,
  Types.ValidateEmailQueryVariables
>;
